// Voucher Posting Dialog Component
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api.service';
import { FileShowModalComponent } from 'app/file-show-modal/file-show-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { CreateVoucherPostingViewComponent } from 'app/create-voucher-posting-view/create-voucher-posting-view.component';
import { CreateProductEditDialogComponent } from 'app/create-product-edit-dialog/create-product-edit-dialog.component';
import { CreateProductViewDialogComponent } from 'app/create-product-view-dialog/create-product-view-dialog.component';
import { forkJoin ,of} from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { VoucherFileModalComponent } from 'app/voucher-file-modal/voucher-file-modal.component';
import { AdminService } from 'app/admin.service';
import { MatSelect } from '@angular/material/select';
import { ViewChild } from '@angular/core';

import { ApprovalTimelineDialogComponent } from 'app/components/approval-timeline/approval-timeline-dialog.component';
import { ApprovalTimelineData } from 'app/components/approval-timeline/approval-timeline.component';
import { HsnGstEditComponent } from '../hsn-gst-edit/hsn-gst-edit.component';
// import { response } from 'express';
declare var require: any;
import { StatementViewComponent } from 'app/statement-view/statement-view.component';
import { LedgerBookComponent } from 'app/ledger-book/ledger-book.component';
import { CreditNoteVoucherComponent } from 'app/credit-note-voucher/credit-note-voucher.component';
import { DebitNoteVoucherComponent } from 'app/debit-note-voucher/debit-note-voucher.component';
import { SalesVoucherComponent } from 'app/sales-voucher/sales-voucher.component';
import { PurchaseVoucherComponent } from 'app/purchase-voucher/purchase-voucher.component';
import { UI_DOCUMENT_PANEL_DIALOG_CONFIG } from 'app/shared/ui/document-panel/document-panel.config';
@Component({
  selector: 'app-create-voucher-posting-dialog',
  templateUrl: './create-voucher-posting-dialog.component.html',
  styleUrls: ['./create-voucher-posting-dialog.component.scss']
})
export class CreateVoucherPostingDialogComponent {
  voucherType: any;
  branch: any;
  branchdata: any = [];
  vouchers: any[] = [];

  debitLedgerType: any;
  debitAmount: number;
  debitDescription: string;
  debitsides: any[] = [{
    debitLedgerType: null,
    debitAmount: null,
    debitDescription: null
  }];
  creditLedgerType: any;
  creditAmount: number;
  creditDescription: string;
  creditsides: any[] = [{
    debitLedgerType: null,
    debitAmount: null,
    debitDescription: null
  }];
  narration: string;
  ledger: any;
  voucherNo: any;
  date: any;
  totaldr: any;
  totalcr: any;
  file: File | null = null;
  showDeleteIcon: boolean = false;
  operationType: any;
  base64File:any[]=[] ;
  postData: any = {};
  myFiles:string [] = [];
  files: File[] = [];
  //updateItems: boolean = false;
  imageUrls: any[] = [];
  documentUrls: any[] = [];
  test:boolean=true;
  fromBranch = [];
  toBranch: any;
  branch_id: any;
  role_id: any;
  showDesign: boolean;
  showinterbranch: boolean;
  // drbranch = [];
  // crbranch = [];
  // rounded_ledger:any;
  showPurchesDesign: boolean;
  showPurches: boolean;
  showInter: boolean;
  vendorData: any;
  productEntries: any[] = [];
  product = [];
  tax: any[] = [];
 // selectedProductType: number = null;
  hsn_no: number = null;
  document_no: number = null;
  selectedDescription: string = '';
  unit: string = '';
  selectedQty: number = null;
  selectedUnitPrice: number = null;
  selectedDiscount: number = null;
  selectedTaxType: number = null;
  totalAmount: number = null;
  ledger_name: string;
  ledger_id:any;
  vendor: any;
  debitEntries: any[] = [];
  creditEntries: any[] = [];
  details: any[] = [];
  purchesnarration:string;
  roundedamount: number;
  issue_date:any;
 // productId:any;
  customerData: any;
  isPurchase: boolean;
  isSales: boolean;
  customer: any;
  customer_name :string;
  customer_email:string;
  customer_phone :string;
  customer_address :string;
  customer_gstno :string;
  customer_pan :string;
  company_name:string;
  company_email :string;
  company_phone :string;
  company_address :string;
  company_gstno :string;
  company_pan :string;
  company_logo:string;
  company_signature:string;
  hostname: string;
  branch_access_list:any;
  purchaseInvoice:any;
  isChecked: boolean = false; 
  voucher: any[] = [];
  selectedGrn: any[] = [];
  grn: any[] = [];
  productList: any[] = [];
  vendor_branch_id: any;
  sku = [];
  // isUpdateMode:boolean= false; 
  roundedamount2: number;
  gst_ledger: any;
  selectedGsn: any[] = [];
  gsn: any[] = [];
  customer_branch_id:any;
  purchase_invoice:any[];
  //pi_id: any;
  //totalCreditValue:any;
  sales_invoice:any[];
  credit_note:any[];
  debit_note:any[];
 // si_id: any;
  voucher_data:any;
  voucher_type:any;
  service = [];
  combinedDropdownData: any[] = [];
  selectedItem: any = null;
  searchDrText: string = '';
  searchCrText: string = '';
  filteredDrLedgers: any[] = [];
  filteredCrLedgers: any[] = [];
  fullhostname:any;
  showadvDesign:any;
  showadvinterbranch:boolean;
  mismatchedSerialNo: string[] = [];
  vendorBranchData: any[];
  selectedVendorBranch: any;
  customerBranchData: any[];
  selectedCustomerBranch: any;
  customerBranchdetails:any;
  GstLedger:any[];
  vendor_name :string;
  vendor_email:string;
  vendor_phone :string;
  vendor_address :string;
  vendor_gstno :string;
  vendor_pan :string;
  isUpdate:boolean= false; 
  invoice_type:any;
  type: any;
  selectedSection: any;
  sectionData: any;
  section_id:any;
  selectedPiSection: any[];
  all_section_data: any[] = [];
  rofitcost_id: any;
  profitCostData: any[] = [];
  store_data: any = [];
  section_data: any[] = [];
  branch_data: any = [];
  profitcost_id: any;
  store_id: any;
  ProfitCostData: any = [];
  sectionProfitCostMap: { [sectionId: number]: number } = {};
  selectQty: number = null;
  selectedPrice: number = null;
  price_policy:number;
  selectedSkuId: number[] = [];
  tableSkus: any[] = []; 
  inv_branch: any;
  maxDate: string = '';
  uploadedFiles: any[] = [];
  image_data: any;
  rounded_ledger_data:any;
  profit_cost_data: any[] = [];
  profit_cost_id:any;
  filteredSections:any;
  profit_cost:any[] = [];
  employee_data: any[] = [];
  inv_section_id:any
  fa_details: any[] = [];
  fa_master: any
  cgst: number;
  sgst: number;
  igst: number;
  vendor_id: any;
  company_cin: any;
  //company_state_code: any;
  customer_branch_gst: string;
  vendorBranchGstType:any
  vendor_branch_gst: any;
  gst_type:any;
  existingFiles: any[] = [];
  vendorBranchGstNumber:any;
  customers: any;
  cutomer_branchs: any;
  cutomer_branch_ledger_id: any;
  cutomer_branch_ledger_name: any;
  sales_invoice_details:any[];
  debit_note_details:any[];
  credit_note_details:any[];
  salesInvoice:any;
  creditNote:any;
  debitNote:any;
  vendors: any;
  vendor_branchs: any;
  vendor_branch_ledger_id: any;
  vendor_branch_ledger_name: any;
  purchase_invoice_details:any[];
  isDuplicate: boolean;
  originalVoucherId: any;
  is_pi_si_manual:number;
  so_no: any;
  si_no:any;
  unit_name: any;
  store_id_for_items:any;
  affect_qty:any;
  is_affect_qty:boolean= false; 
 // filtered_ledger_data:any[];
  profitCostId!: number[];
  limit = 50;
  hasMore = true;
  loading = false;
  currentSearch = '';
  ledger_ids: any;
  section_selected:any;
  customerBranchLedger: any;
  vendorBranchLedger: any;
  invoice_date: any;
  @ViewChild('ledgerSelect') ledgerSelect!: MatSelect;
  customer_address1: any;
  customer_district: any;
  customer_pincode: any;
  customer_city: any;
  customer_branch_address: any;
  customer_branch_address1: any;
  customer_branch_city: any;
  customer_branch_pin_code: any;
  customer_branch_district: any;
  customer_branch_name: any;
  vendor_branch_address: any;
  vendor_branch_address1: any;
  vendor_branch_city: any;
  vendor_branch_pin_code: any;
  vendor_branch_district: any;
  vendor_branch_name: any;
  vendor_branch_pincode: any;
  vendor_branch_email: any;
  vendor_branch_phone: any;
  customer_branch_pincode: any;
  isView: boolean;
  showPostButton: boolean;
  approval_status:any;
  is_posted: any;
  customer_branch_state: any;
  selectedEmployees: any[] = [];
  private VoucherComponents: any = {
  'Credit Note': CreditNoteVoucherComponent,
  'Debit Note': DebitNoteVoucherComponent,
  'Sales': SalesVoucherComponent,
  'Purchase': PurchaseVoucherComponent,
};
  /** Prevents showdesigns() from repeatedly closing/reopening voucher dialogs. */
  private designDialogOpened = false;
  /** When true, this dialog only redirects to Purchase/Sales — skip ngOnInit fetches. */
  private redirectToDesignDialog = false;
  customer_branch_cin_no: any;
  customer_branch_tan_no: any;
  vendor_branch_cin_no: any;
  vendor_branch_tan_no: any;
  constructor(
    private apiService: ApiService,
    private adminService: AdminService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateVoucherPostingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      creation_voucher_debit: any[];
      creation_voucher_credit: any[];
      voucherId: any; 
      id?: number; voucherType: any; 
      operationType: any; voucherNo: any; date: any; narration: any; debitSides: any[]; creditSides: any[]; upload: any; 
      showInter:any;
      type?: any; branch_id?: any;profit_cost_id?:any;profit_costs?: any;store_id?: number;section_id?: any;  originalVoucherId: null;
      isDuplicate: boolean;
      approval_status?: any;
      images: any;
      uploadedFiles: any;
      is_audit: any;
      layoutType?: string;
      selectedEmployees?: any[];
      showPostButton?: boolean;
    }
  ) {
    let showInterbranch = this.data.showInter;
    this.voucher_type = showInterbranch;
    console.log(showInterbranch);
    if (showInterbranch === 'Purchase' || showInterbranch === 'Sales') {
      this.showPurches = false;
      this.redirectToDesignDialog = true;
      this.showdesigns();
    } else if (showInterbranch === 'Inter Branch') {
      this.showPurches = false;
      this.showinterbranch = true;
    }else if(showInterbranch === 'Advance Multibranch'){
      this.showPurches = false;
      this.showadvinterbranch = true;
    }else if(showInterbranch === 'Credit Note' || showInterbranch === 'Debit Note'){
      this.showPurches = false;
      this.redirectToDesignDialog = true;
      this.showdesigns();
    } else {
      this.showPurches = false;
      this.showinterbranch = false;
    }  
    if (showInterbranch === 'Purchase') {
      this.isPurchase = true;
    }  else if (showInterbranch === 'Sales') {
      this.isSales = true;
    }else {
      this.isPurchase = false;
      this.isSales = false;
    }  
    //localstorage Data//
    let userString = localStorage.getItem('data');
    let user = JSON.parse(userString);
    this.branch_id = user?.branch_id;
    this.role_id = user?.role_id;
    //localstorage Data//
    this.dialogRef = dialogRef;
    this.operationType = data.operationType;
    this.isDuplicate = data.isDuplicate || false;  
    this.originalVoucherId = data.originalVoucherId || null;
    // this.fetchbranchData();
    this.checkUserRole();
    // this.fetchCombinedData();
    // this.fetchSectionData();
    let access_list=JSON.parse(localStorage.getItem("accesslist")||'{}');
    this.branch_access_list=access_list[0]?.branches;
    console.log(access_list,"access_list");
    console.log(this.branch_access_list,"branch_access_list");
    if (data?.type === 'update'){
      console.log('type',this.type);
      this.isUpdate = true;
    }
    this.type = data?.type;
    if (data?.type === 'view') {
      this.isView = true;
    }
    this.showPostButton = data?.showPostButton || false;
    if (this.showPostButton) {
      this.approval_status = this.data.approval_status === 'Approved';
    }
  }
  getTitle(): string {
    if (this.isView) return `View Voucher Posting - ${this.voucherNo}`;
    return this.operationType === 'create' ? 'Create Voucher Posting' : `Update Voucher Posting - ${this.voucherNo}`;
  }
  getButton(): string {
    return this.operationType === 'create' ? 'Create' : 'Update';
  }

  canEditFromView(): boolean {
    if (this.is_posted === 1) return false;
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  enterEditFromView(): void {
    if (!this.canEditFromView()) return;
    this.isView = false;
    this.isUpdate = true;
    this.operationType = 'update';
    this.type = 'update';
    if (this.data) {
      this.data.type = 'update';
      this.data.operationType = 'update';
    }
    // showPostButton path stores a boolean in approval_status — restore string for edit guards
    if (typeof this.approval_status === 'boolean') {
      this.approval_status = this.data?.approval_status;
    }
  }

  deleteVoucherFromView(): void {
    if (!this.canEditFromView() || !this.data?.id) return;
    if (!confirm('Are you sure you want to delete this voucher?')) return;
    const requestData = {
      doc_type: this.voucher_type || this.data?.showInter,
      doc_id: this.data.id,
      type: 'delete'
    };
    this.apiService.deleteVoucherPosting(this.data.id, requestData).subscribe(
      (response) => {
        if (response && response.message) {
          alert('Voucher removed successfully');
          this.dialogRef.close(true);
        }
      },
      (error) => {
        console.error('Error deleting voucher:', error);
        alert('Error deleting voucher');
      }
    );
  }
    // ngOnInit(): void {
    //   this.fetchVoucherData();
    //   this.fetchVoucherById();
    //   // this.fetchvendorData();
    //   // this.fetchData();
    //   // this.fetchCustomerData();
    //   // this.fetchSectionData();
    //   this.hostname = window.location.hostname;
    //   this.fullhostname = window.location.origin;
    //   this.fetchcompany(this.hostname);
    //   // this.fetchPurchaseInvoice();
    //   // this.fetchSalesInvoice();
    //   // this.fetchtaxData();
    //   const today = new Date();
    //   this.date = this.formatDate(today);
    //   this.maxDate = this.formatDate(today);
    //   // forkJoin({
    //   //   stores: this.apiService.getStore(),
    //   //   profitCosts: this.apiService.getProfitCostCenter(),
    //   //   section: this.apiService.getSection(),
    //   //   branch: this.apiService.getbranchData(),
    //   // }).subscribe(({ stores, profitCosts, section, branch }) => {
    //   //   this.store_data = stores;
    //   //   this.profitCostData = profitCosts.data;
    //   //   this.all_section_data = section;
    //   //   this.branch_data = branch;
    //   //   if (this.data?.branch_id) {
    //   //     this.branch_id = this.data.branch_id;
    //   //     this.onInvBranchChange(this.branch_id);
    //   //   }
    //   //   setTimeout(() => {
    //   //     if (this.data?.profit_costs) {
    //   //       this.profitcost_id = this.data.profit_cost_id;
    //   //       this.onProfitCostChange(this.profitcost_id);
    //   //       this.onProfitCost(this.profitcost_id);
    //   //       setTimeout(() => {
    //   //         if (this.data?.store_id) {
    //   //           this.store_id = this.data.store_id;
    //   //         }
    //   //       }, 100);
    //   //     }
    //   //   }, 100);
    //   // }, error => {
    //   //   console.error('Error fetching initial data:', error);
    //   // });
    //   // this.getEmployeelist();
    // }


  posting(): void {
    const payload = {
      selected_voucher: [this.data.id]
    };
    this.apiService.postVoucher(payload).subscribe(
      response => {
        alert('Voucher posted successfully');
        this.dialogRef.close(true);
      },
      error => {
        console.error('Error posting voucher:', error);
        alert('Error posting voucher');
      }
    );
  }

  ngOnInit(): void {
    console.log('ngOnInit - Initial data object:', this.data);
    console.log('ngOnInit - data.approval_status:', this.data?.approval_status);
    console.log('ngOnInit - data.id:', this.data?.id);

    // Purchase/Sales/Credit/Debit are handed off to their own dialogs in the constructor.
    // Continuing init here re-assigns voucherType and re-triggers showdesigns via ngModelChange,
    // which remounts the footer continuously and makes buttons unclickable.
    if (this.redirectToDesignDialog) {
      return;
    }

    this.fetchEmployeeData();

  this.fetchVoucherData();
  if(this.data.id){
    this.fetchVoucherById();
  }
  this.hostname = window.location.hostname;
  this.fullhostname = window.location.origin;
  this.fetchcompany(this.hostname);
  const today = new Date();
  this.date = this.formatDate(today);
  this.maxDate = this.formatDate(today);
  this.fetchbranchData();
  this.fetchSectionData();
  this.fetchtaxData();
  if (!this.data.isDuplicate) return;
  // DUPLICATE MODE START
  this.voucherType = this.data.voucherType;
  this.voucherNo = null; 
  this.date = this.data.date;
  this.branch = this.data.branch_id;
  this.profit_cost_id = this.data.profit_cost_id;
  this.section_id = this.data.section_id;
  this.store_id = this.data.store_id;
  this.fetchStoreData();
  this.fetchProfitCostData();
  this.uploadedFiles = this.data.upload || [];
  this.narration = this.data.narration;
  this.selectedEmployees = this.data.selectedEmployees || [];
  this.showinterbranch = !!this.data.showInter;
  this.isUpdate = false;
  this.branchdata = (this.branchdata || []).map(b => ({ ...b, id: Number(b.id) }));
     this.debitsides = this.debitsides = ((this.data.debitSides?.length ? this.data.debitSides : null)  || this.data.creation_voucher_debit  || []).map((d: any) => {
    const branchId = Number(d.branch_id || this.data.branch_id);
    const ledgerId = Number(d.debitLedgerType || d.ledger?.id || d.ledger_id);
    const ledgerObj = d.ledger || { id: ledgerId, ledger_name: d.ledger_name || '' };
    if (!this._filteredDrLedgers.has(branchId)) {
      this._filteredDrLedgers.set(branchId, []);
    }
    if (!this._filteredDrLedgers.get(branchId).some(l => l.id === ledgerId)) {
      this._filteredDrLedgers.get(branchId).push(ledgerObj);
    }
    const preselectedBranch = this.branchdata.some(b => b.id === branchId) ? branchId : (this.branchdata[0]?.id || null);

    return {
      fromBranch: preselectedBranch,
      branch_id: branchId,
      debitLedgerType: ledgerId,
      ledger_id: ledgerId,
      debitAmount: d.debitAmount ?? d.amount,
      debitDescription: d.debitDescription ??d.description,
      ledger: ledgerObj,
      employee_id: d.employee_id
    };
  });

  console.log("Final debitSides:", this.debitsides);
     this.creditsides = ((this.data.creditSides?.length ? this.data.creditSides : null) || this.data.creation_voucher_credit || []).map((c: any) => {
    const branchId = Number(c.branch_id || this.data.branch_id);
    const ledgerId = Number(c.creditLedgerType || c.ledger?.id || c.ledger_id);
    const ledgerObj = c.ledger || { id: ledgerId, ledger_name: c.ledger_name || '' };

    if (!this._filteredCrLedgers.has(branchId)) {
      this._filteredCrLedgers.set(branchId, []);
    }
    if (!this._filteredCrLedgers.get(branchId).some(l => l.id === ledgerId)) {
      this._filteredCrLedgers.get(branchId).push(ledgerObj);
    }
    const preselectedBranch = this.branchdata.some(b => b.id === branchId) ? branchId : (this.branchdata[0]?.id || null);

    return {
      fromBranch: preselectedBranch,
      toBranch: preselectedBranch,
      branch_id: branchId,
      creditLedgerType: ledgerId,
      ledger_id: ledgerId,
      creditAmount: c.creditAmount ?? c.amount,
      creditDescription: c.creditDescription ?? c.description,
      ledger: ledgerObj,
      employee_id: c.employee_id
    };
  });

  console.log("Final creditSides:", this.creditsides);
  const drBranches = [...new Set(this.debitsides.map(x => x.fromBranch))];
  const crBranches = [...new Set(this.creditsides.map(x => x.toBranch))];

  drBranches.forEach(branch => this.getLedgerData(branch, true));
  crBranches.forEach(branch => this.getLedgerDatas(branch, true));

if (this.data.uploadedFiles && this.data.uploadedFiles.length > 0) {
  this.myFiles = this.data.uploadedFiles.map(f => ({
    id: f.id,
    name: f.name,
    url: f.url,
    extension: f.extension,
    selected: false
  }));
}
this.fetchtaxData();
}

  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

onInvBranchChange(branchId: number) {
  if (!this.profitCostData || this.profitCostData.length === 0) {
    this.ProfitCostData = [];
    return;
  }
    this.ProfitCostData = this.profitCostData.filter(profitCost =>
      profitCost.branch_id === branchId
    );
    this.fetchProfitCost();
  }
  fetchProfitCost() {
    this.apiService.getProfitCostCenter().subscribe(
      (response) => {
        this.ProfitCostData = response.data;
        console.log("Profit cost data:", this.ProfitCostData);
      },
      (error) => {
        console.error("Error fetching profit cost data:", error);
      }
    );
  }

  fetchEmployeeData() {
    this.apiService.getAllEmployeeMasterList().subscribe(
      (response) => {
        console.log('Employee List response:', response);
        this.employee_data = response?.data || [];
      },
      (error) => {
        console.error('Error fetching employee list:', error);
      }
    );
  }
  onProfitCostChange(profitCostId: number) {
    const selectedProfitCost = this.ProfitCostData.find(item => item.id === profitCostId);
    if (selectedProfitCost) {
      this.store_data = selectedProfitCost.stores;
      this.section_data = this.all_section_data.filter(
        section => section.profit_cost_id === profitCostId
      );
      this.section_data.forEach(section => {
        this.sectionProfitCostMap[section.id] = profitCostId;
      });
    } else {
      this.store_data = [];
      this.section_data = [];
    }
    this.store_id = [];
    this.inv_section_id = null;
  }
  onProfitCost(profitCostId: number | number[]) {
    const pc_cc_ids = Array.isArray(profitCostId) ? profitCostId : [profitCostId];
    if (this.invoice_type) {
      this.gstType();
      if (this.invoice_type === 'credit note') {
        this.fetchCreditNoteDetails(this.creditNote);
      } else if (this.invoice_type === 'debit note') {
        this.fetchDebitNoteDetails(this.debitNote);
      } else if (this.invoice_type === 'purchase') {
        this.fetchPurchaseInvoiceDetails(this.purchaseInvoice);
      } else if (this.invoice_type === 'sales') {
        this.fetchSalesInvoiceDetails(this.salesInvoice);
      }
    } else {
      this.profitCostId = pc_cc_ids;
      console.log("Profit cost id:", this.profitCostId);
    // const selectedProfitCost = this.profit_cost.find(item => item.id === pc_cc_ids);
    const selectedProfitCost = this.profit_cost.find(item =>
      pc_cc_ids.includes(item.id)
    );
    console.log("Selected profit cost:", selectedProfitCost);
    if (selectedProfitCost) {
      this.store_id_for_items = selectedProfitCost.store_id;
    }
      this.filteredSections = this.all_section_data.filter(sec =>
      pc_cc_ids.includes(sec.profit_cost_id)
    );
    console.log("Filtered sections", this.filteredSections);
    this.selectedPiSection = null;
    this.resetLedgerState();
    // this.rounded_ledger_data = [];
    this.fetchProfitCostLedger(pc_cc_ids)
    this.fetchStoreData();
    this.resetFields([
      'voucherType',
      'branch',
      'profit_cost_id'
    ]);
  }
  }
  fetchStoreData() {
    const postData = {
      profit_cost_id: this.profit_cost_id,
    };
    console.log('profit cost id', postData);
    this.apiService.getStoreByPcCc(postData).subscribe(
      (response) => {
        this.store_data = response;
        console.log('store data', this.store_data);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  resetLedgerState() {
  this.rounded_ledger_data = [];
  this.hasMore = true;
  this.currentSearch = '';
}
  fetchProfitCostLedger( profitCostId: number | number[],
  reset: boolean = false) {
  if (this.loading) return;
  if (!this.hasMore && !reset) return;

  if (reset) {
    this.hasMore = true;
    this.rounded_ledger_data = [];
  }
  const ids = Array.isArray(profitCostId) ? profitCostId : [profitCostId];
  this.loading = true;
  const offset = this.rounded_ledger_data.length;
    // this.apiService.getProfitCostLedger(data,true).subscribe(
    //   (response) => {
    //     this.rounded_ledger_data = response.ledger_data;

    //     console.log('Ledger data:', this.rounded_ledger_data);
    //   },
    //   (error) => {
    //     console.error('Error fetching ledger data:', error);
    //   }
    // );
    this.apiService.getProfitCostLedger(
      ids,
    true,
    {
      offset: offset,
      limit: this.limit,
      search: this.currentSearch,
      ledger_ids: this.ledger_ids
    }
  ).subscribe(
    (res: any) => {
      const data = res.ledger_data || [];
      this.rounded_ledger_data = [
        ...this.rounded_ledger_data,
        ...data,
      ];
      if (data.length < this.limit) {
        this.hasMore = false; 
      }
      this.loading = false;
    },
    () => this.loading = false
  );
  }

  fetchInventorySku() {
    this.selectedSkuId = null;
    this.tableSkus = []; // Clear table
    const postData = {
      inv_section_id: this.inv_section_id,
      store_id: this.store_id
    };
    this.apiService.getInventorySku(postData).subscribe(
      (response) => {
        this.sku = response.filter(item => item.details && item.details.length > 0);
        console.log('this.sku', this.sku);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
   getLifoFifoValue(sku: any, so: any): number {
    if (!sku?.details || !so || so.selectQty <= 0) {
      return 0;
    }

    let remainingQty = so.selectQty;
    let totalValue = 0;

    if (this.price_policy === 1) {
      // LIFO
      const lifoDetails = [...sku.details].reverse();
      for (const detail of lifoDetails) {
        if (remainingQty <= 0) break;
        const availableQty = parseFloat(detail.qty);
        const usedQty = Math.min(availableQty, remainingQty);
        totalValue += usedQty * detail.price;
        remainingQty -= usedQty;
      }
    } else if (this.price_policy === 2) {
      // FIFO
      const fifoDetails = [...sku.details];
      for (const detail of fifoDetails) {
        if (remainingQty <= 0) break;
        const availableQty = parseFloat(detail.qty);
        const usedQty = Math.min(availableQty, remainingQty);
        totalValue += usedQty * detail.price;
        remainingQty -= usedQty;
      }
    } else if (this.price_policy === 3) {
      // Average Cost
      const totalQty = sku.details.reduce((sum, d) => sum + parseFloat(d.qty), 0);
      const totalPrice = sku.details.reduce((sum, d) => sum + (d.qty * d.price), 0);
      const avgPrice = totalQty > 0 ? totalPrice / totalQty : 0;
      totalValue = so.selectQty * avgPrice;
    }

    return totalValue;
  }

  getLifoFifoBreakdown(sku: any, so: any): string[] {
    const breakdown: string[] = [];

    if (!sku || !Array.isArray(sku.details) || !so || so.selectQty <= 0) {
      return breakdown;
    }

    if (this.price_policy === 3) {
      // Average Cost
      const totalQty = sku.details.reduce((sum, d) => sum + parseFloat(d.qty), 0);
      const totalPrice = sku.details.reduce((sum, d) => sum + (d.qty * d.price), 0);
      const avg = totalQty > 0 ? (totalPrice / totalQty).toFixed(2) : '0';
      breakdown.push(`${so.selectQty} × ${avg}`);
    } else {
      // FIFO / LIFO
      let details: any[] = [];
      if (this.price_policy === 1) {
        details = [...sku.details].reverse(); // LIFO
      } else if (this.price_policy === 2) {
        details = [...sku.details]; // FIFO
      }

      let remainingQty = so.selectQty;

      for (const detail of details) {
        if (remainingQty <= 0) break;

        const availableQty = parseFloat(detail.qty);
        const usedQty = Math.min(availableQty, remainingQty);
        breakdown.push(`${usedQty} × ${detail.price}`);
        remainingQty -= usedQty;
      }
    }

    return breakdown;
  }

  onSelectSku() {
    this.tableSkus = this.tableSkus.filter(sku => this.selectedSkuId.includes(sku.id));

    // Add new SKUs
    for (const id of this.selectedSkuId) {
      const exists = this.tableSkus.find(item => item.id === id);
      if (!exists) {
        const selected = this.sku.find(item => item.id === id);
        if (selected) {
          const cloned = {
            ...selected,
          };
          this.tableSkus.push(cloned);
        }
      }
    }
  }


  updateValue(detail: any) {
    const qty = Number(detail.qty) || 0;
    const price = Number(detail.price) || 0;
    detail.value = qty * price;
  }
   onQtyChange(sku: any, so: any) {
    const totalQty = this.getTotalQty(sku);

    if (totalQty > sku.qty) {
      alert(`Total SO quantity (${totalQty}) exceeds available stock (${sku.qty})`);
      so.selectQty = 0; // reset only this SO row qty
      return;
    }

    if (this.price_policy && this.price_policy !== 0) {
      so.lifoBreakdown = this.getLifoFifoBreakdown(sku, so);
      so.lifoValue = this.getLifoFifoValue(sku, so);
    } else {
      alert('Price policy is not set. Please set Price policy.');
      so.selectQty = 0;
    }
  }

  // getMaxDate(): string {
  //   const today = new Date();
  //   const year = today.getFullYear();
  //   let month = (today.getMonth() + 1).toString().padStart(2, '0');
  //   let day = today.getDate().toString().padStart(2, '0');
  //   return `${year}-${month}-${day}`;
  // }
  
  ledger_data: Map<number, any[]> = new Map<number, any[]>();
  ledger_datas: Map<number, any[]> = new Map<number, any[]>();
  _filteredDrLedgers: Map<number, any[]> = new Map<number, any[]>();
  _filteredCrLedgers: Map<number, any[]> = new Map<number, any[]>();
  getLedgerData(fromBranch?: any,inter_update?:boolean) {  //for dr side
    if (fromBranch) {
      this.apiService.getAllLedgerAndMaps(this.voucherType, "Dr", fromBranch).subscribe((data: any) => {
        this.ledger_data.set(fromBranch, data.ledger_data);
        if(inter_update){
          this.filterDrLedgers(fromBranch);
        }else{
          this.filterDrLedgers();
        }
      });
    } else {
      if (this.voucher_type !== 'Credit Note' && this.voucher_type !== 'Debit Note') {
        this.apiService.getAllLedgerAndMaps(this.voucherType, "Dr",this.branch).subscribe((data: any) => {
          this.ledger_data.set(this.branch, data.ledger_data);
          this.filterDrLedgers();
        });
      } 
      // else {
      //   const postdata = {
      //     voucher_type:this.voucherType,
      //     creation_id:this.voucher_type === 'Credit Note' ? this.pi_id : this.si_id,
      //     side: "Dr",
      //     is_qc: 0
      //   };
      //   this.apiService.getPiLedger(postdata).subscribe((data: any) => {
      //     console.log('dr data', data);
      //     console.log('ledger dr', data.ledger_data);
      //     this.ledger_data.set(this.voucherType, data.ledger_data);
      //     this.filterDrLedgers();
      //   });
      // }
    }
  }
  filterDrLedgers(interbranch_id?:any) {
    let branch=0;
    if(interbranch_id){
      branch=interbranch_id;
    }else{
      branch=this.branch;
    }
    this.filteredDrLedgers=this._filteredDrLedgers.get(branch) || [];
    if (!this.ledger_data.has(branch)) {
      this.filteredDrLedgers = [];
      return;
    }
    let ledgers = this.ledger_data.get(branch) || [];

    if (this.searchDrText && this.searchDrText.trim() !== '') {
      const searchLower = this.searchDrText.toLowerCase();
      this.filteredDrLedgers = ledgers.filter((ledger: any) =>
        ledger.ledger_name?.toLowerCase().includes(searchLower)
      );
    } else {
      this.filteredDrLedgers = [...ledgers];
    }
    this.debitsides.forEach(debit => {
      if (debit.debitLedgerType && !this.filteredDrLedgers.some(l => l.id === debit.debitLedgerType)) {
        const selectedLedger = ledgers.find(l => l.id === debit.debitLedgerType);
        if (selectedLedger) {
          this.filteredDrLedgers.push(selectedLedger);
        }
      }
    });

    this._filteredDrLedgers.set(branch,this.filteredDrLedgers);

    // console.log("drrrrrrrrrrrrrrrrrr",this.filteredDrLedgers);
    // console.log("222222drrrrrrrrrrrrrrrrrr",this._filteredDrLedgers.get(branch))
  }
  
  filterCrLedgers(interbranch_id?:any) {

    let branch=0;
    if(interbranch_id){
      branch=interbranch_id;
    }else{
      branch=this.branch;
    }

    this.filteredCrLedgers=this._filteredCrLedgers.get(branch) || [];
    if (!this.ledger_datas.has(branch)) {
      this.filteredCrLedgers = [];
      return;
    }
    let ledgers = this.ledger_datas.get(branch) || [];
    if (this.searchCrText && this.searchCrText.trim() !== '') {
      const searchLower = this.searchCrText.toLowerCase();
      this.filteredCrLedgers = ledgers.filter((ledger: any) =>
        ledger.ledger_name?.toLowerCase().includes(searchLower)
      );
    } else {
      this.filteredCrLedgers = [...ledgers];
    }
    this.creditsides.forEach(credit => {
      if (credit.creditLedgerType && !this.filteredCrLedgers.some(l => l.id === credit.creditLedgerType)) {
        const selectedLedger = ledgers.find(l => l.id === credit.creditLedgerType);
        if (selectedLedger) {
          this.filteredCrLedgers.push(selectedLedger);
        }
      }
    });
    this._filteredCrLedgers.set(branch,this.filteredCrLedgers);
    // console.log("crrrrrrrrrrrrrrrrrr",this.filteredCrLedgers);
    // console.log("1111111111crrrrrrrrrrrrrrrrrr",this._filteredCrLedgers.get(branch))
  }
  
  getLedgerDatas( toBranch?: any,inter_update?:boolean) {  //for cr side
    if (toBranch) {
      this.apiService.getAllLedgerAndMapss(this.voucherType, "Cr", toBranch).subscribe((data: any) => {
        this.ledger_datas.set(toBranch, data.ledger_data);
        if(inter_update){
          this.filterCrLedgers(toBranch);
        }else{
          this.filterCrLedgers();
        }
      });
    } else {
      if (this.voucher_type != 'Credit Note' && this.voucher_type != 'Debit Note') {
        this.apiService.getAllLedgerAndMaps(this.voucherType, "Cr",this.branch).subscribe((data: any) => {
          this.ledger_datas.set(this.branch, data.ledger_data);
          this.filterCrLedgers();
        });
      } 
      // else {
      //   const postdata = {
      //     voucher_type:this.voucherType,
      //     creation_id:this.voucher_type == 'Credit Note' ?this.pi_id:this.si_id,
      //     side: "Cr",
      //     is_qc:0
      //   }
      //   this.apiService.getPiLedger(postdata).subscribe((data: any) => {
      //     console.log('dr data', data);
      //     console.log('ledger dr', data.ledger_data);
      //     this.ledger_datas.set(this.voucherType, data.ledger_data);
      //     this.filterCrLedgers();
      //   });
      // }
    }
  }

  fetchbranchData() {
    this.apiService.getbranchData().subscribe(
      (response) => {
        this.branchdata = response;
        console.log('branchesss:', this.branchdata);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  // fetchVoucherNo(data: any) {

    // this.apiService.getVoucher(data).subscribe(
    //   (response) => {
    //     this.voucherNo = response.voucher_no;
    //   },
    //   (error) => {
    //     console.error('Error fetching voucher number:', error);
    //   }
    // );

  // }

  getSelectedEmployeeList() {
    return this.employee_data.filter(emp =>
      this.selectedEmployees.map(Number).includes(Number(emp.id))
    );
  }

  onEmployeeHeaderChange() {
    const selectedIds = this.selectedEmployees || [];
    this.debitsides.forEach(side => {
      if (side.employee_id && !selectedIds.includes(side.employee_id)) {
        side.employee_id = null;
      }
    });

    this.creditsides.forEach(side => {
      if (side.employee_id && !selectedIds.includes(side.employee_id)) {
        side.employee_id = null;
      }
    });
  }

  fetchVoucherData() {
    this.apiService.getDataVoucher().subscribe(
      (response) => {
        // alert(this.branch_access_list.length);
        if (this.branch_access_list?.length == 1) {
          // alert('asdasd');
          this.vouchers = response.filter(voucherType => voucherType.voucher_type !== 'Inter Branch');
        } else {
          console.log('else');
          console.log('layoutType', this.data.layoutType);
          if(this.data.layoutType === 'centralhub'){
            this.vouchers = response.filter(voucherType => voucherType.voucher_type !== 'Purchase' && voucherType.voucher_type !== 'Sales');
          }else{
            this.vouchers = response.filter(voucherType => voucherType.voucher_type === 'Purchase' || voucherType.voucher_type === 'Sales')
          }
        }
      },
      (error) => {
        console.log("Error fetching data:", error);
      }
    );
  }
  showinterbranchdesign() {
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    this.showDesign = selectedVoucher && selectedVoucher.voucher_type == 'Inter Branch';
    this.showadvDesign=selectedVoucher && selectedVoucher.voucher_type ==  'Advance Multibranch';
    this.showinterbranch = this.showDesign;
    this.showadvinterbranch = this.showadvDesign;
    console.log('show design',this.showDesign);
    console.log('show adv design',this.showadvinterbranch );
  }
  private processedBranchesdr = new Set<number>();

  loadLedgerDatadr(branchId: number) {
    if (this.processedBranchesdr.has(branchId)) return;
  
    this.processedBranchesdr.add(branchId);
    this.getLedgerData(branchId, true);
  }

  private processedBranchescr = new Set<number>();

  loadLedgerDatacr(branchId: number) {
    if (this.processedBranchescr.has(branchId)) return;
  
    this.processedBranchescr.add(branchId);
    this.getLedgerDatas(branchId, true);
  }
  fetchVoucherById() {
   console.log('inside fetch by id')
   console.log('Initial data.approval_status:', this.data?.approval_status);
    if (this.data?.id && (this.data?.showInter === 'Inter Branch' || this.data?.showInter === 'Advance Multibranch'|| this.data?.showInter === null)) {
      console.log('inside Inter Branch')
      this.apiService.getvoucherPostingById(this.data.id).subscribe(
        (voucherData:any) => {
          console.log(voucherData,"data checcccck");
          console.log('API approval_status:', voucherData?.Voucher?.approval_status);
          if (voucherData && voucherData.Voucher) {
            this.voucherType = voucherData.Voucher.voucher_id;
            this.voucherNo = voucherData.Voucher.voucher_no;
            this.date = voucherData.Voucher.date;
            this.branch = voucherData.Voucher.branch_id;
            this.is_posted = voucherData.Voucher.is_posted;
            this.narration = voucherData.Voucher.narration;
            this.file = voucherData.Voucher.file;
            this.fetchProfitCostData();
            this.fetchSectionData();
            this.profit_cost_id = (voucherData.Voucher.profit_cost_id || (voucherData.Voucher?.creation_voucher_details?.[0]?.profit_cost_id) || null);
            this.section_id = (voucherData.Voucher.section_id || (voucherData.Voucher?.creation_voucher_details?.[0]?.section_id) || null);
            this.store_id = (voucherData.Voucher.store_id || (voucherData.Voucher?.creation_voucher_details?.[0]?.store_id) || null);
            this.fetchStoreData();
            this.fetchEmployeeData();
            // Update approval_status from API response
            if (voucherData.Voucher.approval_status !== undefined) {
              this.data.approval_status = voucherData.Voucher.approval_status;
              console.log('Updated data.approval_status to:', this.data.approval_status);
            }
            if (this.branch) {
              this.getLedgerData();
              this.getLedgerDatas();
          }
            this.creditsides = [];
            this.debitsides = [];
            this.selectedEmployees = voucherData.Voucher.employee_id
              ? voucherData.Voucher.employee_id.split(',').map((id: string) => +id)
              : [];

            if (voucherData.Voucher.creation_voucher_debit?.length > 0) {
              this.debitsides = voucherData.Voucher.creation_voucher_debit.map(debit => ({
                  serialNumber: debit.sl_no,
                  fromBranch: debit.branch_id,  // Use this.branch if available, otherwise use debit.branch_id
                  debitLedgerType: debit.ledger_id,
                  debitAmount: debit.amount,
                  debitDescription: debit.description,
                  employee_id: debit.employee_id
            }));

            this.debitsides.map((data)=>{
              // alert(data.fromBranch)
              this.loadLedgerDatadr(data.fromBranch);
              // this.filterDrLedgers(data.fromBranch)
            });
          }
        

          // Fetch credit side data
          if (voucherData.Voucher.creation_voucher_credit?.length > 0) {
              this.creditsides = voucherData.Voucher.creation_voucher_credit.map(credit => ({
                  debitSerialNumber: credit.sl_no,
                  toBranch: credit.branch_id,
                  creditLedgerType: credit.ledger_id,
                  creditAmount: credit.amount,
                  creditDescription: credit.description,
                  employee_id: credit.employee_id
              }));
              this.creditsides.map((data)=>{
                // alert(data.toBranch)
                this.loadLedgerDatacr(data.toBranch);
                // this.filterCrLedgers(data.toBranch)
              });
          }
          }
        },
        (error) => {
          console.error("Error fetching ledger data:", error);
        }
      );
    } else if (this.data?.id && (this.data?.showInter === 'Purchase')) {
       console.log('inside Purchase')
      this.apiService.getvoucherPostingById(this.data.id).subscribe(
        (voucherData) => {
          console.log('Purchase API approval_status:', voucherData?.Voucher?.approval_status);
          if (voucherData && voucherData.Voucher) {
            this.voucherType = voucherData.Voucher.voucher_id;
            this.fetchbranchData();
            this.voucherNo = voucherData.Voucher.voucher_no;
            this.branch = voucherData.Voucher.branch_id;
            this.is_posted = voucherData.Voucher.is_posted;
            this.onBranchChange();
            // this.profit_cost_id = voucherData.Voucher?.creation_voucher_details?.[0]?.profit_cost_id || null;
             this.profit_cost_id = voucherData.Voucher?.profit_cost_id
              ? voucherData.Voucher.profit_cost_id.split(',').map(id => +id)
              : [];
            // this.onProfitCost(this.profit_cost_id);
            this.date = voucherData.Voucher.date;
            this.issue_date = voucherData.Voucher.issue_date;
            this.document_no = voucherData.Voucher.document_no;
            this.purchesnarration = voucherData.Voucher.narration;
            // Update approval_status from API response
            // if (voucherData.Voucher.approval_status !== undefined) {
            //   this.data.approval_status = voucherData.Voucher.approval_status;
            //   console.log('Updated data.approval_status to:', this.data.approval_status);
            // }
            if (voucherData.Voucher.creation_voucher_details && voucherData.Voucher.creation_voucher_details?.length > 0) {
                this.productEntries = voucherData.Voucher.creation_voucher_details.map(entry => ({
                  // productType: entry.product_id,
                  productType: { id: entry.product_id, name:entry.name },
                  ledger_name: entry.product_ledger_name,
                  ledger_id: entry.product_ledger,
                  hsn_no: entry.hsn_no,
                  description: entry.description,
                  unit: entry.unit_name,
                  qty: entry.qty,
                  unitPrice: entry.unit_price,
                  value: entry.qty * entry.unit_price,
                  discount: entry.discount,
                  taxType: entry.gst_id,
                  vendor: entry.vendor_id,
                  selectedVendorBranch: entry.branch_id,
                  roundedamount: entry.rounded_amount,
                  ledger: entry.rounded_ledger,
                  taxledger: this.fetchtaxData(),
                  selectedGrn :entry.grn_id,
                  grn_gsn_details_id: entry.grn_gsn_details_id,
                  selectedPiSection  : entry.section_id,
                  profit_cost_id : entry.profit_cost_id,
                  specification: entry.specification,
                }));
                this.ledger_ids= voucherData.Voucher?.creation_voucher_details?.[0]?.rounded_ledger || null;
                this.onProfitCost(this.profit_cost_id);
                console.log('productEntries of purchase',this.productEntries);
                if (this.productEntries?.length > 0) {
                  this.apiService.getVendorCustomerByBranch(this.branch,'vendor').subscribe((vendors) => {
                    this.vendorData = Array.isArray(vendors?.vendor) ? vendors.vendor : []
                  });
                  this.vendor = this.productEntries[0].vendor;
                  this.onVendorChange(this.vendor);
                  // this.getVendorBranch(this.vendor);
                  // this.fetchSectionData();
                  // this.selectedPiSection = this.productEntries[0].selectedPiSection;
                  // this.section_selected=this.productEntries[0].selectedPiSection;
                   this.selectedVendorBranch = this.productEntries[0].selectedVendorBranch;
                  this.section_selected = voucherData.Voucher?.section_id
                  ? voucherData.Voucher.section_id.toString().split(',').map(id => +id)
                  : []; 
                  console.log('selectedSection purchase' , this.section_selected);
                  this.selectedPiSection = this.section_selected;
                  this.fetchqc();
                  // this.selectedGrn = this.productEntries.map(entry => entry.selectedGrn);
                  this.selectedGrn = [...new Set(this.productEntries.map(entry => entry.selectedGrn))];
                  // this.selectedVendorBranch = this.productEntries[0].selectedVendorBranch;
                  if (this.selectedGrn?.some(grn => grn !== null)) {
                    this.roundedamount2 = this.productEntries[0].roundedamount;
                }else{
                    this.roundedamount = this.productEntries[0].roundedamount;
                }
                  this.ledger = this.productEntries[0].ledger;
                  // this.onVendorChange(this.vendor);
                  // this.onVendorBranchChange();
                  this.fetchSectionData();
                  this.onSearchClick();
                }
            }
          }
      if (voucherData.uploadedFiles && voucherData.uploadedFiles.length > 0) {
          this.uploadedFiles = voucherData.uploadedFiles.map((file: any) => ({
            ...file,
            preview: `${this.fullhostname}/api/storage/${file.image}`,
          }));
        } else {
          this.uploadedFiles = [];
        }  

     },
        (error) => {
          console.error("Error fetching voucher data:", error);
        }
      );
    } else if (this.data?.id && (this.data?.showInter === 'Inventory Voucher')) {
      forkJoin({
        voucherData: this.apiService.getvoucherPostingById(this.data.id),
        profitCosts: this.apiService.getProfitCostCenter(),
        sections: this.apiService.getSection(),
      }).subscribe(({ voucherData, profitCosts, sections }) => {
        this.profitCostData = profitCosts.data || profitCosts;
        this.all_section_data = sections;
        console.log('Inventory Voucher API approval_status:', voucherData?.Voucher?.approval_status);

        if (voucherData && voucherData.Voucher) {
          this.voucherType = voucherData.Voucher.voucher_id;
          this.patchVoucherForm(voucherData);
          this.voucherNo = voucherData.Voucher.voucher_no;
          // Update approval_status from API response
          // if (voucherData.Voucher.approval_status !== undefined) {
          //   this.data.approval_status = voucherData.Voucher.approval_status;
          //   console.log('Updated data.approval_status to:', this.data.approval_status);
          // }
        }
      });
    } else if (this.data?.id && (this.data?.showInter === 'Credit Note')) {
      console.log('inside Credit Note')
      this.apiService.getvoucherPostingById(this.data.id).subscribe(
        (voucherData: any) => {
          console.log(voucherData, "data checcccck");
          console.log('Credit Note API approval_status:', voucherData?.Voucher?.approval_status);
          if (voucherData && voucherData.Voucher) {
            this.fetchbranchData();
            //this.fetchSalesInvoice();
            this.voucherType = voucherData.Voucher.voucher_id;
            this.voucherNo = voucherData.Voucher.voucher_no;
            this.date = voucherData.Voucher.date;
            this.branch = voucherData.Voucher.branch_id;
            if(voucherData.Voucher.sales_purchase_id){
              this.invoice_type ='sales'
              this.fetchSalesInvoice(voucherData.Voucher.sales_purchase_id,voucherData.Voucher.creation_voucher_details);
            }else{
              this.invoice_type ='debit note'
              this.fetchDebitNote(voucherData.Voucher.credit_debit_id);
            }
            //this.fetchProfitCostData();
            this.narration = voucherData.Voucher.narration;
           // this.profit_cost_id = voucherData.Voucher?.creation_voucher_details?.[0]?.profit_cost_id || null;
            const details = voucherData.Voucher?.creation_voucher_details || [];
            this.profit_cost_id = details.map((item: any) => item.profit_cost_id).filter((id: any) => id != null);
            //this.profit_cost_id = voucherData.Voucher?.profit_cost_id || null;
           // this.salesInvoice = voucherData.Voucher.sales_purchase_id;
            this.type = voucherData.Voucher.calculation_type;
           // this.fetchSalesInvoiceDetails(this.salesInvoice, voucherData.Voucher.creation_voucher_details);
            //this.file = voucherData.Voucher.file;
            //   if (this.branch) {
            //     this.getLedgerData();
            //     this.getLedgerDatas();
            // }
          }
        },
        (error) => {
          console.error("Error fetching ledger data:", error);
        }
      );
    } else if (this.data?.id && (this.data?.showInter === 'Debit Note')) {
      console.log('inside Debit Note')
      this.apiService.getvoucherPostingById(this.data.id).subscribe(
        (voucherData: any) => {
          console.log(voucherData, "data checcccck");
          if (voucherData && voucherData.Voucher) {
            this.fetchbranchData();
            // this.fetchPurchaseInvoice();
            this.voucherType = voucherData.Voucher.voucher_id;
            this.voucherNo = voucherData.Voucher.voucher_no;
            this.date = voucherData.Voucher.date;
            this.branch = voucherData.Voucher.branch_id;
            this.is_posted = voucherData.Voucher.is_posted;
            if (voucherData.Voucher.sales_purchase_id) {
              this.invoice_type = 'purchase'
              this.fetchPurchaseInvoice(voucherData.Voucher.sales_purchase_id, voucherData.Voucher.creation_voucher_details);
            } else {
              this.invoice_type = 'credit note'
              this.fetchCreditNote(voucherData.Voucher.credit_debit_id);
            }
           // this.fetchProfitCostData();
            this.narration = voucherData.Voucher.narration;
            //this.profit_cost_id = voucherData.Voucher?.creation_voucher_details?.[0]?.profit_cost_id || null;
            const details = voucherData.Voucher?.creation_voucher_details || [];
            this.profit_cost_id = details.map((item: any) => item.profit_cost_id).filter((id: any) => id != null);
            //this.profit_cost_id = voucherData.Voucher?.profit_cost_id || null;
            //this.purchaseInvoice = voucherData.Voucher.sales_purchase_id;
            this.type = voucherData.Voucher.calculation_type;
            this.affect_qty = voucherData.Voucher.is_affect_qty;
            //this.fetchPurchaseInvoiceDetails(this.purchaseInvoice, voucherData.Voucher.creation_voucher_details);
           // this.fetchSalesInvoiceDetails(this.salesInvoice, voucherData.Voucher.creation_voucher_details);
            // Update approval_status from API response
            // if (voucherData.Voucher.approval_status !== undefined) {
            //   this.data.approval_status = voucherData.Voucher.approval_status;
            //   console.log('Updated data.approval_status to:', this.data.approval_status);
            // }
            //this.file = voucherData.Voucher.file;
            //   if (this.branch) {
            //     this.getLedgerData();
            //     this.getLedgerDatas();
            // }
          }
        },
        (error) => {
          console.error("Error fetching ledger data:", error);
        }
      );
    }
    else {
       console.log('inside else')
      this.apiService.getvoucherPostingById(this.data.id).subscribe(
        (voucherData) => {
          console.log('Else branch API approval_status:', voucherData);
          if (voucherData && voucherData.Voucher) {
            this.voucherType = voucherData.Voucher.voucher_id;
            this.voucherNo = voucherData.Voucher.voucher_no;
            this.date = voucherData.Voucher.date;
            this.fetchbranchData();
            this.branch = voucherData.Voucher.branch_id;
            this.is_posted = voucherData.Voucher.is_posted;
            this.onBranchChange();
            // this.profit_cost_id = voucherData.Voucher?.creation_voucher_details?.[0]?.profit_cost_id || null;
            this.profit_cost_id = voucherData.Voucher?.profit_cost_id
              ? voucherData.Voucher.profit_cost_id.split(',').map(id => +id)
              : [];
            this.issue_date = voucherData.Voucher.issue_date;
            this.document_no = voucherData.Voucher.document_no;
            this.purchesnarration = voucherData.Voucher.narration;
            // Update approval_status from API response
            // if (voucherData.Voucher.approval_status !== undefined) {
            //   this.data.approval_status = voucherData.Voucher.approval_status;
            //   console.log('Updated data.approval_status to:', this.data.approval_status);
            // }
            if (voucherData.Voucher.creation_voucher_details && voucherData.Voucher.creation_voucher_details?.length > 0) {
              this.productEntries = voucherData.Voucher.creation_voucher_details.map(entry => ({
                // productType: entry.product_id,
                productType: { id: entry.product_id, name:entry.name },
                ledger_name: entry.product_ledger_name,
                ledger_id:entry.product_ledger,
                hsn_no: entry.hsn_no,
                description: entry.description,
                unit: entry.unit_name,
                qty: entry.qty,
                unitPrice: entry.unit_price,
                value: entry.qty * entry.unit_price,
                discount: entry.discount,
                taxType: entry.gst_id,
                customer:entry.vendor_id,
                selectedCustomerBranch: entry.branch_id,
                roundedamount:entry.rounded_amount,
                ledger:entry.rounded_ledger,
                taxledger:this.fetchtaxData(),
                selectedGsn :entry.gsn_id,
                grn_gsn_details_id: entry.grn_gsn_details_id,
                selectedSection  : entry.section_id,
                profit_cost_id: entry.profit_cost_id,
              }));
              this.ledger_ids= voucherData.Voucher?.creation_voucher_details?.[0]?.rounded_ledger || null;
              this.onProfitCost(this.profit_cost_id);
              console.log('productEntries of sales',this.productEntries);
              if (this.productEntries?.length > 0) {
                const firstEntry = this.productEntries[0];
                this.apiService.getVendorCustomerByBranch(this.branch,'customer').subscribe((customers) => {
                    this.customerData = Array.isArray(customers?.customer) ? customers.customer : []
                  });
                this.customer = firstEntry.customer;
                // this.onCustomerChange(this.customer);
                  this.getCustomerBranch(this.customer);
                // this.selectedSection= this.productEntries[0].selectedSection;
                // this.section_selected=this.productEntries[0].selectedSection;
                this.selectedCustomerBranch = this.productEntries[0].selectedCustomerBranch;
                this.section_selected = voucherData.Voucher?.section_id
                  ? voucherData.Voucher.section_id.toString().split(',').map(id => +id)
                  : [];   
                this.selectedSection = this.section_selected;
                console.log('section_selected sales' ,this.section_selected);
                this.fetchGsn();
                // this.selectedGsn = this.productEntries.map(entry => entry.selectedGsn);
                this.selectedGsn = [...new Set(this.productEntries.map(entry => entry.selectedGsn))];
                // this.selectedCustomerBranch = this.productEntries[0].selectedCustomerBranch;
                this.CustomerBranchdetails(this.selectedCustomerBranch);
                if (this.selectedGsn?.some(gsn => gsn !== null)) {
                    this.roundedamount2 = firstEntry.roundedamount;
                } else {
                    this.roundedamount = firstEntry.roundedamount;
                }
                this.ledger = firstEntry.ledger;
                // this.onCustomerChange(this.customer);
                // this.customerdata(this.customer);
                // this.onCustomerBranchChange(this.selectedCustomerBranch);
                this.fetchSectionData();
                this.onSearchClick();
                //  this.fetchGsnProductList();
            }
            }
            console.log('hellow',this.productEntries);
          }
           if (voucherData.uploadedFiles && voucherData.uploadedFiles.length > 0) {
          this.uploadedFiles = voucherData.uploadedFiles.map((file: any) => ({
            ...file,
            preview: `${this.fullhostname}/api/storage/${file.image}`,
          }));
        } else {
          this.uploadedFiles = [];
        }  
        },
        (error) => {
          console.error("Error fetching voucher data:", error);
        }
      );
    }
  }
 
  getFileDetails(e) {
    for (let i = 0; i < e.target.files?.length; i++) {
      const file = e.target.files[i];
      this.myFiles.push(file);
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedFiles.push({
          file: event.target.result,
          name: file.name,
          preview: event.target.result
        });
    console.log('Reader result:', event.target.result); 
      };
      reader.readAsDataURL(file);
    }
  }
  removeFile(index: number) {
    this.myFiles.splice(index, 1);
  }
  onFileSelected(event: any) {
    this.getFileDetails(event);
    // const files: FileList = event.target.files;
    // this.convertFileToBase64(files);
  }
  // openFileShowModal() {
  //   if (this.data.id) {
  //     this.apiService.getImagesById(this.data.id, this.voucherType).subscribe(
  //       (data: any) => {
  //         data.imageUrls.forEach((imageUrl: any) => {
  //           if (this.isImage(imageUrl.extension)) {
  //             this.imageUrls.push(imageUrl);
  //           } else if (this.isDocument(imageUrl.extension)) {
  //             this.documentUrls.push(imageUrl);
  //           }
  //         });
  //       },
  //       error => {
  //         console.error('Error fetching images:', error);
  //       }
  //     );
  //     const modalRef = this.dialog.open(FileShowModalComponent, {
  //       width: '1200px',
  //       height: '600px',
  //       data: { id: this.data.id, name: this.test, voucherType: this.voucherType,  is_audit: this.data.is_audit, }
  //     });
  //   }
  //   else {
  //     error => {
  //       console.error('Error fetching images:', error);
  //     }
  //   }
  // }

  openFileShowModal() {
    const finalId = this.data.id || this.originalVoucherId;
    if (!finalId) {
      console.error("No ID found for image loading!");
      return;
    }

    const isVoucherUploadCase = this.voucher_type === 'Purchase' || this.voucher_type === 'Sales'

    if (isVoucherUploadCase) {
      this.openVoucherFileShowModal();
      return;
    }

    const modalRef = this.dialog.open(FileShowModalComponent, {
      width: "1200px",
      height: "600px",
      data: {
        id: finalId,                           // ⭐ Correct voucher ID
        name: this.test,
        voucherType: this.voucherType,
        is_audit: this.data.is_audit,
        isView: this.isView
      }
    });

    modalRef.afterClosed().subscribe(result => {
    });
  }

  isImage(extension: string): boolean {
    const imageExtensions = ['jpeg', 'jpg', 'png', 'svg', 'gif'];
    return imageExtensions.includes(extension.toLowerCase());
  }

  isDocument(extension: string): boolean {
    const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'];
    return documentExtensions.includes(extension.toLowerCase());
  }

  // convertFileToBase64(files: FileList) {
  //   // this.base64File = [];

  //   for (let i = 0; i < files?.length; i++) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       const resultAsString = reader.result as string;
  //       this.base64File.push({ file: resultAsString });
  //       console.log('Base64 Data:', this.base64File);
  //     };
  //     reader.onerror = error => {
  //       console.error('Error reading file:', error);
  //     };
  //     reader.readAsDataURL(files[i]);
  //   }
  // }  
  openVoucherFileShowModal() {
    const finalId = this.data.id || this.originalVoucherId;
    if (finalId && this.voucherType) {
      this.apiService.getVoucherFiles(finalId, this.voucherType).subscribe(
        (response: any) => {
          if (response.status && response.uploadedFiles?.length > 0) {
            this.image_data = response.uploadedFiles;
            const modalRef = this.dialog.open(VoucherFileModalComponent, {
              width: '1200px',
              height: '600px',
              data: {
                id: finalId,
                images: this.image_data,
                voucherType: this.voucherType,
                isViewMode: this.isView
              }
            });

            modalRef.afterClosed().subscribe(result => {
              if (result?.remainingFiles) {
                this.existingFiles = result.remainingFiles;
              }
            });
          } else {
            const modalRef = this.dialog.open(VoucherFileModalComponent, {
              width: '1200px',
              height: '600px',
              data: {
                id: finalId,
                images: [],
                voucherType: this.voucherType,
                isViewMode: this.isView
              }
            });
          }
        },
        (error) => {
          console.error("Error fetching voucher files:", error);
        }
      );
    } else {
      console.error("Invalid Voucher ID or Voucher Type ID.");
    }
  }


  onAdddebitSide() {
    if (!this.voucherType) {
      alert('Please select a voucher type');
      return;
    }
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    if (!selectedVoucher) {
      console.error('Selected voucher not found');
      return;
    }
    const maxDebitSides = selectedVoucher?.dr_no ?? 0;
    if (this.debitsides?.length < maxDebitSides || maxDebitSides === 0) {
      this.debitsides.push({ serialNumber: null, debitLedgerType: null, debitAmount: null, debitDescription: '',  employee_id: null   });
      this.getLedgerData(this.branch, true);
      setTimeout(() => {
        this.searchDrText = '';
        this.filterDrLedgers();
      }, 100);
      this.showDeleteIcon = this.debitsides.length > 1; 
    } else {
      alert(`You can only add ${maxDebitSides} debit side(s) for this voucher.`);
    }
  }
  onRemovedebitSide(index: number) {
    this.debitsides.splice(index, 1);
    this.updateDebitSerialNumbers();
    this.updateCreditSerialNumbers();
  }

  onAddcreditSide() {
    if (!this.voucherType) {
      alert('Please select a voucher type');
      return;
    }
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    if (!selectedVoucher) {
      console.error('Selected voucher not found');
      return;
    }
    const maxCreditSides = selectedVoucher.cr_no;
    if (this.creditsides?.length < maxCreditSides || maxCreditSides === 0) {
      this.creditsides.push({ debitSerialNumber: null, creditLedgerType: null, creditAmount: null, creditDescription: '' ,  employee_id: null  });
      this.getLedgerDatas(this.branch, true);

      setTimeout(() => {
        this.searchCrText = '';
        this.filterCrLedgers();
      }, 100);
      this.showDeleteIcon = true;
    } else {
      alert(`You can only add ${selectedVoucher.cr_no} credit side(s) for this voucher.`);
    }
  }

  onRemovecreditSide(index: number) {
    this.creditsides.splice(index, 1);
  }
  
  calculateTotalDebit(): number {
    let totaldr = this.debitAmount ?? 0;
    for (const side of this.debitsides) {
      totaldr += side.debitAmount ?? 0;
    }
    return parseFloat(totaldr.toFixed(2));
  }

  calculateTotalCredit(): number {
    let totalcr = this.creditAmount ?? 0;
    for (const side of this.creditsides) {
      totalcr += side.creditAmount ?? 0;
    }
    return parseFloat(totalcr.toFixed(2));
  }
  createpostdata(){ //for view post data
    const voucherDr = [];
    const branchIds = [];
    for (let i = 0; i < this.debitsides?.length; i++) {
      const fromBranchDebitSide = this.debitsides[i].fromBranch;
      const ledgerData = this.ledger_data.get(fromBranchDebitSide);
      let selectedLedger = null;
      if (ledgerData) {
        selectedLedger = ledgerData.find(ledger => ledger.id === this.debitsides[i].debitLedgerType);
      }
      const branch_id = selectedLedger?.branch_id || fromBranchDebitSide;
      if (branch_id) {
        branchIds.push(branch_id);
      }
      voucherDr.push({
        sl_no:this.debitsides[i].serialNumber ?? null,
        ledger_id: this.debitsides[i].debitLedgerType ?? null,
        ledger_name: selectedLedger?.ledger_name ?? null,
        amount: this.debitsides[i].debitAmount ?? null,
        description: this.debitsides[i].debitDescription ?? null,
        branch_id: branch_id || null,
        employee_id: this.debitsides[i].employee_id ?? null 
      });
    }

    //loop for voucher cr
    const voucherCr = [];
    for (let i = 0; i < this.creditsides?.length; i++) {
      const toBranchCreditSide = this.creditsides[i].toBranch;
      const ledgerData = this.ledger_datas.get(toBranchCreditSide);
      let selectedLedger = null;
      if (ledgerData) {
        selectedLedger = ledgerData.find(ledger => ledger.id === this.creditsides[i].creditLedgerType);
      }
      const branch_id = selectedLedger?.branch_id || toBranchCreditSide;
      voucherCr.push({
        sl_no: this.creditsides[i].debitSerialNumber ? this.creditsides[i].debitSerialNumber : null,
        ledger_id: this.creditsides[i].creditLedgerType ? this.creditsides[i].creditLedgerType : null,
        ledger_name: selectedLedger?.ledger_name ?? null,
        amount: this.creditsides[i].creditAmount ? this.creditsides[i].creditAmount : null,
        description: this.creditsides[i].creditDescription ? this.creditsides[i].creditDescription : null,
        branch_id: branch_id || null,
        employee_id: this.creditsides[i].employee_id ?? null   // ✅ ADD THIS
      });
    }

    const postData = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      narration: this.narration ? this.narration : null,
      date: this.date,
      // upload:this.base64File,
      // upload: this.uploadedFiles,
      existing_uploads: this.existingFiles || [],   // already uploaded files
      new_uploads: this.uploadedFiles || [],  
      total_dr: this.calculateTotalDebit(),
      total_cr: this.calculateTotalCredit(),
      cr: voucherCr,
      dr: voucherDr,
    };
    return postData;
  }

  onSave(isApproval: boolean = false): void {
    console.log('voucher type', this.voucherType);
    if (!this.voucherType) {
      alert('Please select a voucher type');
      return;
    }
    if (!this.date) {
      alert('Please select a date');
      return;
    }
    if(!this.narration){
      alert('Please enter Narration Before Submiting');
      return;
    }
    if (this.voucher_type === 'Advance Multibranch') {
      this.mismatchedSerialNo = [];
      const allSerialNumbers = new Set([
        ...this.debitsides.map(d => d.serialNumber),
        ...this.creditsides.map(c => c.debitSerialNumber)
      ]);

      allSerialNumbers.forEach(serialNo => {
        const totalDebitAmount = this.debitsides
          .filter(debitSide => String(debitSide.serialNumber) === String(serialNo))
          .reduce((sum, debitSide) => sum + (Number(debitSide.debitAmount) || 0), 0);

        const totalCreditAmount = this.creditsides
          .filter(creditSide => String(creditSide.debitSerialNumber) === String(serialNo))
          .reduce((sum, creditSide) => sum + (Number(creditSide.creditAmount) || 0), 0);

        if (totalDebitAmount !== totalCreditAmount) {
          this.mismatchedSerialNo.push(serialNo);
        }
      });

      if (this.mismatchedSerialNo.length > 0) {
        alert(`SL.No(s) ${this.mismatchedSerialNo.join(', ')} credit side and debit side amounts must be the same.`);
        return;
      }
    }
    const totalDebit = this.calculateTotalDebit();
    const totalCredit = this.calculateTotalCredit();

    if (totalDebit !== totalCredit) {
      alert('Total debit does not match total credit!');
      return;
    }
    if (this.debitsides.some(side => !side.debitLedgerType)) {
      alert('Please select a ledger for all debit entries');
      return;
    }
    if (this.creditsides.some(side => !side.creditLedgerType)) {
      alert('Please select a ledger for all credit entries');
      return;
    }
    if (this.showinterbranch && this.creditsides.some(side => !side.toBranch)) {
      alert('Please select a Branch in credit sides before saving.');
      return;  // Stop the save operation
    }
    if (this.showinterbranch && this.debitsides.some(side => !side.fromBranch)) {
      alert('Please select a Branch in debit sides before saving.');
      return;  // Stop the save operation
    }
    if (this.showinterbranch && this.creditsides.some(side => !side.debitSerialNumber)) {
      alert('Please select a SL.No in credit sides before saving.');
      return;  // Stop the save operation
    }
    if (this.showinterbranch && this.debitsides.some(side => !side.serialNumber)) {
      alert('Please Enter a SL.No in debit sides before saving.');
      return;  // Stop the save operation
    }



    const voucherDr = [];
    const branchIds = [];
    for (let i = 0; i < this.debitsides?.length; i++) {
      const ledgerData = this.ledger_data.get(this.debitsides[i].fromBranch);
      let selectedLedger = null;
      if (ledgerData) {
        selectedLedger = ledgerData.find(ledger => ledger.id === this.debitsides[i].debitLedgerType);
      }
      const branch_id = selectedLedger?.branch_id ?? null;
      if (branch_id !== null) {
        branchIds.push(branch_id);
      }
      voucherDr.push({
        sl_no:this.debitsides[i].serialNumber ?? null,
        ledger_id: this.debitsides[i].debitLedgerType ?? null,
        amount: this.debitsides[i].debitAmount ?? null,
        description: this.debitsides[i].debitDescription ?? null,
        branch_id: this.debitsides[i].fromBranch,
        employee_id: this.debitsides[i].employee_id ?? null
      });
    }

    //loop for voucher cr
    const voucherCr = [];
    for (let i = 0; i < this.creditsides?.length; i++) {
      const ledgerData = this.ledger_datas.get(this.creditsides[i].toBranch);
      let selectedLedger = null;
      if (ledgerData) {
        selectedLedger = ledgerData.find(ledger => ledger.id === this.creditsides[i].creditLedgerType);
      }
      const branch_id = selectedLedger?.branch_id ?? null;
      if (branch_id !== null) {
        branchIds.push(branch_id);
      }
      voucherCr.push({
        sl_no: this.creditsides[i].debitSerialNumber ? this.creditsides[i].debitSerialNumber : null,
        ledger_id: this.creditsides[i].creditLedgerType ? this.creditsides[i].creditLedgerType : null,
        amount: this.creditsides[i].creditAmount ? this.creditsides[i].creditAmount : null,
        description: this.creditsides[i].creditDescription ? this.creditsides[i].creditDescription : null,
        branch_id: this.creditsides[i].toBranch,
        employee_id: this.creditsides[i].employee_id ?? null
      });
    }

    const postData = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      narration: this.narration ? this.narration : null,
      date: this.date,
      branch_id:this.branch??null,
      // upload:this.base64File,
      // upload: this.uploadedFiles,
      existing_uploads: this.existingFiles || [],   // already uploaded files
      new_uploads: this.uploadedFiles || [],  
      total_dr: this.calculateTotalDebit(),
      total_cr: this.calculateTotalCredit(),
      frombranch: branchIds,
      tobranch: branchIds,
      cr: voucherCr,
      dr: voucherDr,
      profit_cost_id: this.profit_cost_id || null,
      section_id: this.section_id || null,
      store_id: this.store_id || null,
      // employee_ids: this.selectedEmployees?.map(emp => emp.id) || []
      employee_ids:this.selectedEmployees|| null
    };
    console.log(postData);
    if (this.data?.id) {
      this.apiService.updateVoucherPosting(this.data.id, postData).subscribe(
        response => {
          console.log('Voucher updated successfully:');
          if (isApproval) {
            this.sendForApprove(true);
          } else {
            this.dialogRef.close(response);
          }
        },
        error => {
          console.error('Error updating voucher:', error);
        }
      );
    } else {
      this.apiService.createVoucherPosting(postData).subscribe(
        response => {
          console.log('Voucher Posting successfully:');
          this.dialogRef.close(response);
        },
        error => {
          console.error('Error posting voucher:', error);
        }
      );
    }
  }
  duplicateVoucher() {
    const { id, type, ...rest } = this.data;
    const dialogRef = this.dialog.open(CreateVoucherPostingDialogComponent, {
      width: '95%',
      height: '95%',
      maxWidth: '100%',
      data: {
        ...rest,
        voucherType: this.voucherType,
        date: this.date,
        branch_id: this.branch,
        narration: this.narration,
        profit_cost_id: this.profit_cost_id,
        section_id: this.section_id,
        store_id: this.store_id,
        // debitSides: this.debitsides,
        // creditSides: this.creditsides,
        voucherNo: null,
        type: 'create',
        operationType: 'create',
        isDuplicate: true,
        originalVoucherId: id,
        debitSides: this.debitsides.map(d => ({ ...d, amount: d.debitAmount, description: d.debitDescription })),
        creditSides: this.creditsides.map(c => ({ ...c, amount: c.creditAmount, description: c.creditDescription })),
        selectedEmployees: this.selectedEmployees,  
        uploadedFiles: this.data.uploadedFiles || this.data.images || [],
        is_audit: this.data.is_audit
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log("Duplicate voucher created:", result);
        this.dialogRef.close(result);
      }
    });
  }


  // trackByFn(index: number, item: any): any {
  //   return index;
  // }
  checkUserRole(): void {
    if (this.role_id == 1) {
      this.showallColumn();
    } else {
      this.hideallColumn();
    }
  }
  showallColumn(): void {
    this.showDesign = true;
  }
  hideallColumn(): void {
    this.showDesign = false;
  }
  
  updateDebitSerialNumbers() {
    this.debitsides.forEach((side, i) => side.serialNumber = i + 1);
  }

  updateCreditSerialNumbers() {
    this.creditsides.forEach(creditSide => {
      if (creditSide.debitSerialNumber && !this.debitsides.find(debitSide => debitSide.serialNumber === creditSide.debitSerialNumber)) {
        creditSide.debitSerialNumber = null;
      }
    });
  }
  onDebitSerialNumberChange(creditSide: any) {
    const selectedSerialNumber = creditSide.debitSerialNumber;
    const matchingDebitSide = this.debitsides.find(side => side.serialNumber === selectedSerialNumber);
    if (matchingDebitSide) {
      creditSide.creditAmount = matchingDebitSide.debitAmount;
      creditSide.toBranch = null;
      creditSide.creditLedgerType = null;
      creditSide.creditDescription = null;
    }
  }
  onDebitAmountChange(debitSide: any) {
    if (this.voucher_type === 'Inter Branch') {
      const selectedSerialNumber = debitSide.serialNumber;
      const matchingCreditSide = this.creditsides.find(side => side.debitSerialNumber === selectedSerialNumber);
      if (matchingCreditSide) {
        matchingCreditSide.creditAmount = debitSide.debitAmount;
      }
    }
  }
  resetDebitSerialNumber(side: any) {
    side.debitSerialNumber = null;
    this.onDebitSerialNumberChange(side);
    side.creditAmount = null;
    side.creditLedgerType = null;
    side.toBranch = null;
  }
  openPostingView(): void {
    const dialogRef = this.dialog.open(CreateVoucherPostingViewComponent, {
      width: '1200px',
      height: '550px',
      data: { postData: this.createpostdata() } // Pass the postData here
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dialog closed with result:', result);
      }
    });
  }
  getAvailableDebitSides(currentCreditSide: any): any[] {
    console.log('debitside', this.debitsides);
    console.log('creditside', this.creditsides);
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    if (selectedVoucher.voucher_type == 'Inter Branch') {
      const selectedDebitSerialNumbers = this.creditsides
        .filter(side => side.debitSerialNumber && side !== currentCreditSide)
        .map(side => side.debitSerialNumber);
      return this.debitsides.filter(debitSide => !selectedDebitSerialNumbers.includes(debitSide.serialNumber));
    } else {
      // return this.debitsides;
      const uniqueDebitsides = this.debitsides.filter((obj, index, self) =>
        index === self.findIndex((item) => item.serialNumber === obj.serialNumber)
      );
      console.log('unique sl no', uniqueDebitsides);
      return uniqueDebitsides;
    }
  }
  getOriginalItem(item: any) {
    for (const group of this.combinedDropdownData) {
      const match = group.items.find(x => x.id === item.id);
      if (match) {
        return match;
      }
    }
    return item;
  }
  openproductView(index: number): void {
    const productToEdit = this.productEntries[index];
    // const selectedVendor = this.vendorData.find(vendor => vendor.id === this.vendor);
    // const selectedVendorName = selectedVendor?.vendor_name || '';
    // const selectedVendorLedgerId = selectedVendor?.ledger_id || null;
    // const selectedVendorLedgerName = selectedVendor?.ledger_name || '';
    // const selectedCustomer = this.customerData.find(customer => customer.id === this.customer);
    // const selectedCustomerName = selectedCustomer?.customer_name || '';
    // const selectedCustomerLedgerId = selectedCustomer?.ledger_id || null;
    // const selectedCustomerLedgerName = selectedCustomer?.ledger_name || '';
    const selectedVendorBranch = Array.isArray(this.vendorBranchData)
      ? this.vendorBranchData.find(
        (branch: any) => branch.id === this.selectedVendorBranch
      )
      : null;
    const selectedMap = selectedVendorBranch?.vendorbranch_map?.find(
      (map: any) => map.company_branch_id === this.branch
    );
    const selectedVendorBranchName = selectedVendorBranch?.branch_name || '';
    const selectedVendorBranchLedgerId = selectedMap?.ledger_id || null;
    const selectedVendorBranchLedgerName = selectedMap?.ledger?.ledger_name || '';
    const selectedCustomerBranch = Array.isArray(this.customerBranchData)
      ? this.customerBranchData.find(branch => branch.id === this.selectedCustomerBranch)
      : null;
    const selectedCustomerBranchName = selectedCustomerBranch ? selectedCustomerBranch.branch_name : '';
        let selectedCustomerBranchLedgerId: number | null = null;
    let selectedCustomerBranchLedgerName: string = '';

    if (selectedCustomerBranch && Array.isArray(selectedCustomerBranch.customerbranch_map)) {
      const matchedMapping = selectedCustomerBranch.customerbranch_map.find(
        mapping => mapping.company_branch_id === this.branch
      );

      if (matchedMapping && matchedMapping.ledger) {
        selectedCustomerBranchLedgerId = matchedMapping.ledger_id;
        selectedCustomerBranchLedgerName = matchedMapping.ledger.ledger_name;
      }
    }

    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    const selectedVoucherType = selectedVoucher?.voucher_type || '';
    const gstLedgers = [];
    this.productList.forEach(product => {
      product.details.forEach(detail => {
        const gstLedger = this.tax.find(item => item.global_gst_id === detail.hsn_sac?.gst_id);
          gstLedgers.push(gstLedger);
      });
    });
        let dialogData: any;
    const correctedEntries = this.productEntries.map(entry => {
      return {
        ...entry,
        productType: this.getOriginalItem(entry.productType)
      };
    });
    if (this.selectedGrn?.some(grn => grn !== null) || this.selectedGsn?.some(gsn => gsn !== null)) {     // purchase/sales
      dialogData = {
        branch_id: this.branch,
        grn: this.selectedGrn,
        gsn: this.selectedGsn,
        productOptions: this.productList,
        totalDiscount: this.getTotaldiscount2(),
        totalAmount: this.getTotalAmount2(),
        totalGSTAmount: this.getTotalGSTAmount2(),
        productList: this.productList,
        taxledger: gstLedgers,
        total_cr: this.totalcredit2(),
        total_dr: this.getTotalRoundedAmount2(),
        round_up: Math.abs(this.roundedamount2) || null,
        round_label: this.roundedamount2 < 0 ? 'Down' : 'Up',
        rounded_ledger: this.roundedledgername2(),
        voucher: selectedVoucherType,
        gstMatch: this.gstMatch(),
        gst_type: this.vendorBranchGstType,
        voucher_id: this.voucherType
      };
    } else {
      dialogData = {
        branch_id: this.branch,
        productOptions: this.combinedDropdownData,
        totalDiscount: this.getTotaldiscount(),
        totalAmount: this.getTotalAmount(),
        totalGSTAmount: this.getTotalGSTAmount(),
        // productEntries: this.productEntries,
        productEntries: correctedEntries,
        taxledger: this.tax,
        total_cr: this.totalcredit(),
        total_dr: this.getTotalRoundedAmount(),
        round_up: this.roundedamount || null,
        rounded_ledger: this.roundedledgername(),
        voucher: selectedVoucherType,
        round_label: this.roundedamount < 0 ? 'Down' : 'Up',
        gstMatch: this.gstMatch(),
      };
    }
    if (selectedVoucherType === 'Sales') {
      Object.assign(dialogData, {
        selectedCustomerBranch: selectedCustomerBranchName,
        selectedCustomerBranchLedgerId: selectedCustomerBranchLedgerId,
        selectedCustomerBranchLedgerName: selectedCustomerBranchLedgerName
      });
    }
    if (selectedVoucherType === 'Purchase') {
      Object.assign(dialogData, {
        selectedVendorBranch: selectedVendorBranchName,
        selectedVendorBranchLedgerId: selectedVendorBranchLedgerId,
        selectedVendorBranchLedgerName: selectedVendorBranchLedgerName
      });
    }
    this.dialog.open(CreateProductViewDialogComponent, {
      width: '1200px',
      height: '550px',
      data: dialogData
    });
  }
  // fetchData() {
  //   this.apiService.getDataLedger().subscribe(
  //     (response) => {
  //       this.rounded_ledger = response.ledger_data;
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // } 
  fetchhsnno(data: any) {
    this.apiService.gethsnno(data,this.voucher_type).subscribe(
      (response) => {
        this.hsn_no = response.hsn_no;
        this.ledger_name = response.ledger_name;
        this.ledger_id = response.ledger_id;
        this.unit = response.unit_name;
        this.selectedDescription = response.description;
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }
  // customerdata(data: any) {
  //   this.apiService.showCustomerById(data).subscribe(
  //     (response) => {
  //       console.log('customer_details',response);
  //       this.customer_name = response.customer_name;
  //       this.customer_email = response.email;
  //       this.customer_phone = response.phone;
  //       this.customer_address = response.address;
  //       this.customer_gstno = response.gst_number;
  //       this.customer_pan = response.pan;
  //       // this.customer_branch_gst = response.customer_branch?.gst_number ?? '';
  //       // this.gst_type = response.customer_branch?.gst_type
          
  //     },
  //     (error) => {
  //       console.error('Error fetching customerdata:', error);
  //     }
  //   );
  // }
  fetchcompany(data: any) {
    this.apiService.Companydetails(data).subscribe(
      (response) => {
        console.log('company_details',response);
        this.company_name = response.name;
        this.company_email = response.email;
        this.company_phone = response.phone_no;
        this.company_address = response.address;
        this.company_gstno = response.gst_reg_no;
        this.company_pan = response.pan_no;
        this.company_cin = response.cin_no;
        this.company_logo = response.company_logo ? `${this.fullhostname}/api/storage/uploads/${response.company_logo}` : '';
        this.company_signature = response.company_signature ? `${this.fullhostname}/api/storage/uploads/${response.company_signature}`: '';
        this.price_policy = response.is_price_policy;
        this.is_pi_si_manual = response.is_pi_si_manual;
        console.log('is_pi_si_manual',this.is_pi_si_manual);
        console.log('company logo',this.company_logo);
        console.log('company signature',this.company_signature);
      },
      (error) => {
        console.error('Error fetching  companydata:', error);
      }
    );
  }
  fetchtaxData() {
    this.apiService.getGst().subscribe(
      (response) => {
        this.tax = response;
        },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  fetchCombinedData() {
    this.adminService.getGlobalItem().subscribe(
      (skuResponse) => {
        this.apiService.getService().subscribe(
          (serviceResponse) => {
            this.combinedDropdownData = [
              { category: 'SKU', items: skuResponse.data.map(item => ({ ...item, type: 'SKU' })) },
              { category: 'Service', items: serviceResponse.map(item => ({ ...item, type: 'Service' })) }
            ];
            console.log(this.combinedDropdownData);
          },
          (error) => {
            console.error('Error fetching service data:', error);
          }
        );
      },
      (error) => {
        console.error('Error fetching SKU data:', error);
      }
    );
  }
  onSelectionChange(selected: any) {
    console.log('selecteddddddddddddddd',selected);
    console.log('store_id',this.store_id_for_items);
    if (selected.type === 'SKU') {
      this.apiService.getSku(this.store_id_for_items,selected.id).subscribe(
        (response) => {
          console.log('responseeeeeeeeee',response);
          this.selectedItem = response[0];
          this.selectedItem.type = 'SKU';
           this.fetchhsnno(this.selectedItem);
      
          },
        (error) => {
          console.error('Error fetching data:', error);
        }
      );
    } else {
      this.selectedItem = selected;
      this.fetchhsnno(this.selectedItem);
    }
    // this.selectedItem = selected;
   this.fetchtaxData();
  }
  addProduct() {
    if (this.selectedItem && this.unit && this.selectedQty !== null && this.selectedUnitPrice !== null && this.selectedTaxType) {
      this.productEntries.push({
        productType: this.selectedItem,
        hsn_no: this.hsn_no,
        description: this.selectedDescription || null,
        unit: this.unit,
        ledger_name: this.ledger_name,
        ledger_id: this.ledger_id,
        qty: this.selectedQty.toFixed(3),
        unitPrice: this.selectedUnitPrice,
        discount: this.selectedDiscount !== null ? this.selectedDiscount : 0,
        taxType: this.selectedTaxType,
      });
      // Reset form fields after adding the product
      this.selectedItem = null;
      this.hsn_no = null;
      this.selectedDescription = '';
      this.unit = null;
      this.ledger_name = '';
      this.ledger_id = null;
      this.selectedQty = null;
      this.selectedUnitPrice = null;
      this.selectedDiscount = null;
      this.selectedTaxType = null;
    } else {
      alert('Please fill out all required fields before adding the product.');
    }
  }
  editProduct(index: number) {
    const productToEdit = this.productEntries[index];
    const dialogRef = this.dialog.open(CreateProductEditDialogComponent, {
      width: '1200px',
      height: '550px',
      data: {
        product: productToEdit,
        index: index,
        productOptions: this.product,
        taxOptions: this.tax
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.productEntries[result.index] = result.product;
      }
    });
  }
  deleteProduct(index: number) {
    this.productEntries.splice(index, 1);
  }
  // fetchvendorData() {
  //   this.apiService.getVendor().subscribe(
  //     (response) => {
  //       this.vendorData = response;
  //       const selectedVendor = this.vendorData.find(vendor => vendor.id === this.vendor);
  //       if (selectedVendor) {
  //         selectedVendor.ledger_id = selectedVendor.ledger_id;
  //         selectedVendor.ledger_name = selectedVendor.ledger_name;
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }
  // fetchCustomerData() {
  //   this.apiService.getCustomer().subscribe(
  //     (response) => {
  //       this.customerData = response;
  //       const selectedCustomer = this.customerData.find(customer => customer.id === this.customer);
  //       if (selectedCustomer) {
  //         selectedCustomer.ledger_id = selectedCustomer.ledger_id;
  //         selectedCustomer.ledger_name = selectedCustomer.ledger_name;
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }
  showpurchesvoucherdesign() {
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    this.showPurchesDesign = selectedVoucher && (selectedVoucher.voucher_type === 'Purchase' || selectedVoucher.voucher_type === 'Sales');
    this.showPurches = this.showPurchesDesign;
    this.isPurchase = selectedVoucher && selectedVoucher.voucher_type === 'Purchase';
    this.isSales = selectedVoucher && selectedVoucher.voucher_type === 'Sales';
  }
  
  getProductTypeName(product: any): string {
    if (!product) return '';
    if(this.data.id){
        return product.name;
    }else{
      if (product.type === 'SKU') {
        return product.sku_name;
      } else if (product.type === 'Service') {
        return product.service_name;
      }
    }
    return '';
  }
  getTaxPercentage(taxTypeId: number): number {
    const selectedTax = this.tax.find(item => item.global_gst_id === taxTypeId);
    return selectedTax ? selectedTax.gst_percentage : 0;
  }
  getCGSTPercentage(taxTypeId: number): number {
    const gstPercentage = this.getTaxPercentage(taxTypeId);
    return gstPercentage / 2;
  }
  getSGSTPercentage(taxTypeId: number): number {
    const gstPercentage = this.getTaxPercentage(taxTypeId);
    return gstPercentage / 2;
  }
  getIGSTPercentage(taxTypeId: number): number {
    const gstPercentage = this.getTaxPercentage(taxTypeId);
    return gstPercentage;
  }
  getTotaldiscount(): number {
    return this.productEntries.reduce((totalDiscount, entry) => {
      const totalPrice = entry.qty * entry.unitPrice;
      const discountAmount = totalPrice * (entry.discount / 100);
      return totalDiscount + discountAmount;
    }, 0);
  }
  getTotaldiscount2(): number {
    return this.productList.reduce((totalDiscount, product) => {
      return totalDiscount + product.details.reduce((detailDiscount, detail) => {
        const totalPrice = this.selectedGrn.length !==0 ? detail.receive_qty * detail.unit_price : detail.send_qty * detail.unit_price;
        const discountAmount = totalPrice * (0 / 100);
        return detailDiscount + discountAmount;
      }, 0);
    }, 0);
  }
  getTotalDiscountAmount(): number {
    return this.productList.reduce((total, product) => {
        return total + product.details.reduce((subTotal: number, detail: any) => subTotal + (Number(detail.discount_amount) || 0), 0);
    }, 0);
  }   

  getTotalInceptiveAmount(): number {
    return this.productList.reduce((total, product) => {
        return total + product.details.reduce((subTotal: number, detail: any) => subTotal + (Number(detail.incentive_amount) || 0), 0);
    }, 0);
  }
  getTotalGSTAmount(): number {
    return this.productEntries.reduce((total, entry) => {
      const value = entry.qty * entry.unitPrice;
      const discount = value * (entry.discount / 100);
      const taxableValue = value - discount;
      const cgst = taxableValue * this.getCGSTPercentage(entry.taxType) / 100;
      const sgst = taxableValue * this.getSGSTPercentage(entry.taxType) / 100;
      return total + cgst + sgst;
    }, 0);
  }
  getTotalGSTAmount2(): number {
    if (this.vendorBranchGstType !== 'REGISTER') return 0;
    if (this.vendorBranchGstType === 'REGISTER') {
      return this.productList.reduce((total, product) => {
        const productGST = product.details.reduce((detailGST, detail) => {
          const value = this.selectedGrn.length !== 0 ? detail.receive_qty * detail.unit_price : (detail.send_qty * detail.unit_price)-detail.discount_amount+detail.incentive_amount;
          const gstLedger = this.tax.find(item => item.global_gst_id === detail.hsn_sac.gst_id);
          //if (!gstLedger) return 0;
          const discount = value * (0 / 100);
          const taxableValue = value - discount;
          const cgst = (taxableValue * this.getCGSTPercentage(gstLedger?.global_gst_id)) / 100;
          const sgst = (taxableValue * this.getSGSTPercentage(gstLedger?.global_gst_id)) / 100;
          return detailGST + cgst + sgst;
        }, 0);
        return total + productGST;
      }, 0);
    }
  }
  productTaxAmount(entry: any) {
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType !== 'REGISTER') return 'NA';
    const value = entry.qty * entry.unitPrice;
    const discount = value * (entry.discount / 100);
    const taxableValue = value - discount;
    const cgst = taxableValue * this.getCGSTPercentage(entry.taxType) / 100;
    const sgst = taxableValue * this.getSGSTPercentage(entry.taxType) / 100;
    return cgst + sgst;
  }
  productTaxAmount2(detail: any) {
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType !== 'REGISTER') return 'NA';
    let value = 0;
    const gstLedger = this.tax.find(item => item.global_gst_id === detail.hsn_sac.gst_id);
    if (!gstLedger) return 0;
    value = this.selectedGrn.length !==0 ? detail.receive_qty * detail.unit_price : (detail.send_qty * detail.unit_price)-detail.discount_amount+detail.incentive_amount;
    const discount = value * (0 / 100);
    const taxableValue = value - discount;
    const cgst = taxableValue * this.getCGSTPercentage(gstLedger?.global_gst_id) / 100;
    const sgst = taxableValue * this.getSGSTPercentage(gstLedger?.global_gst_id) / 100;
    return cgst + sgst;
  }
  lineItemCgstAmount(detail: any){
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && this.gstMatch()) {
    let value = 0;
    const gstLedger = this.tax.find(item => item.global_gst_id === (detail.taxType || detail.gst_id));
     let qtyToUse = detail.qty || 0;
      if (this.invoice_type === 'sales') {
        qtyToUse = detail.change_qty || 0;
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.final_discount) || 0) + (Number(detail?.final_incentive) || 0);
      }else if (this.invoice_type === 'credit note') {
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.discount_amount || 0)) + (Number(detail?.incentive_amount) || 0);
      } else {
        value = qtyToUse * (detail.unitPrice || detail.unit_price || 0);
      }
    const discountPercentage = detail.discount || 0;
    const discount = value * (discountPercentage / 100);
    const taxableValue = value - discount;
    if(this.invoice_type ){
      const cgst = taxableValue * (detail.gst_percentage/2) / 100;
      return cgst
    }else {
      const cgst = taxableValue * this.getCGSTPercentage(gstLedger.global_gst_id) / 100;
      return cgst
    }
    }
    return 0;
  }
  lineItemSgstAmount(detail: any){
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && this.gstMatch()) {
    let value = 0;
    const gstLedger = this.tax.find(item => item.global_gst_id === (detail.taxType || detail.gst_id));
      let qtyToUse = detail.qty || 0;
      if (this.invoice_type === 'sales') {
        qtyToUse = detail.change_qty || 0;
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.final_discount) || 0) + (Number(detail?.final_incentive) || 0);
      }else if (this.invoice_type === 'credit note') {
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.discount_amount || 0)) + (Number(detail?.incentive_amount) || 0);
      } else {
        value = qtyToUse * (detail.unitPrice || detail.unit_price || 0);
      }
    const discountPercentage = detail.discount || 0;
    const discount = value * (discountPercentage / 100);
    const taxableValue = value - discount;
     if(this.invoice_type ){
      const sgst = taxableValue * (detail.gst_percentage/2) / 100;
      return sgst
    }else{
      const sgst = taxableValue * this.getSGSTPercentage(gstLedger.global_gst_id) / 100;
    return sgst
    }
  }
   return 0;
}
  lineItemIgstAmount(detail: any) {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && !this.gstMatch()) {
      let value = 0;
      let qtyToUse = detail.qty || 0;
      if (this.invoice_type === 'sales') {
        qtyToUse = detail.change_qty  || 0;
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.final_discount) || 0) + (Number(detail?.final_incentive) || 0);
      }else if (this.invoice_type === 'credit note') {
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.discount_amount || 0)) + (Number(detail?.incentive_amount) || 0);
      } else {
        value = qtyToUse * (detail.unitPrice || detail.unit_price || 0);
      }
      const gstLedger = this.tax.find(item => item.global_gst_id === (detail.taxType || detail.gst_id));
      if (!this.invoice_type && !gstLedger) return 0;
      const discountPercentage = detail.discount || 0;
      const discount = value * (discountPercentage / 100);
      const taxableValue = value - discount;
      if(this.invoice_type ){
        const igst = taxableValue * (detail.gst_percentage) / 100;
        return igst
      }else{
        const igstPercent = this.getIGSTPercentage(gstLedger.global_gst_id) || 0;
        const igst = (taxableValue * igstPercent) / 100;
        return igst;
      }
    }
    return 0;
  }

  lineItemTotalGstAmount(detail: any): any {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    const cgst = this.lineItemCgstAmount(detail);
    const sgst = this.lineItemSgstAmount(detail);
    const igst = this.lineItemIgstAmount(detail);
    let total = 0;
    if (cgst !== 'NA') total += Number(cgst) || 0;
    if (sgst !== 'NA') total += Number(sgst) || 0;
    if (igst !== 'NA') total += Number(igst) || 0;
    return total.toFixed(2);
  }

  getTotalGSTForDetails(details: any[]): number {
    if (!details) return 0;
    return details.reduce((total, detail) => {
      const gst = this.lineItemTotalGstAmount(detail);
      return total + (gst === 'NA' ? 0 : Number(gst) || 0);
    }, 0);
  }

  cgstAmount(detail: any): string | number {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && this.gstMatch()) {
      const value = this.selectedGrn.length !== 0
        ? detail.receive_qty * detail.unit_price
        : (detail.send_qty * detail.unit_price)-detail.discount_amount+detail.incentive_amount;
      const gstLedger = this.tax.find((item: any) => item?.global_gst_id === detail.hsn_sac?.gst_id);
      if (!gstLedger) return 0;
      const cgstPercent = this.getCGSTPercentage(gstLedger?.global_gst_id) || 0;
      const cgstAmount = (value * cgstPercent) / 100;
      // console.log('CGST Amount:', cgstAmount);
      return cgstAmount.toFixed(2);
    }
    return 0;
  }

  sgstAmount(detail: any): string | number {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && this.gstMatch()) {
      const value = this.selectedGrn.length !== 0
        ? detail.receive_qty * detail.unit_price
        : (detail.send_qty * detail.unit_price)-detail.discount_amount+detail.incentive_amount;
      const gstLedger = this.tax.find((item: any) => item.global_gst_id === detail.hsn_sac?.gst_id);
      if (!gstLedger) return 0;
      const sgstPercent = this.getSGSTPercentage(gstLedger?.global_gst_id) || 0;
      const sgstAmount = (value * sgstPercent) / 100;
      return sgstAmount.toFixed(2);
    }
    return 0;
  }

  igstAmount(detail: any): string | number {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && !this.gstMatch()) {
      let value = this.selectedGrn.length !== 0
        ? detail.receive_qty * detail.unit_price
        : (detail.send_qty * detail.unit_price)-detail.discount_amount+detail.incentive_amount;
      const gstLedger = this.tax.find((item: any) => item.global_gst_id === detail.hsn_sac?.gst_id);
      if (!gstLedger) return 0;
      const igstPercent = this.getIGSTPercentage(gstLedger?.global_gst_id) || 0;
      const igstAmount = (value * igstPercent) / 100;
      return igstAmount.toFixed(2);
    }
    return 0;
  }

  gstMatch(): boolean {
    if (!Array.isArray(this.branchdata)) {
      return false;
    }
    const selectedBranch = this.branchdata.find(
      (branch: any) => branch.id === this.branch
    );
    const branchGstFirst2 = selectedBranch?.gst?.substring(0, 2);
    let otherBranchGstFirst2: string | undefined;
    if (this.voucher_type === 'Purchase') {
      if (!Array.isArray(this.vendorBranchData)) {
        return false;
      }
      const selectedVendorBranch = this.vendorBranchData.find(
        (vendorBranch: any) => vendorBranch.id === this.selectedVendorBranch
      );
      otherBranchGstFirst2 = selectedVendorBranch?.gst_number?.substring(0, 2);
    }
    else if (this.voucher_type === 'Sales') {
      if (!Array.isArray(this.customerBranchData)) {
        return false;
      }
      const selectedCustomerBranch = this.customerBranchData.find(
        (customerBranch: any) => customerBranch.id === this.selectedCustomerBranch
      );
      otherBranchGstFirst2 = selectedCustomerBranch?.gst_number?.substring(0, 2);
    } else if (this.invoice_type === 'purchase' || this.invoice_type === 'debit note') {
      otherBranchGstFirst2 = this.vendor_branch_gst?.substring(0, 2);
      console.log("otherBranchGstFirst2", otherBranchGstFirst2);
    } else if (this.invoice_type === 'sales' || this.invoice_type === 'credit note') {
      otherBranchGstFirst2 = this.customer_branch_gst?.substring(0, 2);
      console.log("otherBranchGstFirst2", otherBranchGstFirst2);
    }
      
    if (!branchGstFirst2 || !otherBranchGstFirst2) {
      // console.warn('GST number missing for one of the branches.');
      return false;
    }
    return branchGstFirst2 === otherBranchGstFirst2;
  }
  getTotalAmount(): number {
    return this.productEntries.reduce((total, entry) => {
      const value = entry.qty * entry.unitPrice;
      const discount = entry.discount_amount;
      const incentive = entry.incentive_amount;
      const taxableValue = (value - discount) + incentive;
      return total + taxableValue;
    }, 0);
  }
  getTotalAmount2(): number {
    return this.productList.reduce((total, product) => {
      const productTotal = product.details.reduce((detailTotal, detail) => {
        const value = this.selectedGrn.length !==0 ? detail.receive_qty * detail.unit_price : detail.send_qty * detail.unit_price;
        const discount = detail.discount_amount;
        const incentive = detail.incentive_amount;
        const taxableValue = (value - discount) + incentive;
        return detailTotal + taxableValue;
      }, 0);
      return total + productTotal;
    }, 0);
  }
  // getTaxledger(taxTypeId: number): number {
  //   const selectedTax = this.tax.find(item => item.global_gst_id === taxTypeId);
  //   return selectedTax ? selectedTax.ledger.ledger_id : null;
  // }
  getGSTAmount(entry: any): number {
    const value = entry.qty * entry.unitPrice;
    const discount = value * (entry.discount / 100);
    const taxableValue = value - discount;
    const cgst = taxableValue * this.getCGSTPercentage(entry.taxType) / 100;
    const sgst = taxableValue * this.getSGSTPercentage(entry.taxType) / 100;
    return cgst + sgst;
  }
  getdiscountvalue(entry: any){
    const value = entry.qty * entry.unitPrice;
    const discount = value * (entry.discount / 100);
    const taxableValue = value - discount;
    return taxableValue;
  }
  getdiscountvalue2(entry: any): number {
    const value = parseFloat(entry.qty) * parseFloat(entry.unit_price);
    const discountPercentage = entry.discount_amount|| 0;
    const discount = value * (discountPercentage / 100);
    return discount;
  }
  getTotalRoundedAmount(): number {
    const totalAmount =  this.getTotalAmount() + this.getTotalGSTAmount();
    return Math.ceil(totalAmount);
  }
  getTotalRoundedAmount2(): number {
    const roundedAmount2 = this.roundedamount2 ? this.roundedamount2 : 0;
    const totalAmount =  this.getTotalAmount2() + this.getTotalGSTAmount2();
     const finalAmount = totalAmount + roundedAmount2
  return finalAmount;
  }
  branchname(){
    const selectedVendorBranch = this.vendorBranchData.find(selectedVendorBranch => selectedVendorBranch.id === this.selectedVendorBranch);
    const selectedVendorBranchName = selectedVendorBranch ? selectedVendorBranch.branch_name : '';
    return selectedVendorBranchName;
  }
  roundedledgername(){
    const selectedledger = this.rounded_ledger_data.find(ledger => ledger.ledger_id === this.ledger);
    const selectedLedgerName = selectedledger ? selectedledger.ledger_name : '';
    return selectedLedgerName;
  }
  roundedledgername2(){
    const selectedledger = this.rounded_ledger_data.find(ledger => ledger.ledger_id == this.ledger);
    const selectedLedgerName = selectedledger ? selectedledger.ledger_name : '';
    return selectedLedgerName;
  }
  vendorBranchLedgerId() {
    const selectedVendorBranch = this.vendorBranchData.find(
      (branch: any) => branch.id === this.selectedVendorBranch
    );
    const selectedMap = selectedVendorBranch?.vendorbranch_map?.find(
      (map: any) => map.company_branch_id === this.branch
    );
    return selectedMap?.ledger_id || null;
  }
  customerBranchLedgerId() {
    let selectedCustomerBranchLedgerId: number | null = null;
    const selectedCustomerBranch = this.customerBranchData.find(
      branch => branch.id === this.selectedCustomerBranch
    );
    if (selectedCustomerBranch && Array.isArray(selectedCustomerBranch.customerbranch_map)) {
      const matchedMapping = selectedCustomerBranch.customerbranch_map.find(
        mapping => mapping.company_branch_id === this.branch
      );
      if (matchedMapping && matchedMapping.ledger) {
        selectedCustomerBranchLedgerId = matchedMapping.ledger_id;
      }
    }
    return selectedCustomerBranchLedgerId;
  }
  // getFormattedGSTAmount(entry: any): string {
  //   const gstAmount = this.getGSTAmount(entry);
  //   return gstAmount.toFixed(2);
  // }
  totalcredit(){
    const roundedAmount = this.roundedamount ? this.roundedamount : 0;
    const totalcr = this.getTotalAmount() + this.getTotalGSTAmount() + roundedAmount;
    return totalcr;
  }
  totalcredit2(){
    const roundedAmount2 = this.roundedamount2 ? this.roundedamount2 : 0;
    const totalcr = this.getTotalAmount2() + this.getTotalGSTAmount2();
    const finalAmount = totalcr + roundedAmount2
    return finalAmount;
  }
  onBranchChange() {
    this.vendor = [];
    this.selectedVendorBranch = [];
    this.customer = [];
    this.selectedCustomerBranch = [];
    this.ProfitCostData = [];

      if (this.branch) {
        const type = this.voucher_type == 'Purchase' ? 'vendor' : this.voucher_type == 'Sales' ? 'customer' : null;
        if (type) {
          this.apiService.getVendorCustomerByBranch(this.branch, type).subscribe(data =>
            type === 'vendor' ? this.vendorData = Array.isArray(data?.vendor) ? data.vendor.filter(v => v.vendor_branch) : [] : this.customerData = Array.isArray(data?.customer) ? (data.customer.filter(
    c => Array.isArray(c.customer_branch) && c.customer_branch.length >0)): []
          );
        }
      }
      this.fetchProfitCostData();
  }
  onBranchChangeWithLedger(branchId: any) {
    if (this.invoice_type) {
      this.onInvoiceTypeChange();
    } else {
      this.onBranchChange();
    }
    if (this.voucher_type !== 'Purchase' && this.voucher_type !== 'Sales') {
      this.getLedgerData();
      this.getLedgerDatas();
    }
  }
  onVendorChange(vendorId: number) {
    if (vendorId) {
      this.getVendorBranch(vendorId);
      this.fetchSectionData();
      // this.vendordata(vendorId);
      this.resetFields([
        'voucherType',
        'branch',
        'profit_cost_id',
        'vendor',
      ]);
    }
  }
  onVendorBranchChange() {
    this.resetFields([
      'voucherType',
      'branch',
      'profit_cost_id',
      'vendor',
      'selectedVendorBranch'
    ]);
  }
  onCustomerChange(CustomerId: number) {
    if (CustomerId) {
      this.getCustomerBranch(CustomerId);
      this.fetchSectionData();
      this.resetFields([
        'voucherType',
        'branch',
        'profit_cost_id',
        'customer',
      ]);
    }
  }
  onCustomerBranchChange(customerbranchId: any) {
    if (customerbranchId) {
      this.CustomerBranchdetails(customerbranchId);
    }
    this.resetFields([
      'voucherType',
      'branch',
      'profit_cost_id',
      'customer',
      'selectedCustomerBranch'
    ]);
  }

  getGroupedGstLedgers() {
  const groupedLedgers: { [ledgerId: number]: any } = {};
  const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
  if (!selectedVoucher) {
    console.warn("No matching voucher found.");
    return [];
  }
  for (const product of this.productList) {
    for (const detail of product.details) {
      const gstAmount = this.productTaxAmount2(detail);
       if (typeof gstAmount !== 'number' || isNaN(gstAmount)) continue;
      const gstId = detail.hsn_sac?.gst_id || 0;
      if (!gstId) continue;

      const tax = this.tax.find(t => t.global_gst_id === gstId);
      if (!tax) continue;

      for (const gstLedger of tax.gst_ledgers) {
        const requiredLedgerType = selectedVoucher.voucher_type === "Purchase" ? "receivable" : "payable";
        if (this.gstMatch()) {
          if (gstLedger.gst_type !== "CGST" && gstLedger.gst_type !== "SGST") continue;
        } else {
          if (gstLedger.gst_type !== "IGST") continue;
        }
        if (
          gstLedger.ledger_type === requiredLedgerType &&
          gstLedger.branch_id === this.branch
        ) {
          const ledgerId = gstLedger.ledger.id;
          const amountToAdd = this.gstMatch() ? gstAmount / 2 : gstAmount;
          if (groupedLedgers[ledgerId]) {
            groupedLedgers[ledgerId].gstAmount += amountToAdd;
          } else {
            groupedLedgers[ledgerId] = {
              gst_id: gstId,
              ledgerName: gstLedger.ledger.ledger_name,
              ledger_id: ledgerId,
              gstAmount: amountToAdd
            };
          }
        }
      }
    }
  }
  return Object.values(groupedLedgers);
}
  getGroupedLedgers(): { ledger_id: number | null, ledger_name: string, totalDiscountedAmount: number }[] {
    const ledgerMap = new Map<number | string, { ledger_id: number | null, ledger_name: string, totalDiscountedAmount: number }>();
    const correctedEntries = this.productEntries.map(entry => {
      return {
        ...entry,
        productType: this.getOriginalItem(entry.productType)
      };
    });
    for (const entry of correctedEntries) {
      const voucher = this.voucher_type;
      const type = entry.productType?.type;
      let ledgerId: number | null = null;
      let ledgerName = 'No ledger found';
      let match: any;
      if (voucher === 'Purchase' && type === 'SKU') {
        match = entry.productType?.sku_detail_maps?.find((map: any) => map.voucher_type === 'Purchase');
        ledgerName = match?.dr_ledger_name ?? 'No Purchase Sku ledger found';
        ledgerId = match?.dr_ledger ?? null;  
      } else if (voucher === 'Purchase' && type === 'Service') {
        match = entry.productType?.service_ledgr_map?.[0];
        ledgerName = match?.ledger?.ledger_name ?? 'No Purchase Service Ledger found';
        ledgerId = match?.ledger?.id ?? null;
      }
      if (voucher === 'Sales' && type === 'SKU') {
        match = entry.productType?.sku_detail_maps?.find((map: any) => map.voucher_type === 'Sales');
        ledgerName = match?.cr_ledger_name ?? 'No Sales Sku ledger found';
        ledgerId = match?.cr_ledger ?? null;
      } else if (voucher === 'Sales' && type === 'Service') {
        match = entry.productType?.service_ledgr_map?.[0];
        ledgerName = match?.ledger?.ledger_name ?? 'No Sales Service Ledger found';
        ledgerId = match?.ledger?.id ?? null;
      }
      const qty = entry.qty ?? 0;
      const unitPrice = entry.unitPrice ?? 0;
      const discount = entry.discount_amount ?? 0;
      const incentive = entry.incentive_amount ?? 0;
      const baseAmount = qty * unitPrice;
      const discountedAmount = baseAmount - discount+incentive;
      const key = ledgerId ?? 'null';
      if (ledgerMap.has(key)) {
        ledgerMap.get(key)!.totalDiscountedAmount += discountedAmount;
      } else {
        ledgerMap.set(key, {
          ledger_id: ledgerId,
          ledger_name: ledgerName,
          totalDiscountedAmount: discountedAmount
        });
      }
    }
    return Array.from(ledgerMap.values());
  }
  getGroupedGstDetails() {
    const groupedLedgers: { [key: number]: { ledger_id: number; totalAmount: number } } = {};
    console.log("productEntries", this.productEntries);
    this.productEntries.forEach((product: any) => {
      const gstDetailsArray = this.getGstLedgerDetails(product.taxType);
      console.log("gstDetailsArray", gstDetailsArray);
      gstDetailsArray.forEach(gstDetails => {
        const totalPrice = product.qty * product.unitPrice;
        console.log("totalPrice", totalPrice);
        const discountAmount = product?.discount_amount||0;
        console.log("discountAmount", discountAmount);
        const incentiveAmount = product?.incentive_amount||0;
        console.log("incentiveAmount", incentiveAmount);
        const discountedPrice = totalPrice - discountAmount + incentiveAmount;
        console.log("discountedPrice", discountedPrice);
        const gstAmount = (discountedPrice * gstDetails.gst_percentage) / 100;
        console.log("gstAmount", gstAmount);
        if (groupedLedgers[gstDetails.ledger_id]) {
          groupedLedgers[gstDetails.ledger_id].totalAmount += gstAmount;
          console.log("if groupedLedgers", groupedLedgers);
        } else {
          groupedLedgers[gstDetails.ledger_id] = {
            ledger_id: gstDetails.ledger_id,
            totalAmount: gstAmount,
          };
          console.log("else groupedLedgers", groupedLedgers);
        }
      });
    });
    return Object.values(groupedLedgers);
  }
  getGstLedgerDetails(taxType: number): { ledger_id: number; gst_percentage: number }[] {
    const gstLedger = this.tax.find(item => item.global_gst_id === taxType);
    if (!gstLedger) return [];
    const requiredLedgerType =
      this.voucher_type === 'Purchase'||(this.invoice_type === 'purchase' || this.invoice_type === 'debit note')  ? 'receivable' : 'payable';
    const isSameState = this.gstMatch();
    console.log("requiredLedgerType", requiredLedgerType);
    console.log("this.invoice_type", this.invoice_type);
    console.log("Is Same State:", isSameState);
    console.log("GST Ledger:", gstLedger.gst_ledgers);
    let gstLedgers = gstLedger.gst_ledgers.filter(
      ledger => ledger.ledger_type === requiredLedgerType && (!ledger.branch_id || ledger.branch_id == this.branch)
    );
    console.log("after filter GST Ledgers:", gstLedgers);
    if (isSameState) {
      return gstLedgers 
        .filter(l => l.gst_type === 'CGST' || l.gst_type === 'SGST')
        .map(l => ({
          ledger_id: l.ledger.id,
          gst_percentage: gstLedger.gst_percentage / 2
        }));
    } else {
      return gstLedgers
        .filter(l => l.gst_type === 'IGST')
        .map(l => ({
          ledger_id: l.ledger.id,
          gst_percentage: gstLedger.gst_percentage
        }));
    }
    
  }
  detail(isApproval: boolean = false): void {
    const hasGrnOrGsn = this.selectedGrn?.some(grn => grn !== null) || this.selectedGsn?.some(gsn => gsn !== null);
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);

  if (!this.voucherType) {
    alert('Please select a voucher');
    return;
  }
  if (!this.date) {
    alert('Please select a date');
    return;
  }
  if (selectedVoucher.voucher_type === 'Purchase') {
    if (!this.vendor) {
      alert('Please select a Vendor');
      return;
    }
  } else {
    if (!this.customer) {
      alert('Please select a Customer');
      return;
    }
  }
  if (!this.document_no) {
    alert('Please Select an External Document Number');
    return;
  }
  if (!this.issue_date) {
    alert('Please select a Document Date');
    return;
  }
  if (!this.purchesnarration) {
    alert('Please Enter Narration');
    return;
  }
  const totalDebit = this.getTotalRoundedAmount().toFixed(2);
  const totalCredit = this.totalcredit().toFixed(2);
  const totalDebit2 = this.getTotalRoundedAmount2().toFixed(2);
  const totalCredit2 = this.totalcredit2().toFixed(2);

  if (hasGrnOrGsn && totalDebit2 !== totalCredit2) {
    alert('Total debit does not match total credit!');
    return;
  }

  if (!hasGrnOrGsn && totalDebit !== totalCredit) {
    alert('Total debit does not match total credit!');
    return;
  }
  if (this.roundedamount2 && !this.ledger) {
    alert('Please select a Rounded Ledger.');
    return;
  }
    const filteredDetails = this.productList[0]?.details?.filter((d: any) => {
      return !this.fa_master?.some((fa: any) => fa.grn_details_id == d.id);
    });
  const faDetails = {
    fa_detail: this.productList[0]?.details[0]?.fa_template,
    branch_id: this.branch ?? null,
    // detail: this.productList[0]?.details,
    detail: filteredDetails,
  };
  if (this.productList[0]?.details[0]?.item_service_type === 'Fixed Asset' && this.operationType === 'create') {
    // Preserve current HSN/GST edits before re-fetching GRN data
    const hsnPreservationMap = new Map();
    this.productList.forEach(grn => {
      grn.details?.forEach(d => {
        const key = `${grn.id}_${d.item_service_type}_${d.item_service_type === 'Service' ? (d.service_id || d.service?.id) : d.sku_id}`;
        hsnPreservationMap.set(key, {
          hsn_no: d.hsn_no,
          hsn_sac: d.hsn_sac,
          taxType: d.taxType,
          specification: d.specification
        });
      });
    });

    const create_fa_master = (filteredDetails && filteredDetails.length > 0)
      ? of(null)
      : this.apiService.createFaMaster(faDetails);
    create_fa_master.pipe(
      tap((response: any) => {
        if (response) {
          const res = Array.isArray(response) ? response[0] : response;
          const status = res?.status ?? 'fail';
          const message = res?.message ?? 'Unknown server response';
          //  alert(message);
        }
        }),
        switchMap(() => this.apiService.getFaMaster()),
        tap((faResponse: any) => {
          this.fa_master = faResponse;
        }),
        switchMap(() => this.apiService.getGrnDetails(this.selectedGrn,this.selectedPiSection,this.profit_cost_id)),
        tap((grnResponse: any) => {
          const newData = grnResponse.data || [];
          newData.forEach(grn => {
            if (grn.details) {
              grn.details = grn.details.filter((d: any) => {
                if (this.data?.id) {
                  return ((this.productEntries && this.productEntries.some((entry: any) => entry.productType?.id == d.sku_id
                    && entry.grn_gsn_details_id == d.id &&
                    entry.selectedPiSection == d.section_id)) ? true : (Number(d.receive_qty) != 0 && d.remaining_qty != 0));
                } else {
                  return Number(d.receive_qty) != 0 && d.remaining_qty != 0;
                }
              });
            }

            grn.details?.forEach(d => {
              const key = `${grn.id}_${d.item_service_type}_${d.item_service_type === 'Service' ? (d.service_id || d.service?.id) : d.sku_id}`;
              const preserved = hsnPreservationMap.get(key);
              if (preserved) {
                d.hsn_no = preserved.hsn_no;
                d.hsn_sac = preserved.hsn_sac;
                d.taxType = preserved.taxType;
                d.specification = preserved.specification;
              }
            });
          });
          this.productList = newData;
        })
      ).subscribe({
        next: () => {
          this.Save(isApproval);
        },
        error: (error) => {
          console.error('Error during FA Master flow:', error);
        }
      });
    } else {
      this.Save(isApproval);
    }
  }
  Save(isApproval: boolean = false): void {
    const gstLedgers: { ledger_id: number; gstAmount: number }[] = this.getGroupedGstLedgers() as { ledger_id: number; gstAmount: number }[];
    this.debitEntries = [];
    const hasGrnOrGsn = this.selectedGrn?.some(grn => grn !== null) || this.selectedGsn?.some(gsn => gsn !== null);
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    const isPurchase = selectedVoucher.voucher_type === 'Purchase';
    const isSales = selectedVoucher.voucher_type === 'Sales';
    const amount = Math.abs(this.roundedamount2 || 0);

  const debitMap = new Map<number, number>();
      const prodDebitMap = new Map<number, number>();
    const groupedLedgers = this.getGroupedLedgers();
    groupedLedgers.forEach(entry => {
      if (entry.ledger_id !== null) {
        prodDebitMap.set(entry.ledger_id, entry.totalDiscountedAmount);
      }
    });
    const groupedGstDetails = this.getGroupedGstDetails();
    groupedGstDetails.forEach(entry => {
      debitMap.set(entry.ledger_id, entry.totalAmount);
    });
    // grn and gsn sku ledger //start
  const prodDebitMap2 = new Map<number, number>();
  // this.productList.forEach(entry => {
  //   const purchaseOrders = Array.isArray(entry.purchase_order) ? entry.purchase_order : entry.purchase_order ? [entry.purchase_order] : [];
  //   const salesOrders = Array.isArray(entry.sales_order) ? entry.sales_order : entry.sales_order ? [entry.sales_order] : [];
  //   entry.details.forEach((detail) => {
  //     const price = parseFloat(detail.unit_price) || 0;
  //     const qty = parseFloat(this.selectedGrn.length !== 0 ? detail.receive_qty : detail.send_qty) || 0;
  //     const discount = this.getdiscountvalue2(detail) || 0;
  //     const totalAmount = price * qty;
  //     const taxableAmount = totalAmount - discount;
  //     const sectionIds = detail?.section_id
  //     ? detail.section_id.toString().split(',').map(Number)
  //     : [];
  //     const sku_maps = detail?.sku?.sku_detail_maps || [];
  //     const service_maps = detail?.service?.service_ledgr_map || [];
  //      let fa_ledgers =
  //     this.data?.id && detail?.fa_master
  //       ? detail.fa_master.map((fa: any) => ({
  //           ledger_id: fa.ledger_id,
  //           book_value: parseFloat(fa.book_value) || 0,
  //         }))
  //       : detail?.fa_master?.map((fa: any) => ({
  //           ledger_id: fa.ledger_id,
  //           book_value: parseFloat(fa.book_value) || 0,
  //         })) || [];
  //     // const purchase_sku_ledger = sku_maps.find((m: any) =>
  //     //   m.voucher_type === 'Purchase' || purchaseOrders.some(po => po.section_id === m.section_id)
  //     // );
  //     // const purchase_service_ledger = service_maps.find((m: any) =>
  //     //   m.voucher_type === 'Purchase' || purchaseOrders.some(po => po.section_id === m.section_id)
  //     // );
  //     // const sales_sku_ledger = sku_maps.find((m: any) =>
  //     //   m.voucher_type === 'Sales' || salesOrders.some(so => so.section_id === m.section_id)
  //     // );
  //     // const sales_service_ledger = service_maps.find((m: any) =>
  //     //   m.voucher_type === 'Sales' || salesOrders.some(so => so.section_id === m.section_id)
  //     // );
  //     const purchase_sku_ledger = sku_maps.find((m: any) =>
  //       m.voucher_type === 'Purchase' &&
  //       purchaseOrders.some((po: any) => {
  //         const poSections = po.section_id?.toString().split(',').map(Number);
  //         return poSections.includes(Number(m.section_id));
  //       })
  //     );
  //     const purchase_service_ledger = service_maps.find((m: any) =>
  //       m.voucher_type === 'Purchase' &&
  //       purchaseOrders.some((po: any) => {
  //         const poSections = po.section_id?.toString().split(',').map(Number);
  //         return poSections.includes(Number(m.section_id));
  //       })
  //     );

  //     const sales_sku_ledger = sku_maps.find((m: any) =>
  //       m.voucher_type === 'Sales' &&
  //       salesOrders.some((so: any) => {
  //         const soSections = so.section_id?.toString().split(',').map(Number);
  //         return soSections.includes(Number(m.section_id));
  //       })
  //     );

  //     const sales_service_ledger = service_maps.find((m: any) =>
  //       m.voucher_type === 'Sales' &&
  //       salesOrders.some((so: any) => {
  //         const soSections = so.section_id?.toString().split(',').map(Number);
  //         return soSections.includes(Number(m.section_id));
  //       })
  //     );
  //     let ledgerId: number | undefined;
  //     if (this.selectedGrn.length !== 0) {
  //       if (detail.item_service_type === 'Fixed Asset' && fa_ledgers.length > 0) {
  //         fa_ledgers.forEach((fa: any) => {
  //           prodDebitMap2.set(fa.ledger_id, fa.book_value);
  //         });
  //       }else if (detail.item_service_type === 'SKU') {
  //         ledgerId = purchase_sku_ledger?.dr_ledger;
  //       } else if (detail.item_service_type === 'Service') {
  //         ledgerId = purchase_service_ledger?.dr_ledger;
  //       }
  //     } else {
  //       if (detail.item_service_type === 'Fixed Asset' && fa_ledgers.length > 0) {
  //         fa_ledgers.forEach((fa: any) => {
  //           prodDebitMap2.set(fa.ledger_id, fa.book_value);
  //         });
  //       }else if (detail.item_service_type === 'SKU') {
  //         ledgerId = sales_sku_ledger?.cr_ledger;
  //       } else if (detail.item_service_type === 'Service') {
  //         ledgerId = sales_service_ledger?.cr_ledger;
  //       }
  //     }
  //     if (ledgerId !== undefined) {
  //       const existingAmount = prodDebitMap2.get(ledgerId) || 0;
  //       prodDebitMap2.set(ledgerId, existingAmount + taxableAmount);
  //       // prodDebitMap2.set(ledgerId, taxableAmount);
  //     }
  //   });
  // });
  this.productList.forEach(entry => {

  const purchaseOrders = Array.isArray(entry.purchase_order)
    ? entry.purchase_order
    : entry.purchase_order ? [entry.purchase_order] : [];

  const salesOrders = Array.isArray(entry.sales_order)
    ? entry.sales_order
    : entry.sales_order ? [entry.sales_order] : [];

  entry.details.forEach((detail) => {

    const price = parseFloat(detail.unit_price) || 0;
    const qty = parseFloat(
      this.selectedGrn.length !== 0 ? detail.receive_qty : detail.send_qty
    ) || 0;

    const discount = detail.discount_amount || 0;
    const incentive = detail.incentive_amount || 0;

    const totalAmount = price * qty;
    const taxableAmount = totalAmount - discount + incentive;

    const sku_maps = detail?.sku?.sku_detail_maps || [];
    const service_maps = detail?.service?.service_ledgr_map || [];
    const maps = detail.item_service_type === 'SKU' ? sku_maps : service_maps;
    let fa_ledgers =
      this.data?.id && detail?.fa_master
        ? detail.fa_master.map((fa: any) => ({
            ledger_id: fa.ledger_id,
            book_value: parseFloat(fa.book_value) || 0,
          }))
        : detail?.fa_master?.map((fa: any) => ({
            ledger_id: fa.ledger_id,
            book_value: parseFloat(fa.book_value) || 0,
          })) || [];
    if (detail.item_service_type === 'Fixed Asset' && fa_ledgers.length > 0) {
      fa_ledgers.forEach((fa: any) => {
        const existing = prodDebitMap2.get(fa.ledger_id) || 0;
        prodDebitMap2.set(fa.ledger_id, existing + fa.book_value);
      });
      return;
    }
    const sectionIds = detail?.section_id
      ? detail.section_id.toString().split(',').map(Number)
      : [];

    const orders = this.selectedGrn.length !== 0 ? purchaseOrders : salesOrders;
    const voucherType = this.selectedGrn.length !== 0 ? 'Purchase' : 'Sales';
    sectionIds.forEach((sectionId: number) => {

      const match = maps.find((m: any) =>
        m.voucher_type === voucherType &&
        Number(m.section_id) === sectionId &&
        orders.some((o: any) => {
          const oSections = o.section_id?.toString().split(',').map(Number);
          return oSections.includes(sectionId);
        })
      );
      if (!match) return;

      const ledgerId =
        voucherType === 'Purchase'
          ? match.dr_ledger
          : match.cr_ledger;

      if (!ledgerId) return;
      const existing = prodDebitMap2.get(ledgerId) || 0;
      prodDebitMap2.set(ledgerId, existing + taxableAmount);
    });
  });
});
  const hasNullProdLedger = Array.from(prodDebitMap2.keys()).some(
    key => key === null || key === undefined
  );

  const hasNullGstLedger = gstLedgers.some(
    item => item.ledger_id === null || item.ledger_id === undefined
  );

  if (hasNullProdLedger || hasNullGstLedger) {
    alert('Ledger mapping missing! Some product or GST ledger_id not found.');
    return;
  }
    if (hasGrnOrGsn) {
      if (this.vendorBranchGstType === 'REGISTER') {
        gstLedgers.forEach(ledger => {
          this.debitEntries.push({
            ledger_id: ledger.ledger_id,
            amount: ledger.gstAmount.toFixed(2),
            description: '',
          });
        });
      }
      prodDebitMap2.forEach((amount, prod_ledger_id) => {
        this.debitEntries.push({
          ledger_id: prod_ledger_id,
          amount: amount.toFixed(2),
          description: '',
        });
      });
    } else {
      //Debit side gst ledger
      debitMap.forEach((amount: number, ledger_id: number) => {
        this.debitEntries.push({
          ledger_id: ledger_id,
          amount: amount.toFixed(2),
          description: '',
        });
      });
      //Debit side Product Ledger
      prodDebitMap.forEach((amount, prod_ledger_id) => {
        this.debitEntries.push({
          ledger_id: prod_ledger_id,
          amount: amount.toFixed(2),
          description: '',
        });
      });
    }
    // Rounded Ledger
    // if (this.ledger && this.roundedamount) {
    //   this.debitEntries.push({
    //     ledger_id: this.ledger,
    //     amount: this.roundedamount || 0,
    //     description: '',
    //   });
    // }
    if (isPurchase || isSales) {
      if (this.ledger && this.roundedamount2 > 0) {
        this.debitEntries.push({
          ledger_id: this.ledger,
          amount,
          description: '',
        });
      } else if(this.ledger && this.roundedamount2 < 0){
        this.creditEntries.push({
          ledger_id: this.ledger,
          amount,
          description: '',
        });
      } else if (this.ledger && this.roundedamount > 0) {
      this.debitEntries.push({
        ledger_id: this.ledger,
        amount: this.roundedamount || 0,
        description: '',
      });
    } else if(this.ledger && this.roundedamount < 0){
      this.creditEntries.push({
        ledger_id: this.ledger,
        amount,
        description: '',
      });
    }
    }
    // Credit side Vendor Ledger & customer ledger
    const totalAmount = this.getTotalRoundedAmount().toFixed(2);
    const totalAmount2 = this.getTotalRoundedAmount2().toFixed(2);
    if (hasGrnOrGsn) {
      this.creditEntries.push({
        ledger_id: isPurchase ? this.vendorBranchLedgerId() : this.customerBranchLedgerId(),
        amount: totalAmount2,
        description: '',
      });
    } else {
      this.creditEntries.push({
        ledger_id: isPurchase ? this.vendorBranchLedgerId() : this.customerBranchLedgerId(),
        amount: totalAmount,
        description: '',
      });
    }
    const selectedVendorBranch = Array.isArray(this.vendorBranchData)
      ? this.vendorBranchData.find(branch => branch.id === this.selectedVendorBranch)
      : null;
    const selectedCustomerBranch = Array.isArray(this.customerBranchData)
      ? this.customerBranchData.find(branch => branch.id === this.selectedCustomerBranch)
      : null;
    if (hasGrnOrGsn) {

      this.productList.forEach(entry => {
        console.log('productList', this.productList);
        const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
        const isPurchase = selectedVoucher?.voucher_type === 'Purchase';
        const isSales = selectedVoucher?.voucher_type === 'Sales';
        const hasGrn = this.selectedGrn?.length !== 0;
        const purchaseOrders = entry.purchase_order ? [entry.purchase_order] : [];
        const salesOrders = entry.sales_order ? [entry.sales_order] : [];
        const details = (entry.details || []).map(detail => {
          const item_service_type = detail?.item_service_type;
          // const maps = detail?.sku?.sku_detail_maps || [];
          const sku_maps = detail?.sku?.sku_detail_maps || [];
          const service_maps = detail?.service?.service_ledgr_map || [];
          const findLedger = (maps: any[], type: 'Purchase' | 'Sales', sectionIds: any[], ledgerKey: 'dr_ledger' | 'cr_ledger', nameKey: 'dr_ledger_name' | 'cr_ledger_name') => {
            const match = maps.find(m => 
              (m.voucher_type === type) && 
              (detail.section_id == (m.section_id))
            );
            console.log('findLedger debug:', { type, sectionIds, matchFound: !!match, ledgerId: match?.[ledgerKey] });
            return {
              id: match?.[ledgerKey],
              name: match?.[nameKey]
            };
          };

          const sectionIds = isPurchase ? purchaseOrders.map(po => po.section_id) : salesOrders.map(so => so.section_id);
          let ledgerInfo: any = { id: undefined, name: undefined };

          if (item_service_type === 'SKU') {
            ledgerInfo = findLedger(
              sku_maps,
              isPurchase ? 'Purchase' : 'Sales',
              sectionIds,
              isPurchase ? 'dr_ledger' : 'cr_ledger',
              isPurchase ? 'dr_ledger_name' : 'cr_ledger_name'
            );
          } else if (item_service_type === 'Service') {
            ledgerInfo = findLedger(
              service_maps,
              isPurchase ? 'Purchase' : 'Sales',
              sectionIds,
              isPurchase ? 'dr_ledger' : 'cr_ledger',
              isPurchase ? 'dr_ledger_name' : 'cr_ledger_name'
            );
          } else if (item_service_type === 'Fixed Asset') {
            const fa = detail.fa_master?.[0];
            ledgerInfo = fa
              ? {
                ledger_id: fa.ledger_id,
                ledger_name: fa.ledger?.ledger_name || ''
              }
              : { id: undefined, name: undefined };
          }
          console.log(ledgerInfo);
          return {
            product_id: hasGrn ? item_service_type === 'SKU' ? detail?.sku?.id : item_service_type === 'Service' ? detail?.service?.id : detail?.fa_template?.id : item_service_type === 'SKU' ? detail?.sku?.id : item_service_type === 'Service' ? detail?.service?.id : detail?.fa_template?.id,
            name: hasGrn ? (item_service_type === 'SKU' ? detail?.sku?.item?.item_name : item_service_type === 'Service' ? detail?.service?.service_name : detail?.fa_template?.name)
              : (item_service_type === 'SKU' ? detail?.sku?.item?.item_name : item_service_type === 'Service' ? detail?.service?.service_name : detail?.fa_template?.name),
            product_ledger: ledgerInfo.id ?? ledgerInfo.ledger_id,
            product_ledger_name: ledgerInfo.name ?? ledgerInfo.ledger_name,
            hsn_no: detail?.hsn_no,
            description: detail?.description,
            unit_name: detail?.unit?.unit_name,
            qty: isPurchase ? detail?.receive_qty : detail?.send_qty,
            unit_price: detail?.unit_price,
            value: isPurchase ? (detail?.receive_qty || 0) * (detail?.unit_price || 0) : (detail?.send_qty || 0) * (detail?.unit_price || 0),
            discount_amount: detail?.discount_amount||0,
            incentive_amount: detail?.incentive_amount||0,
            gst_id: this.vendorBranchGstType === 'REGISTER' ? detail?.hsn_sac?.gst_id : '',
            rounded_amount: this.roundedamount2 || null,
            rounded_ledger: this.ledger || null,
            gst_ledger: this.vendorBranchGstType === 'REGISTER' ? gstLedgers : '',
            vendor_id: isPurchase ? this.vendor : isSales ? this.customer : '',
            branch_id: isPurchase ? selectedVendorBranch?.id : isSales ? selectedCustomerBranch?.id : '',
            type: isPurchase ? 'purchase' : isSales ? 'sales' : '',
            // grn_id: this.selectedGrn ?? null,
            grn_id: detail?.grn_id,
            // gsn_id: this.selectedGsn ?? null,
            gsn_id: detail?.gsn_id,
            // section_id: isPurchase ? this.selectedPiSection : this.selectedSection,
            section_id: detail?.section_id,
            item_type: detail?.item_service_type,
            // profit_cost_id: this.profit_cost_id,
            profit_cost_id: (detail?.gsn_id )? (detail?.profit_cost_id) :this.profit_cost_id??null,
            details_id:detail?.id,
            product_service_type: item_service_type,
            store_id : item_service_type === 'SKU' ? detail?.sku?.store_id : null,
            specification : detail?.specification,
          };
        });
        this.details.push(...details);
      });
    } else {
      console.log('without grn');
      console.log('productEntries1111', this.productEntries);
      const correctedEntries = this.productEntries.map(entry => {
        return {
          ...entry,
          productType: this.getOriginalItem(entry.productType)
        };
      });
      correctedEntries.forEach(entry => {
        const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
        const isPurchase = selectedVoucher.voucher_type === 'Purchase';
        const isSales = selectedVoucher.voucher_type === 'Sales';
        const type = entry.productType.type;
        let product_ledger_id: any;
        let product_ledger_name: any;
        const sectionIds = Array.isArray(this.section_id) ? this.section_id : (this.section_id ? [this.section_id] : []);

        if (type === "Service") {
          const maps = entry.productType?.service_ledgr_map || [];
          const match = maps.find(m => 
            (m.voucher_type === (isPurchase ? 'Purchase' : 'Sales')) && 
            (sectionIds.length === 0 || sectionIds.some(sid => Number(sid) === Number(m.section_id)))
          ) || maps[0]; 
          
          product_ledger_id = isPurchase ? (match?.dr_ledger ?? match?.ledger?.id) : (match?.cr_ledger ?? match?.ledger?.id);
          product_ledger_name = isPurchase ? (match?.dr_ledger_name ?? match?.ledger?.ledger_name) : (match?.cr_ledger_name ?? match?.ledger?.ledger_name);
          
          console.log('Service ledger lookup:', { sectionIds, matchFound: !!match, product_ledger_id });
        } else if (type === "SKU") {
          const skuMaps = entry.productType?.sku_detail_maps || [];
          const match = skuMaps.find(m => 
            (m.voucher_type === (isPurchase ? 'Purchase' : 'Sales')) && 
            (sectionIds.length === 0 || sectionIds.some(sid => Number(sid) === Number(m.section_id)))
          );
          
          if (isPurchase) {
            product_ledger_id = match?.dr_ledger;
            product_ledger_name = match?.dr_ledger_name;
          } else if (isSales) {
            product_ledger_id = match?.cr_ledger;
            product_ledger_name = match?.cr_ledger_name;
          }
          console.log('SKU ledger lookup:', { sectionIds, matchFound: !!match, product_ledger_id });
        }
        console.log('type', type);
        console.log('productType', entry.productType);
        this.details.push({
          product_id: entry.productType.id,
          // name: this.data.id ? entry.productType.name : (type === "Service" ? entry.productType.service_name : entry.productType.sku_name),
          name: type === "Service" ? entry.productType.service_name : entry.productType.sku_name,
          product_ledger: product_ledger_id,
          product_ledger_name: product_ledger_name,
          hsn_no: entry.hsn_no,
          description: entry.description,
          unit_name: entry.unit,
          qty: entry.qty,
          unit_price: entry.unitPrice,
          value: entry.qty * entry.unitPrice,
          discount: entry.discount,
          gst_id: entry.taxType,
          rounded_amount: this.roundedamount || null,
          rounded_ledger: this.ledger || null,
          vendor_id: isPurchase ? this.vendor : isSales ? this.customer : '', // Setting vendor_id based on voucherType
          branch_id: isPurchase ? selectedVendorBranch.id : isSales ? selectedCustomerBranch.id : '',
          type: isPurchase ? 'purchase' : isSales ? 'sales' : '',
          item_type: type,
          gst_ledger: groupedGstDetails.map(gst => ({
            ledger_id: gst.ledger_id,
            gst_id: entry.taxType,
          })),
          section_id: isPurchase ? this.selectedPiSection : this.selectedSection,
          details_id:null,
          product_service_type: type,
          profit_cost_id: this.profit_cost_id,
        });
      });
    }   //end details 
    const postDataPurches = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      date: this.date,
      issue_date: this.issue_date,
      document_no: this.document_no,
      narration: this.purchesnarration,
      doc_type: 'purchase',
      total_cr: hasGrnOrGsn ? this.totalcredit2().toFixed(2) : this.totalcredit().toFixed(2),
      total_dr: hasGrnOrGsn ? this.getTotalRoundedAmount2().toFixed(2) : this.getTotalRoundedAmount().toFixed(2),
      dr: this.debitEntries,
      cr: this.creditEntries,
      details: this.details,
      branch_id:this.branch??null,
      // upload: this.base64File || []
      // upload: this.uploadedFiles,
        // IMPORTANT
  existing_uploads: this.existingFiles,  // files that still exist after delete
  new_uploads: this.uploadedFiles,  
      fa_details: this.fa_details,
      profit_cost_id: this.profit_cost_id,
      section_id: this.selectedPiSection,
      type: this.operationType
    };
    const postDataSales = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      date: this.date,
      issue_date: this.issue_date,
      document_no: this.document_no,
      narration: this.purchesnarration,
      doc_type: 'sales',
      total_cr: hasGrnOrGsn ? this.totalcredit2().toFixed(2) : this.totalcredit().toFixed(2),
      total_dr: hasGrnOrGsn ? this.getTotalRoundedAmount2().toFixed(2) : this.getTotalRoundedAmount().toFixed(2),
      cr: this.debitEntries,
      dr: this.creditEntries,
      details: this.details,
      branch_id: this.branch ?? null,
      // upload: this.base64File || []
      // upload: this.uploadedFiles
     existing_uploads: this.existingFiles,
     new_uploads: this.uploadedFiles,  
      profit_cost_id: this.profit_cost_id,
      section_id: this.selectedSection,
      type: this.operationType
    };
    const postData = selectedVoucher.voucher_type === 'Purchase' ? postDataPurches : postDataSales;
    console.log('s/p/postdata', postData);
    // return;
    if (this.data?.id) {
      // console.log('lipsa');
      this.apiService.updateVoucherPosting(this.data.id, postData).subscribe(
        response => {
          console.log('Voucher updated successfully:', response);
          if (isApproval) {
            this.sendForApprove(true);
          } else {
            this.dialogRef.close(response);
          }
        },
        error => {
          console.error('Error updating voucher:', error);
        }
      );
    } else {
      this.apiService.createVoucherPosting(postData).subscribe(
        response => {
          console.log('Voucher Created successfully:', response);
          this.dialogRef.close(response);
        },
        error => {
          console.error('Error posting voucher:', error);
        }
      );
    }
  }


  // view() {
  //   let totalValue = 0;
  //   const cr: any[] = [];
  //   const dr: any[] = [];
  //   const skuPrices: any[] = [];
  //   for (const sku of this.tableSkus) {
  //     const qty = Number(sku.selectQty) || 0;
  //     let itemValue = 0;
  //     itemValue = this.getLifoFifoValue(sku);

  //     totalValue += itemValue;
  //     skuPrices.push({
  //       sku_name: sku?.sku?.sku_name,
  //       amount: itemValue
  //     });
  //     const matchingMap = sku?.sku?.sku_inventory_maps?.find(
  //       (map: any) => map.voucher_id === this.voucherType
  //     );

  //     if (matchingMap) {
  //       if (matchingMap.inventory_cr_ledger) {
  //         cr.push({
  //           ledger_id: matchingMap.inventory_cr_ledger,
  //           ledger_name: matchingMap.cr_ledger.ledger_name,
  //           amount: itemValue
  //         });
  //       }

  //       if (matchingMap.inventory_dr_ledger) {
  //         dr.push({
  //           ledger_id: matchingMap.inventory_dr_ledger,
  //           ledger_name: matchingMap.dr_ledger.ledger_name,
  //           amount: itemValue
  //         });
  //       }
  //     }
  //   }
  //   const dialogData = {
  //     type: 'inventory',
  //     total_cr: totalValue,
  //     total_dr: totalValue,
  //     cr,
  //     dr,
  //     tableSkus: this.tableSkus,
  //     voucher_id: this.voucherType,
  //     skuPrices
  //   };

  //   this.dialog.open(CreateProductViewDialogComponent, {
  //     width: '1200px',
  //     height: '550px',
  //     data: dialogData
  //   });
  // }

  SaveInventory(isApproval: boolean = false) {
    let totalValue = 0;

    const crMap: { [ledger_id: number]: { ledger_name: string, amount: number ,description: string} } = {};
    const drMap: { [ledger_id: number]: { ledger_name: string, amount: number ,description: string} } = {};

    const details: any[] = [];

    for (const sku of this.tableSkus) {
      if (!sku.soList || sku.soList.length === 0) continue;

      // loop over each SO entry
      for (const so of sku.soList) {
        const qty = Number(so.selectQty) || 0;
        if (qty <= 0) continue;

        const itemValue = this.getLifoFifoValue(sku, so);
        totalValue += itemValue;

        const unit_name = sku?.sku?.item?.unit?.[0]?.global_unit?.unit_name;

        const matchingMap = sku?.sku?.sku_inventory_maps?.find(
          (map: any) => map.voucher_id === this.voucherType
        );

        const product_ledger = matchingMap?.inventory_cr_ledger ?? null;
        const product_ledger_name = matchingMap?.cr_ledger?.ledger_name ?? '';
console.log('sku,',sku);
        // push SO-level detail
        details.push({
          product_id: sku?.id,
          product_ledger,
          product_ledger_name,
          qty: qty,
          value: itemValue.toFixed(2),
          branch_id: this.inv_branch ?? null,
          employee_id: so.employee_id,
          profit_cost_id: this.profitcost_id,
          store_id: this.store_id,
          inv_section_id: this.inv_section_id,
          hsn_no: sku.hsn_no,
          description: sku.description,
          unit_id: sku.unit_id,
        });
        console.log('details',details)

        // build CR/DR maps
        if (matchingMap) {
          if (matchingMap.inventory_cr_ledger) {
            const ledgerId = matchingMap.inventory_cr_ledger;
            const ledgerName = matchingMap.cr_ledger.ledger_name;
            crMap[ledgerId] = {
              ledger_name: ledgerName,
              amount: (crMap[ledgerId]?.amount || 0) + itemValue,
              description:''
            };
          }

          if (matchingMap.inventory_dr_ledger) {
            const ledgerId = matchingMap.inventory_dr_ledger;
            const ledgerName = matchingMap.dr_ledger.ledger_name;
            drMap[ledgerId] = {
              ledger_name: ledgerName,
              amount: (drMap[ledgerId]?.amount || 0) + itemValue,
              description:''
            };
          }
        }
      }
    }

    const cr = Object.entries(crMap).map(([ledger_id, data]) => ({
      ledger_id: Number(ledger_id),
      ledger_name: data.ledger_name,
      amount: data.amount,
      description:''
    }));

    const dr = Object.entries(drMap).map(([ledger_id, data]) => ({
      ledger_id: Number(ledger_id),
      ledger_name: data.ledger_name,
      amount: data.amount,
      description: ''
    }));

    if (totalValue === 0 || details.length === 0 || details?.[0].product_ledger === null) {
      alert('Voucher cannot be created.');
      return;
    }

    const postDataInventory = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      date: this.date,
      type: 'inventory',
      total_cr: totalValue,
      total_dr: totalValue,
      cr,
      dr,
      branch_id: this.inv_branch ?? null,
      details
    };

    console.log('Final postData:', postDataInventory);
    // return;
    if (this.data?.id) {
      this.apiService.updateVoucherPosting(this.data.id, postDataInventory).subscribe(
        response => {
          console.log('Voucher updated successfully:', response);
          if (isApproval) {
            this.sendForApprove(true);
          } else {
            this.dialogRef.close(response);
          }
        },
        error => {
          console.error('Error updating voucher:', error);
        }
      );
    } else {
      this.apiService.createVoucherPosting(postDataInventory).subscribe(
        response => {
          console.log('Voucher Created successfully:', response);
          this.dialogRef.close(response);
        },
        error => {
          console.error('Error posting voucher:', error);
        }
      );
    }
  }

//   convertToPdf() {
//     let itemdetails = this.productEntries;
//     let resultArray = [];
//     let totalSum = 0;
//     let totalbefortax, totaldiscount, totalafterdiscount, totaltax, roundedamount, totalamount;
//     const hasGrnOrGsn = (this.selectedGrn && this.selectedGrn.length > 0) || (this.selectedGsn && this.selectedGsn.length > 0);
//     if (hasGrnOrGsn) {
//       this.productList.forEach(item => {
//         item.details.forEach(detail => {
//           console.log('hsn',detail);
//           let itemName = this.selectedGrn.length > 0 ? detail?.sku?.sku_name : (detail?.item_service_type === 'SKU' ? detail?.sku?.sku_name : detail?.service?.service_name);
//           let cgst = this.getCGSTPercentage(detail.hsn_sac.gst_id);
//           let sgst = this.getSGSTPercentage(detail.hsn_sac.gst_id);
//           let totalamount = this.selectedGrn.length > 0 ? detail.receive_qty * detail.unit_price : detail.send_qty * detail.unit_price;
//           let discountamount = detail.discount ? (totalamount * (detail.discount / 100)).toFixed(2) : '0.00';
//           let taxValue = this.productTaxAmount2(detail);
//           let productgstAmount =
//             typeof taxValue === 'number'
//               ? taxValue.toFixed(2)
//               : 'NA';
//           totalSum += totalamount;
//           resultArray.push({
//             id: item.productType,
//             name: itemName,
//             quantity: this.selectedGrn.length > 0 ? detail.receive_qty : detail.send_qty,
//             unitprice: detail.unit_price,
//             hsn: detail.hsn_no,
//             cgst: cgst,
//             sgst: sgst,
//             amount: totalamount,
//             discountamount: discountamount,
//             productgstAmount: productgstAmount
//           });
//         });
//       });
//       totalbefortax = totalSum;
//       totaldiscount = this.getTotaldiscount2();
//       totalafterdiscount = this.getTotalAmount2();
//       totaltax = this.getTotalGSTAmount2();
//       roundedamount = this.roundedamount2;
//       totalamount = this.getTotalRoundedAmount2().toFixed(2);
//     } else {
//       itemdetails.forEach(item => {
//         let itemName = this.getProductTypeName(item.productType);
//         let cgst = this.getCGSTPercentage(item.taxType);
//         let sgst = this.getSGSTPercentage(item.taxType);
//         let totalamount = (item.qty) * (item.unitPrice);
//         totalSum += totalamount;
//         let discountamount = (totalamount * (item.discount / 100)).toFixed(2);
//         let productgstAmount = (this.productTaxAmount(item) || 0).toFixed(2);
//         resultArray.push({
//           id: item.productType,
//           name: itemName,
//           quantity: item.qty,
//           unitprice: item.unitPrice,
//           hsn: item.hsn_no,
//           cgst: cgst,
//           sgst: sgst,
//           amount: totalamount,
//           discountamount: discountamount,
//           productgstAmount: productgstAmount
//         });
//       });
//       totalbefortax = totalSum;
//       totaldiscount = this.getTotaldiscount();
//       totalafterdiscount = this.getTotalAmount();
//       totaltax = this.getTotalGSTAmount();
//       roundedamount = this.roundedamount;
//       totalamount = this.getTotalRoundedAmount().toFixed(2);
//     }
//     const exportdata = {
//       exportType: 'pdf',
//       expanded: 'True',
//       customername: this.customer_name ?? this.vendor_name,
//       customeremail: this.customer_email ?? this.vendor_email,
//       customerphone: this.customer_phone ?? this.vendor_phone,
//       customeraddress: this.customer_address ?? this.vendor_address,
//       customergstno: this.customer_gstno ?? '',
//       customerpan: this.customer_pan ?? this.vendor_pan,
//       companyname: this.company_name ?? '',
//       companyaddress: this.company_address ?? '',
//       companyemail: this.company_email ?? '',
//       companyphone: this.company_phone ?? '',
//       companygstno: this.company_gstno ?? '',
//       companypan: this.company_pan ?? '',
//       companylogo: this.company_logo ?? '',
//       companysignature: this.company_signature ?? '',
//       invoiceno: this.document_no ?? '',
//       date: this.issue_date ?? '',
//       isposted:0,
//       data: resultArray,
//       totalbefortax: parseFloat(totalbefortax.toFixed(2)),
//       totaldiscount: parseFloat(totaldiscount.toFixed(2)),
//       totalafterdiscount: parseFloat(totalafterdiscount.toFixed(2)),
//       totaltax: parseFloat(totaltax.toFixed(2)),
//       roundedamount: roundedamount ? parseFloat(roundedamount.toFixed(2)) : null,
//       totalamount: totalamount,
//       vouchernumber:this.voucherNo ?? '',
//     }
// console.log('Export Data Payload:', this.customer_name);


//     this.apiService.voucherpostingexport(exportdata).subscribe(response => {

//       const downloadUrl = response[0];
//       const blob = new Blob([response], { type: 'application/pdf' });
//       const downloadLink = document.createElement('a');
//       const filename = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);
//       downloadLink.href = downloadUrl; 
//       downloadLink.download = filename;
//       downloadLink.target = '_blank';

//       document.body.appendChild(downloadLink);
//       downloadLink.click();

//       document.body.removeChild(downloadLink);
//     }, error => {
//       console.error('Error sending data:', error);
//     });
//   }
 
  formatDateForPdf = (date: any) => {
   if (!date) return '';
   const d = new Date(date);
   if (isNaN(d.getTime())) return date;
   const day = String(d.getDate()).padStart(2, '0');
   const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = String(d.getFullYear());
    return `${day}-${month}-${year}`;
 };

 formatMonthYear(date: any): string {
  if (!date) return '';
  const d = new Date(date);
  const month = d.toLocaleString('en-IN', { month: 'short' });
  const year = d.getFullYear();
  return `${month}-${year}`;
}

 convertToPdf(copyKey: 'original' | 'duplicate' | 'extra' = 'original') {
  try {
    let itemdetails = this.productEntries || [];
    let resultArray: any[] = [];
    let totalSum = 0;
    let totalbefortax = 0, totaldiscount = 0, totalafterdiscount = 0, totaltax = 0, roundedamount = 0, totalamount = 0;
  //  let so_no = '';
    let doc_no ='';
    let so_date = '';
    let start_date = '';
    let end_date = '';
    let categoryName = ''; 
    let so_no = '';
    let po_no = '';
    let  sales_invoice_date ='';
    let  purchase_invoice_date ='';
    let si_no ='';
    let pi_no = '';
    let credit_note_date='';
    let debit_note_date='';
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    console.log('selectedVoucher',selectedVoucher);
    const isPurchase = selectedVoucher?.voucher_type === 'Purchase';
    const isSales = selectedVoucher?.voucher_type === 'Sales';
    const isCreditNote = selectedVoucher?.voucher_type === 'Credit Note';
    const isDebitNote = selectedVoucher?.voucher_type === 'Debit Note';
    const invoiceType = this.invoice_type;
    console.log('invoiceType',invoiceType);
       const selectedBranch = this.branchdata.find(
      (branch: any) => branch.id === this.branch
      );
      const branch_gst  = selectedBranch?.gst;
      console.log('branchess',branch_gst );
    const branch_billing_address = selectedBranch?.billing_address ?? '';
    const branch_billing_phone = selectedBranch?.billing_phone ?? '';
    const branch_billing_phone1 = selectedBranch?.billing_phone1 ?? '';
    const branch_email = selectedBranch?.billing_email ?? '';
    const branch_fax = selectedBranch?.billing_fax ?? '';
    const branch_website = selectedBranch?.billing_website ?? '';
    console.log("Selected Branch Full Data:", selectedBranch);

    const selectedVendorBranchName = this.vendorBranchData?.find(
     (b: any) => b.id === this.selectedVendorBranch
     )?.branch_name;

    const selectedCustomerBranchName = this.customerBranchData?.find(
    (b: any) => b.id === this.selectedCustomerBranch
    )?.branch_name;

     if (isPurchase && !selectedVendorBranchName) {
      alert('Please select a Vendor Branch.');
     return;
    }

    if (isSales && !selectedCustomerBranchName) {
    alert('Please select a Customer Branch.');
    return;
    } 
  const categorySet = new Set<string>();

    const hasGrnOrGsn = 
      (this.selectedGrn && this.selectedGrn.length > 0) || 
      (this.selectedGsn && this.selectedGsn.length > 0);

    if (hasGrnOrGsn) {
      (this.productList || []).forEach(item => {
        (item.details || []).forEach(detail => {
          console.log('hsn', this.productList);

          const hsnData = detail?.hsn_sac;
          // let itemName = this.selectedGrn?.length > 0 
          //   ? detail?.sku?.sku_name 
          //   : (detail?.item_service_type === 'SKU' ? detail?.sku?.sku_name : detail?.service?.service_name);
          let itemName = detail?.item_service_type === 'SKU'
                ? detail?.sku?.sku_name
                : detail?.item_service_type === 'Service'
                  ? detail?.service?.service_name
                  : detail?.item_service_type === 'Fixed Asset'
                    ? detail?.fa_template?.name
                    : '' ;

          // let cgst = hsnData ? this.getCGSTPercentage(hsnData.gst_id) : 0;
          // let sgst = hsnData ? this.getSGSTPercentage(hsnData.gst_id) : 0;
          let cgst = 0, sgst = 0, igst = 0;
          if (hsnData) {
          const sameState = this.gstMatch();
          
          if (sameState) {
          cgst = this.getCGSTPercentage(hsnData.gst_id) || 0;
          sgst = this.getSGSTPercentage(hsnData.gst_id) || 0;
          igst = 0;
         } else {
         cgst = 0;
         sgst = 0;
         igst = this.getIGSTPercentage(hsnData.gst_id) || 0;
       }
        }
          let qty = this.selectedGrn?.length > 0 ? (detail?.receive_qty || 0) : (detail?.send_qty || 0);
          let unitPrice = detail?.unit_price || 0;
          let totalamount = qty * unitPrice;
          let discountamount = detail?.discount ? (totalamount * (detail.discount / 100)).toFixed(2) : '0.00';
          let taxValue = this.productTaxAmount2?.(detail);
          let productgstAmount =
            typeof taxValue === 'number'
              ? taxValue
              : 'NA';
          totalSum += totalamount;

      // if (item?.sales_order) {
      //   doc_no = item.sales_order.doc_no ?? '';
      //   so_date = item.sales_order.date ?? '';
      // }
      if (item?.sales_order) {
            doc_no = item.sales_order.doc_no ?? '';
            so_date = item.sales_order.date ?? '';
          }

      if (detail.start_date) {
        if (!start_date || detail.start_date < start_date) {
          start_date = detail.start_date;
        }
      }

      if (detail.end_date) {
        if (!end_date || detail.end_date > end_date) {
          end_date = detail.end_date;
        }
      }

      // let productServiceNo = "";
      // if (
      //   detail.item_service_type === "SKU" || detail.item_service_type === "Service") {
      //   const matchedDetail = item.sales_order?.so_details?.find((d) =>
      //       d.sku_id === detail.sku_id &&
      //       d.item_service_type === detail.item_service_type &&
      //       d.level_no === detail.level_no
      //   );
      //   productServiceNo = matchedDetail?.product_service_no ?? "";
      // }
      
      //  let categoryName = "";
      //  categoryName = detail?.hsn_sac?.description ?? "";
      //  if (categoryName) categorySet.add(categoryName);

      //  const lineStartDate = detail?.start_date ? this.formatDateForPdf(detail.start_date) : '';
      //  const lineEndDate = detail?.end_date ? this.formatDateForPdf(detail.end_date) : '';
      //  const baseDescription = detail?.description ||detail?.sku?.description ||detail?.service?.description ||'';
      //  let finalDescription = baseDescription;
      //     if (lineStartDate && lineEndDate) {
      //       finalDescription += `\n(${lineStartDate} to ${lineEndDate})`;
      //     }     
          const lineStartDate = detail?.start_date ? this.formatMonthYear(detail.start_date) : '';
          const baseDescription = detail?.description || detail?.sku?.description || detail?.service?.description || '';
          let finalDescription = baseDescription;
          if (lineStartDate) {
            finalDescription += `\n(${lineStartDate})`;
          }

          resultArray.push({
            id: item.productType ?? '',
            name: itemName ?? '',
            product_service_no: detail?.product_service_no ??'',
            // description: detail?.description || detail?.sku?.description || detail?.service?.description || '',
            description: finalDescription,
            quantity: Number(qty).toFixed(3),
            unitprice: unitPrice,
            hsn: detail?.hsn_no ?? '',
            unit: detail?.unit?.unit_name ??'', 
            line_document_no :detail?.line_document_no ??'',
            cgst,
            sgst,
            igst,
            amount: totalamount,
            // discountamount,
            productgstAmount,
            // category_name: categoryName,
            category_name: detail?.hsn_sac?.description ?? "",
            gst_type:this.vendorBranchGstType,
            incentiveAmount:detail?.incentive_amount ?? 0,
            discountAmount:detail?.discount_amount ?? 0,
            remark:detail?.remark ?? '',
          });
        });
      });
      totalbefortax = totalSum;
      totaldiscount = this.getTotaldiscount2?.() ?? 0;
      totalafterdiscount = this.getTotalAmount2?.() ?? 0;
      totaltax = this.getTotalGSTAmount2?.() ?? 0;
      roundedamount = this.roundedamount2 ?? 0;
      totalamount = parseFloat(this.getTotalRoundedAmount2?.()?.toFixed(2) ?? '0');
    } else if (invoiceType === 'sales' || invoiceType === 'credit note') {
      console.log('sales invoice details', this.sales_invoice_details);
      console.log('credit note details', this.credit_note_details);
      const salesInvoiceDetail = invoiceType === 'sales' ? this.sales_invoice_details : this.credit_note_details;
      console.log('credit note salesInvoiceDetail', salesInvoiceDetail);
      so_no = salesInvoiceDetail[0] ?.so_no ?? '';
      sales_invoice_date = salesInvoiceDetail[0] ?.sales_invoice_date ?? '';
      si_no = salesInvoiceDetail[0] ?.si_no ?? '';
      credit_note_date = (this.date);
      resultArray = [];
      totalbefortax = 0;
      totaltax = 0;

      (salesInvoiceDetail || []).forEach(item => {
        if (!item.qty || item.qty <= 0) return;
        const qty = invoiceType === 'sales' ? Number(item.change_qty) : Number(item.qty);
        const unitPrice = Number(item.unit_price);
        // const amount = qty * unitPrice;
        const amount = invoiceType === 'sales' ? (Number(item.change_value)-Number(item.final_discount||0)+Number(item?.final_incentive||0)) : Number(item.value)-Number(item.discount_amount||0)+Number(item?.incentive_amount||0);
        const gstPercent = Number(item.gst_percentage || 0);
        let cgst = 0, sgst = 0, igst = 0;

        if (gstPercent > 0) {
          const sameState = this.gstMatch();
          if (sameState) {
            cgst = gstPercent / 2;
            sgst = gstPercent / 2;
          } else {
            igst = gstPercent;
          }
        }

        const productgstAmount = (amount * gstPercent) / 100;
        totalbefortax += amount;
        totaltax += productgstAmount;

        resultArray.push({
          id: item.product_id,
          name: item.name,
          description: item.description ?? '',
          line_document_no: item?.line_document_no ?? '',
          // quantity: qty,
          unitprice: unitPrice,
          // amount,
          quantity: qty,
          // unitprice: item.change_value / item.change_qty,
          amount: amount,
          hsn: item.hsn_no ?? '',
          unit: item.unit_name ?? '',
          gst_id: item.gst_id,
          gst_percentage: gstPercent,
          cgst,
          sgst,
          igst,
          gst_type: this.vendorBranchGstType ?? '',
          productgstAmount: productgstAmount.toFixed(2),
        });
      });
      console.log('credit note resultArray', resultArray);
      totaldiscount = 0;
      totalafterdiscount = totalbefortax;
      totalamount = totalbefortax + totaltax;
      roundedamount = totalamount;
    }else if (invoiceType === 'purchase' || invoiceType === 'debit note') {
      console.log('purchase invoice details', this.purchase_invoice_details);
      console.log('debit note details', this.debit_note_details);
      const purchaseInvoiceDetail = invoiceType === 'purchase' ? this.purchase_invoice_details : this.debit_note_details;
      console.log('debit note purchaseInvoiceDetail', purchaseInvoiceDetail);
      po_no = purchaseInvoiceDetail[0] ?.po_no ?? '';
      purchase_invoice_date = purchaseInvoiceDetail[0] ?.purchase_invoice_date ?? '';
      pi_no = purchaseInvoiceDetail[0] ?.pi_no ?? '';
      debit_note_date = (this.date);
      resultArray = [];
      totalbefortax = 0;
      totaltax = 0;

      (purchaseInvoiceDetail || []).forEach(item => {
        if (!item.qty || item.qty <= 0) return;
        const qty = invoiceType === 'purchase' ? Number(item.change_qty) : Number(item.qty);
        const unitPrice = Number(item.unit_price);
        // const amount = qty * unitPrice;
        const amount = invoiceType === 'purchase' ? Number(item.change_value) : Number(item.value);
        const gstPercent = Number(item.gst_percentage || 0);
        let cgst = 0, sgst = 0, igst = 0;

        if (gstPercent > 0) {
          const sameState = this.gstMatch();
          if (sameState) {
            cgst = gstPercent / 2;
            sgst = gstPercent / 2;
          } else {
            igst = gstPercent;
          }
        }
        const productgstAmount = (amount * gstPercent) / 100;
        totalbefortax += amount;
        totaltax += productgstAmount;

        resultArray.push({
          id: item.product_id,
          name: item.name,
          description: item.description ?? '',
          line_document_no: item?.line_document_no ?? '',
          // quantity: qty,
          unitprice: unitPrice,
          // amount,
          quantity: qty,
          // unitprice: item.change_value / item.change_qty,
          amount: amount,
          hsn: item.hsn_no ?? '',
          unit: item.unit_name ?? '',
          gst_id: item.gst_id,
          gst_percentage: gstPercent,
          cgst,
          sgst,
          igst,
          gst_type: this.vendorBranchGstType ?? '',
          productgstAmount: productgstAmount.toFixed(2)
        });
      });
      console.log('debit note resultArray', resultArray);

      totaldiscount = 0;
      totalafterdiscount = totalbefortax;
      totalamount = totalbefortax + totaltax;
      roundedamount = totalamount;
    }
    else {
      (itemdetails || []).forEach(item => {
        let itemName = this.getProductTypeName?.(item.productType) ?? '';
        let cgst = 0, sgst = 0, igst = 0;
        const gstId = item.taxType;

        if (gstId) {
          if (this.gstMatch()) {
            cgst = this.getCGSTPercentage?.(gstId) ?? 0;
            sgst = this.getSGSTPercentage?.(gstId) ?? 0;
          } else {
            igst = this.getIGSTPercentage?.(gstId) ?? 0;
          }
        }

        let totalamount = (item.qty || 0) * (item.unitPrice || 0);
        totalSum += totalamount;

        let discountamount = ((totalamount * (item.discount || 0)) / 100).toFixed(2);
        let taxValue = this.productTaxAmount?.(item);
        let productgstAmount = typeof taxValue === 'number' ? taxValue.toFixed(2) : 'NA';
        resultArray.push({
          id: item.productType ?? '',
          name: itemName,
          description: item.description ?? '',
          quantity: item.qty ?? 0,
          unitprice: item.unitPrice ?? 0,
          hsn: item.hsn_no ?? '',
          unit: item?.unit?.unit_name ??'', 
          cgst,
          sgst,
          igst,
          gst_type: this.vendorBranchGstType,
          amount: totalamount,
          discountamount,
          productgstAmount
        });
      });
      totalbefortax = totalSum;
      totaldiscount = this.getTotaldiscount?.() ?? 0;
      totalafterdiscount = this.getTotalAmount?.() ?? 0;
      totaltax = this.getTotalGSTAmount?.() ?? 0;
      roundedamount = this.roundedamount ?? 0;
      totalamount = parseFloat(this.getTotalRoundedAmount?.()?.toFixed(2) ?? '0');
    }
     const allCategories = Array.from(categorySet).join('\n');


    const exportdata = {
      exportType: "pdf",
      expanded: "True",
      copy_key: copyKey,
      // vendor_id: this.customer ?? this.vendor,
  //    vendor_id: isCreditNote ? this.sales_invoice_details?.[0]?.customer_id ?? null : isPurchase ? this.vendor : this.customer,
  //    voucher_type: selectedVoucher?.voucher_type,
  //    customername: isCreditNote  ? this.sales_invoice_details?.[0]?.customer_name ?? '' : (this.customer_name ?? this.vendor_name ?? ''),
  //    customeraddress: isCreditNote ? this.sales_invoice_details?.[0]?.customer_address ?? '': (this.customer_address ?? this.vendor_address ?? ''),
  //    customeremail: isCreditNote ? this.sales_invoice_details?.[0]?.customer_email ?? '' : (this.customer_email ?? this.vendor_email ?? ''),
  //    customerphone: isCreditNote ? this.sales_invoice_details?.[0]?.customer_phone ?? '' : (this.customer_phone ?? this.vendor_phone ?? ''),    
  // //  customergstno: this.customer_gstno ?? '',
  //     customerpan: isCreditNote ? this.sales_invoice_details?.[0]?.customer_pan ?? '' : (this.customer_pan ?? this.vendor_pan ?? ''),
  //     customerbranchgst: isCreditNote? this.sales_invoice_details?.[0]?.customer_branch_gst ?? '': (this.customer_branch_gst ?? this.vendor_branch_gst??''),
  //     vendorname: isDebitNote ? this.vendor_name ?? '' : (this.customer_name ?? this.vendor_name ?? ''),
  //     vendoraddress: isDebitNote ? this.vendor_address ?? '' : (this.customer_address ?? this.vendor_address ?? ''),
  //     vendoremail: isDebitNote ? this.vendor_email ?? '' : (this.customer_email ?? this.vendor_email ?? ''),
  //     vendorphone: isDebitNote ? this.vendor_phone ?? '' : (this.customer_phone ?? this.vendor_phone ?? ''),
  //     vendorpan: isDebitNote ? this.vendor_pan ?? '' : (this.customer_pan ?? this.vendor_pan ?? ''),
  //     vendorbranchgst: isDebitNote ? this.vendor_branch_gst ?? '' : (this.customer_branch_gst ?? this.vendor_branch_gst??''),
     vendor_id: isPurchase ? this.vendor : this.customer,
     voucher_type: selectedVoucher?.voucher_type,
    //  customername: isSales ? this.customer_name : ((this.invoice_type === 'credit note'||this.invoice_type === 'sales') ? this.customers : ''),
    //  customeraddress: (isSales ||(this.invoice_type === 'credit note'||this.invoice_type === 'sales'))?this.customer_address : '',
    //  customeremail: (isSales ||(this.invoice_type === 'credit note'||this.invoice_type === 'sales'))?this.customer_email : '',
    //  customerphone:(isSales ||(this.invoice_type === 'credit note'||this.invoice_type === 'sales'))?this.customer_phone : '',    
    //  //  customergstno: this.customer_gstno ?? '',
    //   customerpan: (isSales ||(this.invoice_type === 'credit note'||this.invoice_type === 'sales'))?this.customer_pan : '',
    //   customerbranchgst: (isSales ||(this.invoice_type === 'credit note'||this.invoice_type === 'sales'))?this.customer_branch_gst : '',
    //   customeraddress1: (isSales || this.invoice_type === 'sales' || this.invoice_type === 'credit note') ? this.customer_address1 ?? '' : '',
    //   customerdistrict: (isSales || this.invoice_type === 'sales' || this.invoice_type === 'credit note') ? this.customer_district ?? '' : '',
    //   customercity: (isSales || this.invoice_type === 'sales' || this.invoice_type === 'credit note') ? this.customer_city ?? '' : '',
    //   customerpincode: (isSales || this.invoice_type === 'sales' || this.invoice_type === 'credit note') ? this.customer_pincode ?? '' : '',

      customerbranchgst: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_gst : '',
      customerbranchname: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_name : '',
      customerbranchaddress: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_address : '',
      customerbranchaddress1: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_address1 : '',
      customerbranchcity: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_city : '',
      customerbranchpincode: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_pincode : '',
      customerbranchdistrict: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_district : '',
      customerbranchstate: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_state : '',
      customerbranchtan: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_tan_no : '',
      customerbranchcin: (isSales || (this.invoice_type === 'credit note' || this.invoice_type === 'sales')) ? this.customer_branch_cin_no : '',
      // vendorname: isPurchase ? this.vendor_name : ((this.invoice_type === 'debit note'||this.invoice_type === 'purchase') ? this.vendors : ''),
      // vendoraddress: (isPurchase ||(this.invoice_type === 'debit note'||this.invoice_type === 'purchase'))?this.vendor_address : '',
      // vendoremail: (isPurchase ||(this.invoice_type === 'debit note'||this.invoice_type === 'purchase'))?this.vendor_email : '',
      // vendorphone: (isPurchase ||(this.invoice_type === 'debit note'||this.invoice_type === 'purchase'))?this.vendor_phone : '',
      // vendorpan: (isPurchase ||(this.invoice_type === 'debit note'||this.invoice_type === 'purchase'))?this.vendor_pan : '',
      // vendorbranchgst: (isPurchase ||(this.invoice_type === 'debit note'||this.invoice_type === 'purchase'))?this.vendor_branch_gst : '',
      vendorbranchgst: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_gst : '',
      vendorbranchname: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_name : '',
      vendorbranchaddress: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_address : '',
      vendorbranchaddress1: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_address1 : '',
      vendorbranchcity: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_city : '',
      vendorbranchpincode: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_pincode : '',
      vendorbranchdistrict: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_district : '',
      vendorbranchemail: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_email : '',
      vendorbranchphone: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_phone : '',
      vendorbranchcin: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_cin_no : '',
      vendorbranchtan: (isPurchase || (this.invoice_type === 'debit note' || this.invoice_type === 'purchase')) ? this.vendor_branch_tan_no : '',
      companyname: this.company_name ?? '',
      // companyaddress: this.company_address ?? '',
      // companyemail: this.company_email ?? '',
      // companyphone: this.company_phone ?? '',
      branchaddress: branch_billing_address,
      branchphone: branch_billing_phone,
      branchphone1:branch_billing_phone1,
      branchemail: branch_email,
      branchfax: branch_fax,
      branchwebsite: branch_website,
      companygstno: this.company_gstno ?? '',
      companypan: this.company_pan ?? '',
      companylogo: this.company_logo ?? '',
      companysignature: this.company_signature ?? '',
      companycin: this.company_cin ?? '',
      invoiceno: this.document_no ?? '',
      // date: this.issue_date ?? '',
      isposted:0,
      data: resultArray,
      totalbefortax: parseFloat(totalbefortax.toFixed(2)),
      totaldiscount: parseFloat(totaldiscount.toFixed(2)),
      totalafterdiscount: parseFloat(totalafterdiscount.toFixed(2)),
      totaltax: parseFloat(totaltax.toFixed(2)),
      roundedamount:parseFloat(roundedamount.toFixed(2)),
      totalamount: totalamount.toFixed(2),
      vouchernumber: this.voucherNo ?? '',
      doc_no,
      so_no,
      si_no,
      po_no,
      pi_no,
      // so_date,
      // start_date,
      // end_date,
      date: this.formatDateForPdf(this.issue_date),
      so_date: this.formatDateForPdf(so_date),
      //po_date: this.formatDateForPdf(po_date),
      sales_invoice_date: this.formatDateForPdf(sales_invoice_date),
      purchase_invoice_date: this.formatDateForPdf(purchase_invoice_date),
      credit_note_date:this.formatDateForPdf(credit_note_date),
      debit_note_date:this.formatDateForPdf(debit_note_date),
      start_date: this.formatDateForPdf(start_date),
      end_date: this.formatDateForPdf(end_date),
      branch_gst: branch_gst,
      category_name: allCategories,
      gst_type: isCreditNote ? this.sales_invoice_details?.[0]?.customer_branch_gst_type ?? '' : this.vendorBranchGstType,
      invoice_type: this.invoice_type??'',
    };
    console.log("Voucher Type:", this.voucherType);
    console.log("Vendor ID:", this.vendor);
    console.log("Customer ID:", this.customer);
    console.log('Export Data Payload:', exportdata);
    // return
    this.apiService.voucherpostingexport(exportdata).subscribe({
      next: (response) => {
        const downloadUrl = response[0];
        const filename = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);
        const downloadLink = document.createElement('a');
        downloadLink.href = downloadUrl;
        downloadLink.download = filename;
        downloadLink.target = '_blank';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      },
      error: (error) => console.error('Error sending data:', error),
    });

  } catch (error) {
    console.error('Error in convertToPdf():', error);
  }
}

  fetchPurchaseInvoice(salesPurchaseId: any = null, voucherData: any = null) {
     const postData = {
      Invoice_type: this.invoice_type,
      branch_id: this.branch
    };
    this.apiService.getPi(postData).subscribe(
      (response) => {
        this.purchase_invoice = response;
        console.log('purchase invoice', this.purchase_invoice);
        if(salesPurchaseId){
          this.purchaseInvoice = salesPurchaseId;
          this.fetchProfitCostFromInvoice(this.invoice_type,this.purchaseInvoice);
          this.fetchPurchaseInvoiceDetails(this.purchaseInvoice, voucherData);
        }
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );

  }
 
  // fetchpi(pi: any) {
  //   this.pi_id = pi;
  //   console.log('pi', pi);
  // }

  // onCheckboxChange(pi: any,type:any,side:any) {
  //   if (this.isChecked) {
  //     const postdata = {
  //       creation_id: this.pi_id,
  //       side: side,
  //       is_qc:1
  //     }
  //     this.apiService.getPiLedger(postdata).subscribe((data: any) => {
  //       console.log('checkbox Dr data', data.ledger_data);

  //     this.creditsides = data.ledger_data.map(credit => {
  //       console.log('credit ledger1',credit.ledger.id);
  //         return {
  //           toBranch:'',
  //           creditLedgerType: credit.ledger.id,
  //           creditAmount: credit.value,
  //           creditDescription: ''
  //         };
  //       });
  //       this.totalCreditValue = data.ledger_data.reduce((total, credit) => {
  //         return total + credit.value;
  //       }, 0); 
        
  //       console.log('Total Credit Value:', this.totalCreditValue);
  //     });
  //   } else{
  //      this.creditsides = [{
  //       creditLedgerType: null,
  //       creditAmount: null,
  //       creditDescription: null
  //     }];
  //   }
  // }
  // onCheckboxChanges(pi: any,type:any,side:any){
  //   if (this.isChecked) {
  //     const postdata = {
  //       creation_id: this.pi_id,
  //       side: side,
  //       is_qc:1
  //     }
  //     this.apiService.getPiLedger(postdata).subscribe((data: any) => {
  //       console.log('checkbox Cr data', data.ledger_data);

  //       this.debitsides = data.ledger_data.map(debit => {
  //         console.log('debit ledger1',debit.ledger.id);
  //         console.log('total cr', this.calculateTotalCredit());
  //         return {
  //           fromBranch:'',
  //           debitLedgerType: debit.ledger.id,
  //           debitAmount:  this.totalCreditValue,
  //           debitDescription: ''
  //         };
  //       });
  //     });
  //   }else{
  //     this.debitsides= [{
  //       debitLedgerType: null,
  //       debitAmount: null,
  //       debitDescription: null
  //     }];
  //   }
  // }

  fetchSalesInvoice(salesPurchaseId: any = null, voucherData: any = null) {
    const postData = {
      Invoice_type: this.invoice_type,
      branch_id: this.branch
    };
    this.apiService.getPi(postData).subscribe(
      (response) => {
        this.sales_invoice = response;
        console.log('sales invoice', this.sales_invoice);
         if(salesPurchaseId){
          this.salesInvoice = salesPurchaseId;
          this.fetchProfitCostFromInvoice(this.invoice_type,this.salesInvoice);
          this.fetchSalesInvoiceDetails(this.salesInvoice, voucherData);
        }
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );

  }

  fetchCreditNote(salesPurchaseId: any = null) {
    const postData = {
      Invoice_type: this.invoice_type,
      branch_id: this.branch
    };
    this.apiService.getPi(postData).subscribe(
      (response) => {
        this.credit_note = response;
        console.log('credit note', this.credit_note);
         if(salesPurchaseId){
          this.creditNote = salesPurchaseId;
          this.fetchProfitCostFromInvoice(this.invoice_type,this.creditNote);
          this.fetchCreditNoteDetails(this.creditNote);
        }
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );

  }

  fetchDebitNote(salesPurchaseId: any = null) {
    const postData = {
      Invoice_type: this.invoice_type,
      branch_id: this.branch
    };
    this.apiService.getPi(postData).subscribe(
      (response) => {
        this.debit_note = response;
        console.log('debit note', this.debit_note);
         if(salesPurchaseId){
          this.debitNote = salesPurchaseId;
          this.fetchProfitCostFromInvoice(this.invoice_type,this.debitNote);
          this.fetchDebitNoteDetails(this.debitNote);
        }
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );

  }

  // fetchsi(pi: any) {
  //   this.si_id = pi;
  //   console.log('pi', pi);
  // }
  
  onInvoiceTypeChange() {
    console.log('invoice type', this.invoice_type);
    if (this.invoice_type === 'credit note') {
      this.fetchCreditNote();
    } else if (this.invoice_type === 'debit note') {
      this.fetchDebitNote();
    }else if (this.invoice_type === 'purchase') {
      this.fetchPurchaseInvoice();
    }else if (this.invoice_type === 'sales') {
      this.fetchSalesInvoice();
    }
  }

  fetchvouchertype(id: number): any {
    this.voucher_data = this.vouchers.find(item => item.id === id);
    this.voucher_type = this.voucher_data.voucher_type;
    // if (this.voucher_type == "Credit Note") {
    //   //this.fetchPurchaseInvoice();
    //   this.fetchSalesInvoice();
    // }else if(this.voucher_type=="Debit Note"){
    //   //this.fetchSalesInvoice();
    // }else 
      if(this.voucher_type=="Inventory Voucher"){
      this.getEmployeelist();
    forkJoin({
      stores: this.apiService.getStore(),
      profitCosts: this.apiService.getProfitCostCenter(),
      section: this.apiService.getSection(),
      branch: this.apiService.getbranchData(),
    }).subscribe(({ stores, profitCosts, section, branch }) => {
      this.store_data = stores;
      this.profitCostData = profitCosts.data;
      this.all_section_data = section;
      this.branch_data = branch;
      if (this.data?.branch_id) {
        this.branch_id = this.data.branch_id;
        this.onInvBranchChange(this.branch_id);
      }
      setTimeout(() => {
        if (this.data?.profit_costs) {
          this.profitcost_id = this.data.profit_cost_id;
          this.onProfitCostChange(this.profitcost_id);
          this.onProfitCost(this.profitcost_id);
          setTimeout(() => {
            if (this.data?.store_id) {
              this.store_id = this.data.store_id;
            }
          }, 100);
        }
      }, 100);
    }, error => {
      console.error('Error fetching initial data:', error);
    });

    }else if((this.voucher_type=="Purchase" || this.voucher_type=="Sales") && this.is_pi_si_manual==1){
      this.fetchCombinedData();
    }
    this.fetchbranchData();
    console.log('voucher data',this.voucher_data);
    console.log('voucher type',this.voucher_type);
    this.resetFields([
      'voucherType'
    ]);
  }
  fetchqc() { //fetch grn by vendor branch id
    this.productList=[];
    this.grn=[];
    // this.vendor_branch_id = vendor_branch_id;
    console.log('vendor id ',this.vendor_branch_id)
    const postData = {
      section_id: this.selectedPiSection,
      vendor_id: this.vendor,
      vendor_branch_id:this.selectedVendorBranch
    };
    this.apiService.getGrnByVendor(postData).subscribe(
      (response) => {
        this.grn = response;
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  fetchGsn() {
    this.productList=[];
    this.gsn = [];
    // this.section_id = customer_id;
    // console.log('customer id ',this.customer_branch_id)
    const postData = {
      section_id: this.selectedSection,
      customer_id: this.customer,
      customer_branch_id:this.selectedCustomerBranch
    };
    this.apiService.getGsnByCustomer(postData).subscribe(
      (response) => {
        this.gsn = response;
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  onSearchClick(): void {
    if(this.selectedGrn.length !== 0){
      console.log('grn');
      this.fetchGrnProductList();
    }else if (this.selectedGsn.length !== 0) {
      console.log('gsn');
      this.fetchGsnProductList();
    }
  }
  is_sku=false;
  is_service=false;
  is_fixed_asset=false;
  fetchGrnProductList(): void {
    console.log('grn1');
    this.apiService.getGrnDetails(this.selectedGrn,this.selectedPiSection,this.profit_cost_id).subscribe(
      (response) => {
        const missingNames: string[] = [];
        const grnList: any[] = [];

        for (const grn of response.data || []) {
        for (const detail of grn.details || []) {
          if (detail.item_service_type === 'SKU') {
            this.is_sku=true;
            const skuMaps = detail.sku?.sku_detail_maps || [];
            const missingCrMaps = skuMaps.filter((m: any) => m.dr_ledger === null && m.voucher_id === this.voucherType);

            if (missingCrMaps.length > 0) {
              const skuName = detail.sku?.sku_name || 'Unknown SKU';
              missingNames.push(skuName);
            }
          }
          if (detail.item_service_type === 'Service') {
            this.is_service=true;
            const serviceLedger = detail.service?.service_ledger_map;

            if (serviceLedger && serviceLedger.dr_ledger === null && serviceLedger.voucher_id === this.voucherType) {
              const serviceName = detail.service?.service_name || 'Unknown Service';
              missingNames.push(serviceName);
            }
          }
          if (detail.item_service_type === 'Fixed Asset') {
            this.is_fixed_asset=true;
          }
        }
        grnList.push({
            ...grn,
            details: (grn.details || []).filter(
              (detail: any) => this.data?.id
                  ? ((this.productEntries && this.productEntries.some((entry: any) => entry.productType?.id == detail.sku_id 
                  && entry.grn_gsn_details_id == detail.id &&
                   entry.selectedPiSection == detail.section_id ))?true: ( Number(detail.receive_qty) != 0 && detail.remaining_qty != 0))
                  : Number(detail.receive_qty) != 0 && detail.remaining_qty != 0
            ),
        });
        }
        if (missingNames.length > 0) {
          alert(`DR Ledger not found for: ${missingNames.join(', ')}`);
        }
        this.productList = grnList;
        if(this.is_sku || this.is_fixed_asset){
          this.fetchHsnData('item');
        }
        if(this.is_service){
          this.fetchHsnData('service');
        }
        this.fetchtaxData();
      },
      (error) => {
        console.error('Error fetching GRN products:', error);
        this.productList = [];
      }
    );
  }
  hsn_data: any[] = [];
  fetchHsnData(hsn_type: string) { //Get Hsn/Sac Data//
    this.adminService.getHsnSacType(hsn_type).subscribe(
      (response) => {
        const newResults = response.data || [];
        newResults.forEach(newItem => {
          if (!this.hsn_data.find(h => h.hsn_sac_no === newItem.hsn_sac_no)) {
            this.hsn_data.push(newItem);
          }
        });

        const targetType = hsn_type === 'item' ? ['SKU' , 'Fixed Asset'] : ['Service'];

        this.productList?.forEach(grn => {
          grn.details?.forEach(detail => {
            if (targetType.includes(detail.item_service_type) && detail.hsn_no) {
              const match = this.hsn_data.find(h => h.hsn_sac_no === detail.hsn_no);
              if (match) {
                detail.hsn_no = match.hsn_sac_no;
                detail.hsn_sac = match;
              }
            }
          });
        });

        // if update mode, sync from productEntries
        if (this.data.id) {
          if (this.productList?.length && this.productEntries?.length) {
            this.productList.forEach(product => {
              product.details?.forEach(detail => {
                if (targetType.includes(detail.item_service_type)) {
                  const detailId = detail.item_service_type === 'SKU' ? detail.sku_id : (detail.item_service_type === 'Fixed Asset' ? detail.fa_template?.id : detail.service?.id);
                  const entry = this.productEntries.find(e =>
                    e.selectedGrn === product.id &&
                    e.productType?.id === detailId
                  );

                  if (entry && entry.hsn_no) {
                    detail.hsn_no = entry.hsn_no;
                    // const match = this.hsn_data.find(h => h.hsn_sac_no === detail.hsn_no);
                    // if (match) {
                    //   detail.hsn_sac = match;
                      detail.specification = entry.specification;
                    // } else if (entry.taxType) {
                      // Fallback only if match not found in collected masters
                      detail.hsn_sac = { gst_id: entry.taxType };
                    // }
                  }
                }
              });
            });
          }
        }
      },
      (error) => {
        console.error('Error fetching HSN data:', error);
      }
    );
  }

  fetchGsnProductList(): void {
    console.log('gsn2');
    this.apiService.getGsnDetails(this.selectedGsn,this.profit_cost_id,this.selectedSection).subscribe(
      (response) => {
        const missingNames: string[] = [];
        const gsnList: any[] = [];
      for (const gsn of response.data || []) {
        for (const detail of gsn.details || []) {
          if (detail.item_service_type === 'SKU') {
            const skuMaps = detail.sku?.sku_detail_maps || [];
            const missingCrMaps = skuMaps.filter((m: any) => m.cr_ledger === null && m.voucher_id === this.voucherType);
            if (missingCrMaps.length > 0) {
              const skuName = detail.sku?.sku_name || 'Unknown SKU';
              missingNames.push(skuName);
            }
          }
          if (detail.item_service_type === 'Service') {
            const serviceLedger = detail.service?.service_ledger_map;

            if (serviceLedger && serviceLedger.cr_ledger === null && serviceLedger.voucher_id === this.voucherType) {
              const serviceName = detail.service?.service_name || 'Unknown Service';
              missingNames.push(serviceName);
            }
          }
        }
        gsnList.push({
            ...gsn,
            details: (gsn.details || []).filter(
              (detail: any) => 
                this.data?.id
                  ? ((this.productEntries && this.productEntries.some((entry: any) => entry.productType?.id == detail.sku_id 
                  && entry.grn_gsn_details_id == detail.id && entry.profit_cost_id == detail.profit_cost_id &&
                   entry.selectedSection == detail.section_id))?true: (Number(detail.send_qty) != 0 && detail.remaining_qty != 0))
                  : Number(detail.send_qty) != 0 && detail.remaining_qty != 0
            ),
          });
      }
        if (missingNames.length > 0) {
          alert(`CR Ledger not found for: ${missingNames.join(', ')}`);
        }
        this.productList = gsnList;
        this.fetchtaxData();
      },
      (error) => {
        console.error('Error fetching Po products:', error);
        this.productList = [];
      }
    );
  }

  getVendorBranch(VendorId: number) {
    this.apiService.getCustomerVendorBranch(this.branch, VendorId, 'vendor').subscribe(
      (response) => {
        this.vendorBranchData = response.vendor_branch;
        const vendorDetails = response.vendor_branch[0]?.vendor;
        this.vendor_name = vendorDetails.vendor_name;
        this.vendor_email = vendorDetails.email;
        this.vendor_phone = vendorDetails.phone;
        this.vendor_address = vendorDetails.address;
        this.vendor_gstno = vendorDetails.gst_number;
        this.vendor_pan = vendorDetails.pan;
        this.vendor_branch_gst = response.vendor_branch[0]?.gst_number ?? '';
        this.vendor_branch_address = response.vendor_branch[0]?.address ?? '';
        this.vendor_branch_address1 = response.vendor_branch[0]?.address1 ?? '';
        this.vendor_branch_city = response.vendor_branch[0]?.city ?? '';
        this.vendor_branch_pincode = response.vendor_branch[0]?.pin_code ?? '';
        this.vendor_branch_district = response.vendor_branch[0]?.district ?? '';
        this.vendor_branch_name = response.vendor_branch[0]?.branch_name ?? '';
        this.vendor_branch_email = response.vendor_branch[0]?.email ?? '';
        this.vendor_branch_phone = response.vendor_branch[0]?.phone ?? '';
        this.vendor_branch_cin_no = response.vendor_branch[0]?.cin_no ?? '';
        this.vendor_branch_tan_no = response.vendor_branch[0]?.tan_no ?? '';
        this.gstType();
      },
      (error) => {
        console.error('Error fetching vendor branch:', error);
      }
    );
  }
  
  getCustomerBranch(CustomerId: number) {
    this.apiService.getCustomerVendorBranch(this.branch, CustomerId, 'customer').subscribe(
      (response) => {
        this.customerBranchData = response.customer_branch;
        const customerDetails = response.customer_branch[0]?.customer;
        this.customer_name = customerDetails.customer_name;
        this.customer_email = customerDetails.email;
        this.customer_phone = customerDetails.phone;
        this.customer_address = customerDetails.address;
        this.customer_address1 = customerDetails.address1;
        this.customer_district = customerDetails.district;
        this.customer_pincode = customerDetails.pin_code;
        this.customer_city = customerDetails.city;
        // this.customer_gstno = customerDetails.gst_number;
        this.customer_pan = customerDetails.pan;
        // this.customer_branch_gst = response.customer_branch[0]?.gst_number ?? '';
        // this.customer_branch_address = response.customer_branch[0]?.address ?? '';
        // this.customer_branch_address1 = response.customer_branch[0]?.address1 ?? '';
        // this.customer_branch_city = response.customer_branch[0]?.city ?? '';
        // this.customer_branch_pincode = response.customer_branch[0]?.pin_code ?? '';
        // this.customer_branch_district = response.customer_branch[0]?.district ?? '';
        // this.customer_branch_name = response.customer_branch[0]?.branch_name ?? '';
        this.gstType();
      },
      (error) => {
        console.error('Error fetching customer branch:', error);
      }
    );
  }
  CustomerBranchdetails(CustomerId: number) {
    this.apiService.customerbranchdetails(CustomerId).subscribe(
      (response) => {
        this.customerBranchdetails = response;
        console.log('customer branch details', this.customerBranchdetails);
        this.customer_branch_gst = this.customerBranchdetails.gst_number ?? '';
        this.customer_branch_address = this.customerBranchdetails.address ?? '';
        this.customer_branch_address1 = this.customerBranchdetails.address1 ?? '';
        this.customer_branch_city = this.customerBranchdetails.city ?? '';
        this.customer_branch_pincode = this.customerBranchdetails.pin_code ?? '';
        this.customer_branch_district = this.customerBranchdetails.district ?? '';
        this.customer_branch_name = this.customerBranchdetails.branch_name ?? '';
        this.customer_branch_state = this.customerBranchdetails.state_name ?? '';
        this.customer_branch_tan_no = this.customerBranchdetails.tan_no ?? '';
        this.customer_branch_cin_no = this.customerBranchdetails.cin_no ?? '';
      },
      (error) => {
        console.error("Error fetching branch data:", error);
      }
    );
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.key;
    if ((charCode >= '0' && charCode <= '9') || charCode === '.') {
      return true;
    }
    event.preventDefault();
    return false;
  }
  // vendordata(data: any) {
  //   this.apiService.showVendorById(data).subscribe(
  //     (response) => {
  //       console.log('vendor_details',response);
  //       this.vendor_name = response.vendor_name;
  //       this.vendor_email = response.email;
  //       this.vendor_phone = response.phone;
  //       this.vendor_address = response.address;
  //       this.vendor_gstno = response.gst_number;
  //       this.vendor_pan = response.pan;
  //       this.vendor_branch_gst = response.vendor_branch?.gst_number ?? '';
  //       // this.gst_type = response.vendor_branch?.gst_type
  //     },
  //     (error) => {
  //       console.error('Error fetching vendordata:', error);
  //     }
  //   );
  // }

  closeDialog(): void {
    this.dialogRef.close();
  }
  fetchSectionData() {
    this.apiService.getSection().subscribe(
      (response) => {
        this.sectionData = response;
        this.all_section_data = response;
        // this.filteredSections = this.sectionData.filter(s => s.profit_cost_id === this.profit_cost_id);
        this.filteredSections = this.sectionData.filter(s =>
          this.profit_cost_id.includes(s.profit_cost_id)
        );
      // if (this.data?.section_id) {
      //   const found = this.filteredSections.find((item: any) => item.id === this.data.section_id);
      //   if (found) {
      //     this.selectedPiSection = found.id;
      //   }
      // }
      if (this.data?.showInter === 'Purchase') {
        console.log('purchase section')
        this.selectedPiSection =this.section_selected;
          // this.fetchqc();
          // const found = this.filteredSections.find((item: any) => item.id === this.data.section_id);
          // if (found) {
          //   this.selectedPiSection = found.id;
          // }
          
        } else {
          console.log('sales section')
      this.selectedSection=this.section_selected
      this.fetchGsn();
    }
        console.log('section_data :', this.sectionData);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  onSectionChange(sectionId: number) {
    if (sectionId) {
      this.resetFields([
        'voucherType',
        'branch',
        'profit_cost_id',
        'customer',
        'selectedCustomerBranch',
        'selectedSection'
      ]);
      this.fetchGsn();
    }
  }
  onPiSectionChange(sectionId: number) {
    this.resetFields([
      'voucherType',
      'branch',
      'profit_cost_id',
      'vendor',
      'selectedVendorBranch',
      'selectedPiSection'
    ]);
    if (sectionId) {
      this.fetchqc();
    }
  }
getPassQtyForSku(product: any, skuId: number): number {
  let total = 0;
  if (product?.quality_check?.length) {
    for (const qc of product.quality_check) {
      if (qc.details?.length) {
        for (const d of qc.details) {
          if (d.sku_id === skuId) {
            total = Number(d.pass_qty) || 0;
          }
        }
      }
    }
  }
  return total;
  }
  fetchProfitCostData(): void {
    const postData = {
      branch_id: this.branch
    };
    this.apiService.getProfitCostByStore(postData).subscribe(
      (response) => {
        this.profit_cost = response;
      },
      (error) => {
        console.error("Error fetching data:", error);
      }
    );
  }
  getEmployeelist() {
    this.apiService.getEmployeelist().subscribe(
      (response) => {
        console.log('SO List response:', response);
        this.employee_data = response?.emplist?.data || [];
      },
      (error) => {
        console.error('Error fetching SO list:', error);
      }
    );
  }
  addSO(sku: any) {
    sku.soList = sku.soList || [];
    sku.soList.push({
      employee_id: null,
      qty: 0
    });
  }
  // validateQty(sku: any) {
  //   const totalQty = this.getTotalQty(sku);
  //   if (totalQty > sku.qty) {
  //     alert(`Total SO quantity (${totalQty}) exceeds stock (${sku.qty})!`);
  //     return false;
  //   }
  //   return true;
  // }
  getTotalQty(sku: any): number {
    return sku.soList?.reduce((sum: number, so: any) => sum + (so.selectQty || 0), 0) || 0;
  }
  patchVoucherForm(voucherData: any) {
    const voucher = voucherData.Voucher;
    this.is_posted = voucher.is_posted;

    this.inv_branch = voucher.inventory_voucher_details[0]?.branch_id;
    this.onInvBranchChange(this.inv_branch);

    this.profitcost_id = voucher.inventory_voucher_details[0]?.profit_cost_id;
    this.onProfitCostChange(this.profitcost_id);

    this.store_id = voucher.store_id || (voucher.inventory_voucher_details[0]?.store_id || null);
    const sectionMap = new Map<number, number>();
    voucher.inventory_voucher_details.forEach(d => {
      if (!sectionMap.has(d.sku_id)) {
        sectionMap.set(d.sku_id, d.section_id);
      }
    });

    this.inv_section_id = Array.from(sectionMap.values());
    this.apiService.getInventorySku({ inv_section_id: this.inv_section_id, store_id: this.store_id }).subscribe(
      (response) => {
        this.sku = response.filter(item => item.details && item.details.length > 0);
        const grouped: { [key: number]: any[] } = {};
        voucher.inventory_voucher_details.forEach(d => {
          if (!grouped[d.sku_id]) grouped[d.sku_id] = [];
          grouped[d.sku_id].push(d);
        });
        this.tableSkus = Object.keys(grouped).map(skuIdStr => {
          const skuId = parseInt(skuIdStr, 10);
          const skuItem = this.sku.find(s => s.id === skuId);
          const details = grouped[skuId];

          return {
            ...skuItem,
            soList: details.map(d => ({
              employee_id: d.employee_id,
              selectQty: d.qty,
              lifoBreakdown: this.getLifoFifoBreakdown(skuItem, { selectQty: d.qty }),
              lifoValue: this.getLifoFifoValue(skuItem, { selectQty: d.qty })
            }))
          };
        });

        this.selectedSkuId = Object.keys(grouped).map(k => parseInt(k, 10));
      },
      (error) => console.error('Error fetching SKUs for update:', error)
    );
  }
  gstType() {
    if (this.selectedVendorBranch && Array.isArray(this.vendorBranchData)) {
      const vendorBranch = this.vendorBranchData.find(
        (branch: any) => branch.id === this.selectedVendorBranch
      );
      this.vendorBranchGstType = vendorBranch?.gst_type ?? null;
      this.vendorBranchGstNumber = vendorBranch?.gst_number ?? null;
    } else if (this.selectedCustomerBranch && Array.isArray(this.customerBranchData)) {
      const customerBranch = this.customerBranchData.find(
        (branch: any) => branch.id === this.selectedCustomerBranch
      );
      this.vendorBranchGstType = customerBranch?.gst_type ?? null;
      this.vendorBranchGstNumber = customerBranch?.gst_number ?? null;
    }
  }

  fetchSalesInvoiceDetails(Invoice_Id: number, savedDetails: any[] = []) {
    const data = {
      Invoice_Id: Invoice_Id,
      profit_cost_id: this.profit_cost_id
    }
    this.apiService.PostedVoucherdetails(data).subscribe(
      (response) => {
        console.log('sales invoice details', response);
        this.sales_invoice_details = response;
        this.customers = this.sales_invoice_details[0].customer_name;
        this.cutomer_branchs = this.sales_invoice_details[0].customer_branch_name;
        this.customer_branch_name = this.sales_invoice_details[0].customer_branch_name;
        //this.cutomer_branch_ledger_id = this.sales_invoice_details[0].customer_branch_ledger_id;
        //this.cutomer_branch_ledger_name = this.sales_invoice_details[0].customer_branch_ledger_name;
        this.customer_address  = this.sales_invoice_details[0].customer_address;
        this.customer_email = this.sales_invoice_details[0].customer_email;
        this.customer_pan = this.sales_invoice_details[0].customer_pan;
        this.cutomer_branchs = this.sales_invoice_details[0].customer_branch_name;
        this.customer_branch_gst = this.sales_invoice_details[0].customer_branch_gst;
        this.customer_branch_address = this.sales_invoice_details[0].customer_branch_address;
        this.customer_branch_address1 = this.sales_invoice_details[0].customer_branch_address1;
        this.customer_branch_city = this.sales_invoice_details[0].customer_branch_city;
        this.customer_branch_district = this.sales_invoice_details[0].customer_branch_district;
        this.customer_branch_pincode = this.sales_invoice_details[0].customer_branch_pincode;
        this.customer_branch_state = this.sales_invoice_details[0].customer_branch_state;
        this.customer_branch_cin_no = this.sales_invoice_details[0].customer_branch_cin_no;
        this.customer_branch_tan_no = this.sales_invoice_details[0].customer_branch_tan_no;
        this.customer_phone = this.sales_invoice_details[0].customer_phone;
        this.unit_name = this.sales_invoice_details[0].unit_name; 
        this.invoice_date = this.sales_invoice_details[0].sales_invoice_date;
        this.vendorBranchGstType= this.sales_invoice_details[0].customer_branch_gst_type;
        this.customerbranchledger(this.sales_invoice_details[0].customer_branch_id,this.branch);

        if (savedDetails && savedDetails.length > 0) {
          this.sales_invoice_details.forEach(item => {
            const match = savedDetails.find(d => d.grn_gsn_details_id === item.grn_gsn_details_id && d.product_id === item.product_id);
            if (match) {
              item.change_qty = match.qty;
              item.change_value = match.value;
              item.pending_qty = Number(item.pending_qty) + Number(match.qty);
              item.final_discount = match.discount_amount;
              item.final_incentive = match.incentive_amount;
            }
          });
          console.log('sales invoice details final', this.sales_invoice_details);
        }

        console.log('customer', this.customers);
        console.log('customer branch', this.cutomer_branchs);
        console.log('sales invoice details', this.sales_invoice_details);
        console.log('customer branch ledger', this.cutomer_branch_ledger_id);
        console.log('customer branch ledger name ', this.cutomer_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }

  fetchPurchaseInvoiceDetails(Invoice_Id: number, savedDetails: any[] = []) {
    const data = {
      Invoice_Id: Invoice_Id,
      profit_cost_id: this.profit_cost_id
    }
    this.apiService.PostedVoucherdetails(data).subscribe(
      (response) => {
        console.log('purchase invoice details', response);
        this.purchase_invoice_details = response;
        this.vendors = this.purchase_invoice_details[0].vendor_name;
        this.vendor_branchs = this.purchase_invoice_details[0].vendor_branch_name;
        this.vendor_branch_name = this.purchase_invoice_details[0].vendor_branch_name;
        //this.vendor_branch_ledger_id = this.purchase_invoice_details[0].vendor_branch_ledger_id;
        //this.vendor_branch_ledger_name = this.purchase_invoice_details[0].vendor_branch_ledger_name;
        this.vendor_address = this.purchase_invoice_details[0].vendor_address;
        this.vendor_email = this.purchase_invoice_details[0].vendor_email;
        this.vendor_pan = this.purchase_invoice_details[0].vendor_pan;
        this.vendor_phone = this.purchase_invoice_details[0].vendor_phone;
        //this.vendor_branchs = this.purchase_invoice_details[0].vendor_branch_name;
        this.vendor_branch_gst = this.purchase_invoice_details[0].vendor_branch_gst;
        this.vendor_branch_address = this.purchase_invoice_details[0].vendor_branch_address;
        this.vendor_branch_address1 = this.purchase_invoice_details[0].vendor_branch_address1;
        this.vendor_branch_city = this.purchase_invoice_details[0].vendor_branch_city;
        this.vendor_branch_district = this.purchase_invoice_details[0].vendor_branch_district;
        this.vendor_branch_pincode = this.purchase_invoice_details[0].vendor_branch_pincode;
        this.vendor_branch_email = this.purchase_invoice_details[0].vendor_branch_email;
        this.vendor_branch_phone = this.purchase_invoice_details[0].vendor_branch_phone;
        this.vendor_branch_cin_no = this.purchase_invoice_details[0].vendor_branch_cin_no;
        this.vendor_branch_tan_no = this.purchase_invoice_details[0].vendor_branch_tan_no;

        this.unit_name = this.purchase_invoice_details[0].unit_name;
        this.invoice_date = this.purchase_invoice_details[0].purchase_invoice_date;
        this.vendorBranchGstType= this.purchase_invoice_details[0].vendor_branch_gst_type;
        this.vendorbranchledger(this.purchase_invoice_details[0].vendor_branch_id,this.branch);
        if (savedDetails && savedDetails.length > 0) {
          this.purchase_invoice_details.forEach(item => {
            const match = savedDetails.find(d => d.grn_gsn_details_id === item.grn_gsn_details_id && d.product_id === item.product_id);
            if (match) {
              item.change_qty = match.qty;
              item.change_value = match.value;
              item.pending_qty = Number(item.pending_qty) + Number(match.qty);
            }
          });
          console.log('purchase invoice details final', this.purchase_invoice_details);
        }

        console.log('vendor', this.vendors);
        console.log('vendor branch', this.vendor_branchs);
        console.log('purchase invoice details', this.purchase_invoice_details);
        console.log('vendor branch ledger', this.vendor_branch_ledger_id);
        console.log('vendor branch ledger name ', this.vendor_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }
  fetchDebitNoteDetails(Invoice_Id: number) {
    const data = {
      Invoice_Id: Invoice_Id,
      profit_cost_id: this.profit_cost_id
    }
    this.apiService.PostedVoucherdetails(data).subscribe(
      (response) => {
        console.log('debit note details', response);
        this.debit_note_details = response;
        this.vendors = this.debit_note_details[0].vendor_name;
        this.vendor_branchs = this.debit_note_details[0].vendor_branch_name;
         this.vendor_branch_name = this.debit_note_details[0].vendor_branch_name;
        //this.vendor_branch_ledger_id = this.debit_note_details[0].vendor_branch_ledger_id;
        //this.vendor_branch_ledger_name = this.debit_note_details[0].vendor_branch_ledger_name;
        this.vendor_address = this.debit_note_details[0].vendor_address;
        this.vendor_email = this.debit_note_details[0].vendor_email;
        this.vendor_pan = this.debit_note_details[0].vendor_pan;
        this.vendor_phone = this.debit_note_details[0].vendor_phone;
        //this.vendor_branchs = this.purchase_invoice_details[0].vendor_branch_name;
        this.vendor_branch_gst = this.debit_note_details[0].vendor_branch_gst;
        this.vendor_branch_address = this.debit_note_details[0].vendor_branch_address;
        this.vendor_branch_address1 = this.debit_note_details[0].vendor_branch_address1;
        this.vendor_branch_city = this.debit_note_details[0].vendor_branch_city;
        this.vendor_branch_district = this.debit_note_details[0].vendor_branch_district;
        this.vendor_branch_pincode = this.debit_note_details[0].vendor_branch_pin_code;
        this.vendor_branch_email = this.debit_note_details[0].vendor_branch_email;
        this.vendor_branch_phone = this.debit_note_details[0].vendor_branch_phone;
        this.vendor_branch_cin_no = this.debit_note_details[0].vendor_branch_cin_no;
        this.vendor_branch_tan_no = this.debit_note_details[0].vendor_branch_tan_no;
        this.unit_name = this.debit_note_details[0].unit_name;
         this.invoice_date = this.debit_note_details[0].purchase_invoice_date;
         this.vendorBranchGstType= this.debit_note_details[0].vendor_branch_gst_type;
        this.vendorbranchledger(this.debit_note_details[0].vendor_branch_id,this.branch);
        console.log('vendor', this.vendors);
        console.log('vendor branch', this.vendor_branchs);
        console.log('purchase invoice details', this.purchase_invoice_details);
        console.log('vendor branch ledger', this.vendor_branch_ledger_id);
        console.log('vendor branch ledger name ', this.vendor_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }
  fetchCreditNoteDetails(Invoice_Id: number) {
    const data = {
      Invoice_Id: Invoice_Id,
      profit_cost_id: this.profit_cost_id
    }
    this.apiService.PostedVoucherdetails(data).subscribe(
      (response) => {
        console.log('credit note details', response);
        this.credit_note_details = response;
        this.customers = this.credit_note_details[0].customer_name;
        this.cutomer_branchs = this.credit_note_details[0].customer_branch_name;
        this.customer_branch_name = this.credit_note_details[0].customer_branch_name;
        // this.cutomer_branch_ledger_id = this.credit_note_details[0].customer_branch_ledger_id;
        // this.cutomer_branch_ledger_name = this.credit_note_details[0].customer_branch_ledger_name;
        this.customer_address = this.credit_note_details[0].customer_address;
        this.customer_email = this.credit_note_details[0].customer_email;
        this.customer_pan = this.credit_note_details[0].customer_pan;
        this.cutomer_branchs = this.credit_note_details[0].customer_branch_name;
        this.customer_branch_gst = this.credit_note_details[0].customer_branch_gst;
        this.customer_branch_address = this.credit_note_details[0].customer_branch_address;
        this.customer_branch_address1 = this.credit_note_details[0].customer_branch_address1;
        this.customer_branch_city = this.credit_note_details[0].customer_branch_city;
        this.customer_branch_district = this.credit_note_details[0].customer_branch_district;
        this.customer_branch_pincode = this.credit_note_details[0].customer_branch_pincode;
        this.customer_branch_state = this.credit_note_details[0].customer_branch_state;
        this.customer_branch_cin_no = this.credit_note_details[0].customer_branch_cin_no;
        this.customer_branch_tan_no = this.credit_note_details[0].customer_branch_tan_no;
        this.customer_phone = this.credit_note_details[0].customer_phone;
        this.unit_name = this.credit_note_details[0].unit_name;
         this.invoice_date = this.credit_note_details[0].sales_invoice_date;
         this.vendorBranchGstType= this.credit_note_details[0].customer_branch_gst_type;
        this.customerbranchledger(this.credit_note_details[0].customer_branch_id,this.branch);
        console.log('customer', this.customers);
        console.log('customer branch', this.cutomer_branchs);
        console.log('sales invoice details', this.sales_invoice_details);
        console.log('customer branch ledger', this.cutomer_branch_ledger_id);
        console.log('customer branch ledger name ', this.cutomer_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }

  fetchProfitCostFromInvoice(invoice_type: string, invoice_id: any) {
    const postData = {
      invoice_type: invoice_type,
      invoice_id: invoice_id
    };
    this.apiService.ProfitCostByInvoiceId(postData).subscribe(
      (response) => {
        console.log('profit cost', response);
        if (response) {
          this.profit_cost = response;
        }
      },
      (error) => {
        console.error('Error fetching profit cost:', error);
      }
    );
  }

  QtyChange(entry, qty, price) {
    if (this.is_affect_qty == false) {
      if (qty > entry.pending_qty) {
        entry.change_value = '';
        entry.change_qty = '';
        entry.final_discount = '';
        entry.final_incentive = '';
        alert('Change Quantity cannot be more than Pending Quantity!');
        return;
      } else if (qty < 0) {
        entry.change_value = '';
        entry.change_qty = '';
        entry.final_discount = '';
        entry.final_incentive = '';
        alert('Change Quantity cannot be less than 0!');
        return;
      }
      console.log('Sub qty:', qty);
      console.log('Sub price:', price);
      entry.change_value = parseFloat((qty * price).toFixed(2));

      if (entry.qty && entry.qty > 0) {
        if (entry.discount_amount) {
          entry.final_discount = parseFloat(((entry.discount_amount / entry.qty) * qty).toFixed(2));
        }
        if (entry.incentive_amount) {
          entry.final_incentive = parseFloat(((entry.incentive_amount / entry.qty) * qty).toFixed(2));
        }
      }
    }
  };

  PriceChange(entry, qty, price) {
    if (this.is_affect_qty == false) {
      if (price > ((entry.pending_qty) * (entry.unit_price))) {
        entry.change_value = '';
        entry.change_qty = '';
        entry.final_discount = '';
        entry.final_incentive = '';
        //alert('Change Value cannot be more than Value!');
        alert(`Change Value cannot be more than ${entry.pending_qty * entry.unit_price}`);
        return;
      } else if (price < 0) {
        entry.change_value = '';
        entry.change_qty = '';
         entry.final_discount = '';
        entry.final_incentive = '';
        alert('Change Value cannot be less than 0!');
        return;
      }
           entry.change_qty = parseFloat((price / entry.unit_price).toFixed(3));
      
      if (entry.qty && entry.qty > 0) {
        if (entry.discount_amount) {
          entry.final_discount = parseFloat(((entry.discount_amount / entry.qty) * entry.change_qty).toFixed(2));
        }
        if (entry.incentive_amount) {
          entry.final_incentive = parseFloat(((entry.incentive_amount / entry.qty) * entry.change_qty).toFixed(2));
        }
      }
    }
  };

  CreditNote() {
    let dialogData: any;
    let result = [];
    console.log("Final Data sales invoice details:", this.sales_invoice_details);
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    const selectedVoucherType = selectedVoucher?.voucher_type || '';

    if (this.invoice_type == 'sales') {
      result = this.sales_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          product_ledger: item.product_ledger,
          product_ledger_name: item.product_ledger_name,
          product_name:item.name,
          change_qty: item.change_qty,
          change_value: (Number(item.change_value || 0) - Number(item?.final_discount || 0) + Number(item?.final_incentive || 0)),
          taxType: item.gst_id,
          invoice_id: item.invoice_id,
        }));
    } else {
      result = this.credit_note_details
        .map(item => ({
          product_ledger: item.product_ledger,
          product_ledger_name: item.product_ledger_name,
          product_name:item.name,
          change_qty: item.qty,
          change_value: item.value-item.discount_amount+item.incentive_amount,
          taxType: item.gst_id,
          invoice_id: item.invoice_id,
        }));
    }

    const groupedResult = new Map<number, any>();
    result.forEach(item => {
      const key = item.product_ledger;
      if (groupedResult.has(key)) {
        const existing = groupedResult.get(key);
        existing.change_qty = (Number(existing.change_qty) || 0) + (Number(item.change_qty) || 0);
        existing.change_value = (Number(existing.change_value) || 0) + (Number(item.change_value) || 0);
      } else {
        groupedResult.set(key, { ...item });
      }
    });
    const productarray = Array.from(groupedResult.values());

    const totalChangeValue = productarray.reduce(
      (sum, item) => sum + Number(item.change_value),
      0
    );
    console.log("Filtered Result sales invoice details:", result);
    dialogData = {
      branch_id: this.branch,
      productDetails: result,
      productarray: productarray,
      type: selectedVoucherType,
      CustomerBranchLedgerId: this.cutomer_branch_ledger_id,
      CustomerBranchLedgerName: this.cutomer_branch_ledger_name,
      CustomerAmount: totalChangeValue,
      InvoiceType: this.invoice_type,
      taxledger: this.tax,
      gstMatch: this.gstMatch(),
      voucher: this.invoice_type === 'sales' ? 'Credit Note' : 'Debit Note',
    };
    console.log("Dialog Data credit note details:", dialogData);
    this.dialog.open(CreateProductViewDialogComponent, {
      width: '1200px',
      height: '550px',
      data: dialogData
    });
  }
  saveCreditNote(isApproval: boolean = false) {
    let debitEntries: any[] = [];
    let creditEntries: any[] = [];
    let totalValue = 0;
    if (!this.voucherType) {
      alert('Please select a Voucher type');
      return;
    }
    if (!this.invoice_type) {
      alert('Please select a Invoice type');
      return;
    }
    if (!this.branch) {
      alert('Please select a Branch');
      return;
    }
    if (!this.profit_cost_id) {
      alert('Please select a Profit Cost Center');
      return;
    }
    if (!this.date) {
      alert('Please select a Date');
      return;
    }
    if (!this.narration) {
      alert('Please enter Narration Before Submiting');
      return;
    }
    if (this.invoice_type == 'sales') {
      const originalProductEntries = this.productEntries;
      this.productEntries = this.sales_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          qty: 1,
          unitPrice: (Number(item.change_value || 0) - Number(item.final_discount || 0) + Number(item.final_incentive || 0)),
          discount: 0,
          taxType: item.gst_id
        }));
      const groupedGstDetails = this.getGroupedGstDetails();
      console.log("Grouped GST Details:", groupedGstDetails);
      this.productEntries = originalProductEntries;
      console.log("productEntries:", this.productEntries);
      debitEntries = this.sales_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          ledger_id: item.product_ledger,
          amount: (Number(item.change_value || 0) - Number(item.final_discount || 0) + Number(item.final_incentive || 0)),
          description: '',
        }));
      console.log("Debit Entries 1:", debitEntries);
      groupedGstDetails.forEach(entry => {
        debitEntries.push({
          ledger_id: entry.ledger_id,
          amount: entry.totalAmount.toFixed(2),
          description: '',
        });
      });

      totalValue = debitEntries.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );
      console.log("Total Value:", totalValue);

      creditEntries = [{
        ledger_id: this.cutomer_branch_ledger_id,
        amount: totalValue,
        description: ''
      }];
      console.log("Credit Entries:", creditEntries);
    } else {
      const originalProductEntries = this.productEntries;
      this.productEntries = this.debit_note_details
        .map(item => ({
          qty: 1,
          unitPrice: item.value,
          discount: 0,
          taxType: item.gst_id
        }));
      const groupedGstDetails = this.getGroupedGstDetails();
      this.productEntries = originalProductEntries;

      debitEntries = this.debit_note_details
        .map(item => ({
          ledger_id: item.product_ledger,
          amount: item.value,
          description: '',
        }));

      groupedGstDetails.forEach(entry => {
        debitEntries.push({
          ledger_id: entry.ledger_id,
          amount: entry.totalAmount.toFixed(2),
          description: '',
        });
      });

      totalValue = debitEntries.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );

      creditEntries = [{
        ledger_id: this.vendor_branch_ledger_id,
        amount: totalValue,
        description: ''
      }];
    }

    const groupEntries = (entries: any[]) => {
      const groupedMap = new Map<number, any>();
      entries.forEach(entry => {
        const key = entry.ledger_id;
        if (groupedMap.has(key)) {
          const existing = groupedMap.get(key);
          existing.amount = (Number(existing.amount) || 0) + (Number(entry.amount) || 0);
        } else {
          groupedMap.set(key, { ...entry });
        }
      });
      return Array.from(groupedMap.values()).map(e => ({
        ...e,
        amount: Number(e.amount).toFixed(2)
      }));
    };

    const groupedDr = groupEntries(debitEntries);
    console.log("Grouped Debit Entries:", groupedDr);
    const groupedCr = groupEntries(creditEntries);
    console.log("Grouped Credit Entries:", groupedCr);
    const postData = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      date: this.date,
      narration: this.narration,
      doc_type: 'credit note',
      total_cr: totalValue,
      total_dr: totalValue,
      dr: groupedDr,
      cr: groupedCr,
      details: this.invoice_type == 'debit note' ? this.debit_note_details : this.sales_invoice_details,
      branch_id: this.branch ?? null,
      //upload: this.uploadedFiles,
      profit_cost_id: this.profit_cost_id,
      sales_purchase_id: this.salesInvoice,
      credit_debit_id: this.invoice_type == 'debit note' ? this.debitNote : null,
      calculation_type: this.type,
      existing_uploads: this.existingFiles,
      new_uploads: this.uploadedFiles,
      invoice_type: this.invoice_type,
    };
    console.log('final payload', postData);
    //return;
    if (this.data?.id) {
      this.apiService.updateVoucherPosting(this.data.id, postData).subscribe(
        response => {
          console.log('Voucher updated successfully:');
          if (isApproval) {
            this.sendForApprove(true);
          } else {
            this.dialogRef.close(response);
          }
        },
        error => {
          console.error('Error updating voucher:', error);
        }
      );
    } else {
      this.apiService.createVoucherPosting(postData).subscribe(
        response => {
          console.log('Voucher Posting successfully:');
          this.dialogRef.close(response);
        },
        error => {
          console.error('Error posting voucher:', error);
        }
      );
    }
  }
  openLedgerBookModal(ledgerId: any) {
    this.dialog.open(LedgerBookComponent, {
      width: '95vw',
      height: '95vh',
      maxWidth: '100vw',
      data: {
        ledger_id: ledgerId,
        is_modal: true
      },
      panelClass: 'custom-modal-box'
    });
  }

  openStatementViewModal(ledgerId: any) {
    this.dialog.open(StatementViewComponent, {
      width: '95vw',
      height: '95vh',
      maxWidth: '100vw',
      data: {
        ledger_id: ledgerId,
        is_modal: true
      },
      panelClass: 'custom-modal-box'
    });
  }

  DebitNote() {
    let dialogData: any;
    let result = [];
    console.log("Final Data purchase invoice details:", this.purchase_invoice_details);
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    const selectedVoucherType = selectedVoucher?.voucher_type || '';
    if (this.invoice_type == 'purchase' && (this.is_affect_qty == false)) {
      result = this.purchase_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          product_ledger: item.product_ledger,
          product_ledger_name: item.product_ledger_name,
          product_name:item.name,
          change_qty: item.change_qty,
          change_value: item.change_value,
          taxType: item.gst_id,
          invoice_id: item.invoice_id,
        }));
    } else if (this.invoice_type == 'purchase' && (this.is_affect_qty == true)) {
      result = this.purchase_invoice_details
        .map(item => ({
          product_ledger: item.product_ledger,
          product_ledger_name: item.product_ledger_name,
          product_name:item.name,
          change_qty: item.qty,
          change_value: item.change_value,
          taxType: item.gst_id,
          invoice_id: item.invoice_id,
        }));
    } else {
      result = this.debit_note_details
        .map(item => ({
          product_ledger: item.product_ledger,
          product_ledger_name: item.product_ledger_name,
          product_name:item.name,
          change_qty: item.qty,
          change_value: item.value,
          taxType: item.gst_id
        }));
    }

    const groupedResult = new Map<number, any>();
    result.forEach(item => {
      const key = item.product_ledger;
      if (groupedResult.has(key)) {
        const existing = groupedResult.get(key);
        existing.change_qty = (Number(existing.change_qty) || 0) + (Number(item.change_qty) || 0);
        existing.change_value = (Number(existing.change_value) || 0) + (Number(item.change_value) || 0);
      } else {
        groupedResult.set(key, { ...item });
      }
    });
    const productarray = Array.from(groupedResult.values());

    const totalChangeValue = productarray.reduce(
      (sum, item) => sum + Number(item.change_value),
      0
    );

    console.log("Filtered Result:", result);
    dialogData = {
      branch_id: this.branch,
      productDetails: result,
      productarray: productarray,
      type: selectedVoucherType,
      VendorBranchLedgerId: this.vendor_branch_ledger_id,
      VendorBranchLedgerName: this.vendor_branch_ledger_name,
      VendorAmount: totalChangeValue,
      InvoiceType: this.invoice_type,
      taxledger: this.tax,
      gstMatch: this.gstMatch(),
      voucher: this.invoice_type === 'purchase' ? 'Debit Note' : 'Credit Note',
    };
    console.log("Dialog Data debit note details:", dialogData);
    this.dialog.open(CreateProductViewDialogComponent, {
      width: '1200px',
      height: '550px',
      data: dialogData
    });
  }
  saveDebitNote(isApproval: boolean = false) {
    let debitEntries: any[] = [];
    let creditEntries: any[] = [];
    let totalValue = 0;
    if (!this.voucherType) {
      alert('Please select a Voucher type');
      return;
    }
    if (!this.invoice_type) {
      alert('Please select a Invoice type');
      return;
    }
    if (!this.branch) {
      alert('Please select a Branch');
      return;
    }
    if (!this.profit_cost_id) {
      alert('Please select a Profit Cost Center');
      return;
    }
    if (!this.date) {
      alert('Please select a Date');
      return;
    }
    if (!this.narration) {
      alert('Please enter Narration Before Submiting');
      return;
    }
    if (this.invoice_type == 'purchase' && (this.is_affect_qty == false)) {
      console.log("if block");
      const originalProductEntries = this.productEntries;
      this.productEntries = this.purchase_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          qty: 1,
          unitPrice: item.change_value,
          discount: 0,
          taxType: item.gst_id
        }));
      const groupedGstDetails = this.getGroupedGstDetails();
      this.productEntries = originalProductEntries;

      creditEntries = this.purchase_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          ledger_id: item.product_ledger,
          amount: item.change_value,
          description: '',
        }));

      groupedGstDetails.forEach(entry => {
        creditEntries.push({
          ledger_id: entry.ledger_id,
          amount: entry.totalAmount.toFixed(2),
          description: '',
        });
      });

      totalValue = creditEntries.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );

      debitEntries = [{
        ledger_id: this.vendor_branch_ledger_id,
        amount: totalValue,
        description: ''
      }];
    }
    else if (this.invoice_type == 'purchase' && (this.is_affect_qty == true)) {
      console.log("else if block");
      const originalProductEntries = this.productEntries;
      this.productEntries = this.purchase_invoice_details
        .map(item => ({
          qty: 1,
          unitPrice: item.change_value,
          discount: 0,
          taxType: item.gst_id
        }));
      const groupedGstDetails = this.getGroupedGstDetails();
      this.productEntries = originalProductEntries;

      creditEntries = this.purchase_invoice_details
        .map(item => ({
          ledger_id: item.product_ledger,
          amount: item.change_value,
          description: '',
        }));

      groupedGstDetails.forEach(entry => {
        creditEntries.push({
          ledger_id: entry.ledger_id,
          amount: entry.totalAmount.toFixed(2),
          description: '',
        });
      });
      totalValue = creditEntries.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );

      debitEntries = [{
        ledger_id: this.vendor_branch_ledger_id,
        amount: totalValue,
        description: ''
      }];
    } else {
      console.log("else block");
      const originalProductEntries = this.productEntries;
      this.productEntries = this.credit_note_details
        .map(item => ({
          qty: 1,
          unitPrice: item.value-item.discount_amount+item.incentive_amount,
          discount: 0,
          taxType: item.gst_id
        }));
      const groupedGstDetails = this.getGroupedGstDetails();
      this.productEntries = originalProductEntries;

      creditEntries = this.credit_note_details
        .map(item => ({
          ledger_id: item.product_ledger,
          amount: item.value,
          description: '',
        }));

      groupedGstDetails.forEach(entry => {
        creditEntries.push({
          ledger_id: entry.ledger_id,
          amount: entry.totalAmount.toFixed(2),
          description: '',
        });
      });

      totalValue = creditEntries.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );

      debitEntries = [{
        ledger_id: this.cutomer_branch_ledger_id,
        amount: totalValue,
        description: ''
      }];
    }

    const groupEntries = (entries: any[]) => {
      const groupedMap = new Map<number, any>();
      entries.forEach(entry => {
        const key = entry.ledger_id;
        if (groupedMap.has(key)) {
          const existing = groupedMap.get(key);
          existing.amount = (Number(existing.amount) || 0) + (Number(entry.amount) || 0);
        } else {
          groupedMap.set(key, { ...entry });
        }
      });
      return Array.from(groupedMap.values()).map(e => ({
        ...e,
        amount: Number(e.amount).toFixed(2)
      }));
    };

    const groupedDr = groupEntries(debitEntries);
    const groupedCr = groupEntries(creditEntries);

    const postData = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      date: this.date,
      narration: this.narration,
      doc_type: 'debit note',
      total_cr: totalValue,
      total_dr: totalValue,
      dr: groupedDr,
      cr: groupedCr,
      details: this.invoice_type == 'credit note' ? this.credit_note_details : this.purchase_invoice_details,
      branch_id: this.branch ?? null,
      //upload: this.uploadedFiles,
      profit_cost_id: this.profit_cost_id,
      sales_purchase_id: this.purchaseInvoice,
      credit_debit_id: this.invoice_type == 'credit note' ? this.creditNote : null,
      calculation_type: this.type,
      existing_uploads: this.existingFiles,
      new_uploads: this.uploadedFiles,
      invoice_type: this.invoice_type,
      affect_qty: this.affect_qty ?? 1,
    };
    console.log('final payload', postData);
    //return;
    if (this.data?.id) {
      this.apiService.updateVoucherPosting(this.data.id, postData).subscribe(
        response => {
          console.log('Voucher updated successfully:');
          if (isApproval) {
            this.sendForApprove(true);
          } else {
            this.dialogRef.close(response);
          }
        },
        error => {
          console.error('Error updating voucher:', error);
        }
      );
    } else {
      this.apiService.createVoucherPosting(postData).subscribe(
        response => {
          console.log('Voucher Posting successfully:');
          this.dialogRef.close(response);
        },
        error => {
          console.error('Error posting voucher:', error);
        }
      );
    }
  }

  affectQty(event: any) {
    if (event == 1) {
      this.is_affect_qty = false;
    } else {
      this.is_affect_qty = true;
    }
  }
onLedgerOpen(opened: boolean) {
  if (!opened) return;
  this.hasMore = true;
  this.rounded_ledger_data = [];
  this.fetchProfitCostLedger(this.profitCostId, true);
  Promise.resolve().then(() => {
    const panel = this.ledgerSelect.panel?.nativeElement;
    if (!panel) {
      console.error('mat-select panel not found');
      return;
    }
    panel.removeEventListener('scroll', this.onLedgerScroll);
    panel.addEventListener('scroll', this.onLedgerScroll);
  });
}


filterLedger(event: any) {
  this.currentSearch = event.target.value;
  this.hasMore = true;
  this.rounded_ledger_data = [];
  this.fetchProfitCostLedger(this.profitCostId, true);
}
onLedgerScroll = (event: any) => {
  const panel = event.target;
  console.log(
    'scrolling:',
    panel.scrollTop,
    panel.clientHeight,
    panel.scrollHeight
  );

  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 10 &&
    this.hasMore &&
    !this.loading
  ) {
    this.fetchProfitCostLedger(this.profitCostId);
  }
};

  sendForApprove(skipSave: boolean = false) {
    if (!skipSave && this.data.id) {
      if (this.showPurches && this.voucher_type !== 'Inventory Voucher') {
        this.detail(true);
      } else if (this.voucher_type === 'Inventory Voucher') {
        this.SaveInventory(true);
      } else if (this.voucher_type === 'Credit Note') {
        this.saveCreditNote(true);
      } else if (this.voucher_type === 'Debit Note') {
        this.saveDebitNote(true);
      } else {
        this.onSave(true);
      }
      return;
    }

    console.log(this.data);
    let document_type = '';
    if(this.invoice_type == 'purchase'){
      document_type = 'Purchase Voucher';
    } else if(this.invoice_type == 'sales'){
      document_type = 'Salesvoucher';
    } else if(this.invoice_type == 'debit note'){
      document_type = 'Debit Note';
    } else if(this.invoice_type == 'credit note'){
      document_type = 'Credit Note';
    }else{
      document_type = 'CreationVoucher';
    }
    const requestData = {
      document_type: document_type,
      document_id: this.data.id,
      // profit_cost_id: this.profit_cost_id,
    };

    this.apiService.sendForApproval(requestData).subscribe(
      (approvalResponse) => {
        console.log('Voucher posting sent for approval:', approvalResponse);
        alert('Document sent for approval');
        this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
      },
      (approvalError) => {
        console.error('Error sending voucher posting for approval:', approvalError);
        alert('Error sending voucher posting for approval: ' + (approvalError.error?.message || approvalError.message || 'Unknown error'));
      }
    );
  }

  showApprovalTimeline() {

    let document_type = '';
    if(this.invoice_type == 'purchase'){
      document_type = 'Purchase Voucher';
    } else if(this.invoice_type == 'sales'){
      document_type = 'Salesvoucher';
    } else if(this.invoice_type == 'debit note'){
      document_type = 'Debit Note';
    } else if(this.invoice_type == 'credit note'){
      document_type = 'Credit Note';
    }else{
      document_type = 'CreationVoucher';
    }
    
    const requestData = {
      document_type: document_type,
      document_id: this.data.id,
      // profit_cost_id: this.profit_cost_id,
    };

    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        console.log('Approval timeline data:', response);
        
        // Open approval timeline dialog with real data
        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      },
      (error) => {
        console.error('Error fetching approval timeline:', error);
        
        // Fallback to demo data if API fails
        const demoApprovalData: ApprovalTimelineData = {
          document_id: this.data.id || 12345,
          document_type: document_type,
          current_stage: 2,
          total_stages: 4,
          overall_status: 'pending',
          created_at: new Date().toISOString(),
          created_by: 'Current User',
          stages: [
            {
              id: 1,
              name: 'Department Head Review',
              level: 1,
              status: 'approved',
              approver_name: 'Sarah Johnson',
              approved_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
              comments: 'All requirements met, approved for next level',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 2,
              name: 'Finance Manager Review',
              level: 2,
              status: 'pending',
              is_current: true,
              timeline: [],
              pending_time_seconds: 7200,
              pending_time_formatted: '2h 0m 0s',
              cancellation_count: 0
            },
            {
              id: 3,
              name: 'General Manager Approval',
              level: 3,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 4,
              name: 'Final Approval',
              level: 4,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            }
          ]
        };

        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: demoApprovalData }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      }
    );
  }
  vendorbranchledger(vendor_branch_id, branch_id) {
    const postData = {
      vendor_branch_id: vendor_branch_id,
      branch_id: branch_id
    };
    this.apiService.getVendorBranchLedger(postData).subscribe(
      (response) => {
        this.vendorBranchLedger = response;
        console.log('vendor branch ledgers', this.vendorBranchLedger);
        this.vendor_branch_ledger_id = this.vendorBranchLedger[0].ledger_id;
        this.vendor_branch_ledger_name = this.vendorBranchLedger[0].ledger.ledger_name;
        console.log('vendor branch ledger', this.vendor_branch_ledger_id);
        console.log('vendor branch ledger name ', this.vendor_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }
  customerbranchledger(customer_branch_id, branch_id) {
    const postData = {
      customer_branch_id: customer_branch_id,
      branch_id: branch_id
    };
    this.apiService.getCustomerBranchLedger(postData).subscribe(
      (response) => {
        this.customerBranchLedger = response;
        console.log('customer branch ledgerss', this.customerBranchLedger);
        this.cutomer_branch_ledger_id = this.customerBranchLedger[0].ledger_id;
        this.cutomer_branch_ledger_name = this.customerBranchLedger[0].ledger.ledger_name;
        console.log('customer branch ledger', this.cutomer_branch_ledger_id);
        console.log('customer branch ledger name ', this.cutomer_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }

  resetFields(excludedFields: string[] = []) {
    const defaultValues: any = {
      branch: null,
      profit_cost_id: null,
      voucherType: null,
      selectedSections: [],
      vendor: null,
      selectedVendorBranch: null,
      selectedPiSection: null,
      selectedGrn: [],
      customer: null,
      selectedCustomerBranch: null,
      selectedSection: null,
      selectedGsn: [],
      productList: [],
    };

    for (const key in defaultValues) {
      if (!excludedFields.includes(key)) {
        (this as any)[key] = defaultValues[key];
      }
    }
  }
  editHsnGst(productList: any[]) {
    const dialogRef = this.dialog.open(HsnGstEditComponent, {
      width: '1000px',
      height: '600px',
      data: {
        productList: productList,
        taxOptions: this.tax
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('result', result);
        this.productList = result;
      }
    });
  }
 
  showdesigns() {
    const component = this.VoucherComponents[this.voucher_type];
    console.log('component', component);
    console.log(this.voucher_type, "voucher_type");
    console.log(this.voucherType, "voucherType");
    if (!component || this.designDialogOpened) {
      return;
    }
    this.designDialogOpened = true;
    this.redirectToDesignDialog = true;

    const dialogData = {
      operationType: this.data.operationType || 'create',
      type: this.data.type || this.data.operationType || 'create',
      voucherType: this.voucherType || this.data.voucherType,
      voucherName: this.voucher_type,
      id: this.data.id,
      approval_status: this.data.approval_status ?? this.approval_status ?? null,
      showPostButton: this.data.showPostButton ?? this.showPostButton ?? false,
    };

    // Open the design dialog only after this posting dialog has fully closed,
    // so leftover async/ngModelChange work cannot call showdesigns again.
    // Open the design dialog only after this posting dialog has fully closed,
    // so leftover async/ngModelChange work cannot call showdesigns again.
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialog.open(component, {
        ...UI_DOCUMENT_PANEL_DIALOG_CONFIG,
        data: dialogData,
      });
    });
    // Signal callers that this close is only a hand-off to Purchase/Sales/etc.
    this.dialogRef.close({ redirected: true });
  }
 // }
}
